import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { KPITablesPopupComponent } from 'src/app/shared/popups/kpitables-popup/kpitables-popup.component';
import { EditKPIPopupComponent } from 'src/app/shared/popups/edit-kpipopup/edit-kpipopup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboardDetailsPopupComponent } from 'src/app/shared/popups/dashboard-details-popup/dashboard-details-popup.component';
import * as echarts from 'echarts';
import { PmsSystemUnlockPopupComponent } from 'src/app/shared/popups/pms-system-unlock-popup/pms-system-unlock-popup.component';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { MisAttachmentViewComponent } from 'src/app/shared/popups/mis-attachment-view/mis-attachment-view.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@Component({
  selector: 'app-pms',
  templateUrl: './pms.component.html',
  styleUrls: ['./pms.component.scss']
})
export class PmsComponent implements OnInit {
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard';
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showSystemUnlockPopup: boolean = false;
  currentDate: any = new Date();
  toDate: any = null;
  fromDate: any = null;
  pmsSetupInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  scoreRangeArray: any = [
    {
      companyId: null,
      id: null,
      maxRange: null,
      minRange: null,
      normalizeScore: null,
      pmsSetupId: null
    }
  ];
  scoreRangeArrayForAdd: any = [];
  loggedInCompanyFiscalyear: any;
  companyHODList: any = [];
  numbersOfDaysArray = Array.from({ length: 30 }, (_, i) => i + 1);
  numbersOfDaysForGracePeriod: any = [];
  columnHeaderVisiableData: any = [];
  columnHeaderAllData: any = [];
  columnHeaderHideShowAllData = [
    {
      fieldId: 1,
      isVisible: true,
      fieldName: 'Review Status',
      position: 1,
      isEditable: true
    },
    {
      fieldId: 2,
      isVisible: true,
      fieldName: 'KRA',
      position: 2,
      isEditable: true
    },
    {
      fieldId: 3,
      isVisible: true,
      fieldName: 'KPI',
      position: 3,
      isEditable: true
    },
    {
      fieldId: 4,
      isVisible: false,
      fieldName: 'Review Cycle',
      position: 4,
      isEditable: true
    },
    {
      fieldId: 5,
      isVisible: false,
      fieldName: 'Lesser is Better',
      position: 5,
      isEditable: true
    },
    {
      fieldId: 6,
      isVisible: false,
      fieldName: 'Milestone From',
      position: 6,
      isEditable: true
    },
    {
      fieldId: 7,
      isVisible: false,
      fieldName: 'Milestone To',
      position: 7,
      isEditable: true
    },
    {
      fieldId: 8,
      isVisible: true,
      fieldName: 'Weightage',
      position: 8,
      isEditable: true
    },
    {
      fieldId: 9,
      isVisible: true,
      fieldName: 'UOM',
      position: 9,
      isEditable: true
    },
    {
      fieldId: 10,
      isVisible: true,
      fieldName: 'Target',
      position: 10,
      isEditable: true
    },
    {
      fieldId: 11,
      isVisible: true,
      fieldName: 'Actual',
      position: 11,
      isEditable: true
    },
    {
      fieldId: 12,
      isVisible: true,
      fieldName: '% Achievement',
      position: 12,
      isEditable: true
    },
    {
      fieldId: 13,
      isVisible: true,
      fieldName: 'KPI Score',
      position: 13,
      isEditable: true
    },
    {
      fieldId: 14,
      isVisible: false,
      fieldName: 'Employee Comment',
      position: 14,
      isEditable: true
    },
    {
      fieldId: 15,
      isVisible: false,
      fieldName: 'Manager Comment',
      position: 15,
      isEditable: true
    },
    {
      fieldId: 16,
      isVisible: false,
      fieldName: 'MIS Attachment',
      position: 16,
      isEditable: true
    },
    {
      fieldId: 17,
      isVisible: false,
      fieldName: 'Dotted Manager Comment',
      position: 17,
      isEditable: true
    }
  ];
  editPMSSetUp: boolean = false;
  addedScores: any = [];
  kpiDataListByUser: any = [];
  loggedInUserId: any;
  teamOfManagerList: any = [];
  selectedUserForKPISearch: any;
  selectedSizeOfPMS: any = 100;
  getAllkpiIDsList: any = [];
  goalApprovalStatus: boolean = false;
  goalReviewStatus: boolean = false;
  allReviewAreApproved: boolean = false;
  selectedKPIList: any = [];
  loggedInUserRole: any;
  totalWeightage: any = 0;
  totalKpiScore: any = 0;
  selectAllCheckbox: boolean = false;
  searchKpiString: any = null;
  totalPagesOfKpi: any = 0;
  totalKpis: any = 0;
  currentPageNumberOfKpis: any = 1;
  page: any = 0;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  selectedYear: any = null;
  pmsYears: any = [];
  getMonthsByFiscalandReviewCycle: any = [];
  getToMonthsByFiscalandReviewCycle: any = [];
  fromYear: any = null;
  toYear: any = null;
  loggedInCompanyReviewCycle: any = null;
  deptListOfCompany: any;
  selectedDeptForKPISearch: any = [];
  goalSettingAtAllLevels: boolean = false;
  selectedYearReviewCycle: any;
  activeCustomReportBtn: boolean = false;
  isAllEmpForReportToggle: boolean = true;
  selectedGoalForEmp: any = 'My Goals';
  selectedUserForKPIReport: any;
  activeReportBtnName: any = 'Scorecard';
  reportBtn = [
    {
      isActive: true,
      btnName: 'Scorecard'
    },
    {
      isActive: false,
      btnName: 'All Employee -Month-YTD'
    },
    {
      isActive: false,
      btnName: 'KPI wise YTD'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Report'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Summary'
    },
    {
      isActive: false,
      btnName: 'Custom Report'
    }
  ];
  isAnyColumnInvisible: boolean = false;
  isAllReviewStatusNotApproved: boolean = false;
  monthsForScoreCardReport: any = [];
  employeesScoreCardReportData: any = [];
  selectedReviewCycle: any[] = [];
  searchKpiReportString: any = null;
  customReportData: any = [];
  selectedSummaryTypeForReport: any = null;
  selectedDepartmentForReport: any = [];
  allColumnsInvisible: boolean = false;
  selectedDepartmentsForReport: any = [];
  employeeListByDept: any = [];
  isKPIInPendingState: any;
  isKPIInRejectedState: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  isCuttofDateApplicable: boolean = false;
  isSelectedYearIsSameYeartoCurrentYear: any;
  reviewCycleDisabled: boolean = false;
  isRevokeEnable: boolean = false;
  goalSubmitReviewStatus: boolean = false;
  goalApproveReviewStatus: boolean = false;
  goalSettingStatus: boolean = false;
  selectedCutOffValue: any;
  selectedCapType: any;
  dashboardCounterModule = [
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Active Employees',
      totalCount: 0,
      color: '#3067FA',
      background: '#D4DBEB'
    },
    {
      moduleActiveIcon: '././assets/icon/goalSetting.svg',
      ModuleName: 'Goal Setting Status',
      totalCount: 0,
      color: '#F3820E',
      background: '#FFE3C3'
    },
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'Goal Review Status',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD'
    },
    {
      moduleActiveIcon: '././assets/icon/managerApprove.svg',
      ModuleName: 'Manager Approval Status',
      totalCount: 0,
      color: '#2D82D7',
      background: '#CEDEEE'
    },
    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'Exited Employees',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE'
    },
    {
      moduleActiveIcon: '././assets/icon/settingStatus.svg',
      ModuleName: 'My Goal Setting Status',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB'
    },
    {
      moduleActiveIcon: '././assets/icon/reviewStatus.svg',
      ModuleName: 'My Goal Review Status',
      totalCount: 0,
      color: '#5C4CD3',
      background: '#D9D7EB'
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'My Approved Status',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB'
    }
  ];
  getYtdReportForTable: any = [];
  quarterlyBarChartData: any = [];
  selectedYearForCompanyScoreTrend: any;
  showMangerTable: boolean = true;
  companyScoreData: any = [];
  companyScoreMonths: any = [];
  employeeData: any = [];
  managerData: any = [];
  kpiScoreData: any = [];
  chartKpiSummary: echarts.ECharts | undefined;
  chartQuaterlyYtdScore: echarts.ECharts | undefined;
  chartTargetvsActual: echarts.ECharts | undefined;
  chartTopPerfomanceOfKpi: echarts.ECharts | undefined;
  chartBottomPerfomanceOfKpi: echarts.ECharts | undefined;
  lastThreeYearKpiScore: echarts.ECharts | undefined;
  chartOptionsKpiSummary: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  chartOptionsQuaterlyYtdScore: any = {
    line: {},
    bar: {}
  };
  chartOptionsTargetvsActual: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  chartOptionsTopPerfomanceOfKpi: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  chartOptionsBottomPerfomanceOfKpi: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  chartOptionslastThreeYearKpiScore: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  dashboardColorName: any;
  fisrtDashboardColor: any = '#F6921E';
  secondDashboardColor: any = '#393186';
  loggedInUserisDottedManager: boolean = false;
  isAllMonthTotalWtHundred: boolean = false;
  pmsYearsForUnlockStatus: any = [];
  selectedYearForUnlockStatus: any;
  userIsAdmin: boolean = false;
  unLockIsOn: boolean = true;
  loggedInUserIsMD: boolean = false;
  greaterThan100WtMonths: any = [];
  lessThan100WtMonths: any = [];
  loggedInCompanyMDID: any = null;
  loggedInMDID: any;
  selectedUserForTopTenKpi: any;
  constructor(
    public sharedService: SharedService,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private activatedroute: ActivatedRoute,
    public toastr: ToastrService,
    private pdfDownload: DownloadAsPdfService,
    public mobileResponsiveService: MobileResponsiveService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.dashboardColorName = sessionStorage.getItem('dashboardColorName');
    this.dashboardColorName = this.dashboardColorName?.split(',');
    if (this.dashboardColorName.length != 0) {
      this.fisrtDashboardColor = this.dashboardColorName[0];
    }
    if (this.dashboardColorName.length > 1) {
      this.secondDashboardColor = this.dashboardColorName[1];
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    if (sessionStorage.getItem('loggedInCompanyMDID')) {
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    if (sessionStorage.getItem('loggedInCompanyMDID')) {
      this.loggedInMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (sessionStorage.getItem('loggedInUserIsMD') == 'true') {
      this.loggedInUserIsMD = true;
    } else {
      this.loggedInUserIsMD = false;
    }

    if (sessionStorage.getItem('isDottedManager') == 'true') {
      this.loggedInUserisDottedManager = true;
    }
    this.initilaizePMSSetupForm();
    if (this.loggedInCompanyReviewCycle == null) {
      this.updateYearControl(this.loggedInCompanyFiscalyear);
    }
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }
  ionViewWillEnter() {
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
      this.userIsAdmin = true;
    } else {
      this.userIsAdmin = false;
    }
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
          this.showSetupPopup = true;
          this.showSystemUnlockPopup = false;
          this.updateYearControl(this.loggedInCompanyFiscalyear);
          this.getpmsyearlist();
        }
      } else if (params?.operation == 'unlocksystem') {
        this.showSystemUnlockPopup = true;
        this.showSetupPopup = false;
        this.getPMSYearForUnlock();
      } else {
        this.selectedTypeTabIndex = params?.tabIndex;
        // this.selectedTypeTabName = params?.tabName;
        this.updateYearControl(this.loggedInCompanyFiscalyear);
        this.getPmsYears();
        // this.getColumnVisibility();
        this.getListOfEmployee();
      }
    });
  }
  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/pms', { operation: operation }]);
  }
  onClickBreadcrumPMS() {
    this.router.navigate(['/home/hrportal/pms']);
  }
  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    // this.sharedService.removeSubMenuPreviousActiveTabClass();
    // this.sharedService.changeSubMenuBackgroundColor();
    // if (this.selectedTypeTabName == 'Dashboard') {
    //   this.router.navigate(['/home/hrportal/pms/dashboard',{tabIndex: this.selectedTypeTabIndex}]);
    // }
    this.selectedKPIList = [];
    if (this.selectedTypeTabName == 'My Goals') {
      this.getDashboardCount();
    }
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
      this.getPmsUnlockSetupForUser();
      this.getKPIsByDateRange();
    }
    if (this.selectedTypeTabName == 'Team Goals' || this.selectedTypeTabName == 'Dept KPIs' || this.selectedTypeTabName == 'Dotted Goals') {
      this.selectedUserForKPISearch = null;
      this.getListOfEmployee();
      this.getKPIsByDateRange();
    }
    if (this.selectedTypeTabName == 'Employee Goals') {
      this.selectedUserForKPISearch = null;
      if (this.loggedInUserRole == 'Admin') {
        this.getDeptsOfAdminByDate();
      } else {
        this.getDepartmentList();
      }
    }
    if (this.selectedTypeTabName == 'Reports') {
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
        this.selectedUserForKPISearch = null;
        if (this.loggedInUserRole == 'Admin') {
          this.getDeptsOfAdminByDate();
        } else {
          this.getDepartmentList();
        }
        this.selectedSummaryTypeForReport = 'Company Summary';
      } else {
        this.selectedSummaryTypeForReport = null;
        this.submiForReportPreview();
      }
      this.reportColumnHeaderInfo();
    }
    if (this.selectedTypeTabName == 'Dashboard') {
      if (this.loggedInUserRole == 'Admin') {
        this.getEmpsOfAdminByDateByDeptEmpty();
      } else {
        this.getTargetVsActualUsersList();
        this.getTopPerformingKpiData();
        this.getBottomPerformingKpiData();
        this.getTopTenKpis();
        this.compnayScoreCard();
        this.getYtdVsScore();
        this.getKpiGoalSummary();
        this.lastThreeYearKpiScoreGraph();
      }
    }
  }
  showKPISPopup(data: any) {
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      buttonName: data,
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserForKPISearch,
      fromYear: this.fromYear,
      toYear: this.toYear,
      fromMonth: this.fromDate,
      toMonth: this.toDate
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(KPITablesPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getKPIsByDateRange();
    });
  }
  getListOfEmployee() {
    this.teamOfManagerList = [];
    console.log(this.loggedInUserId);
    if (this.selectedTypeTabName == 'Team Goals') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        from: this.fromDate,
        fromYear: this.fromYear,
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        userType: null,
        loggedInUserRole: this.loggedInUserRole
      };

      console.log(request);

      this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
        if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
          this.selectedUserForKPISearch = this.teamOfManagerList[0].id;
          this.getKPIsByDateRange();
        }
      });
    }
    if (this.selectedTypeTabName == 'Dept KPIs') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        from: this.fromDate,
        fromYear: this.fromYear,
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        userType: null
      };
      this.httpService.callPostService(this.config.getDeptEmployeesByDate, request).subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    }
    if (this.selectedTypeTabName == 'Dotted Goals') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        from: this.fromDate,
        fromYear: this.fromYear,
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        userType: null
      };
      this.httpService.callPostService(this.config.getEmpsOfDottedManagerByDate, request).subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    }
    if (this.selectedTypeTabName == 'Employee Goals') {
      this.getAllEmployeesByDept();
    }
  }
  initilaizePMSSetupForm() {
    this.pmsSetupInformationForm = this.fb.group({
      addScores: this.fb.array(this.scoreRangeArray.map((scoreRange: any) => this.createScoresRange(scoreRange))),
      capSelect: [''],
      capValue: [false, Validators.required],
      cftValue: [false, Validators.required],
      comment: [null, this.minimumValueValidator(0)],
      companyId: [this.loggedInUserCompanyID, Validators.required],
      cutoffDate: [null, Validators.required],
      cutoffDateApplicable: [false, Validators.required],
      fiscalYear: [this.loggedInCompanyFiscalyear, Validators.required],
      fromYear: [null],
      goalSettingAtllLevels: [false],
      gracePeriod: [null, Validators.required],
      id: [null],
      reviewCycle: ['', Validators.required],
      toYear: [null],
      valueSelect: ['', Validators.required],
      year: [null]
    });
  }
  createScoresRange(ScoresRange: any): FormGroup {
    return this.fb.group({
      companyId: [this.loggedInUserCompanyID, Validators.required],
      id: [ScoresRange.id],
      maxRange: [ScoresRange.maxRange],
      minRange: [ScoresRange.minRange],
      normalizeScore: [ScoresRange.normalizeScore],
      pmsSetupId: [ScoresRange.pmsSetupId]
    });
  }
  get addScoresRange(): FormArray {
    return this.pmsSetupInformationForm.get('addScores') as FormArray;
  }
  addMoreScoresRange(): void {
    this.addScoresRange.push(
      this.createScoresRange({
        companyId: this.loggedInUserCompanyID,
        id: null,
        maxRange: null,
        minRange: null,
        normalizeScore: null,
        pmsSetupId: null
      })
    );
  }
  addMoreScoreRange() {
    var maxRange = 0;
    if (this.addedScores?.length == 0) {
      maxRange = 0;
    } else {
      for (let i = 0; i < this.addedScores?.length; i++) {
        maxRange = this.addedScores[i].maxRange;
      }
    }
    this.scoreRangeArrayForAdd.push({
      companyId: this.loggedInUserCompanyID,
      id: null,
      maxRange: null,
      minRange: maxRange,
      normalizeScore: null,
      pmsSetupId: null
    });
  }
  createScoresRangeForOnce(ScoresRange: any): FormGroup {
    return this.fb.group({
      companyId: [this.loggedInUserCompanyID, Validators.required],
      id: [ScoresRange[0]?.id],
      maxRange: [ScoresRange[0]?.maxRange],
      minRange: [ScoresRange[0]?.minRange],
      normalizeScore: [ScoresRange[0]?.normalizeScore],
      pmsSetupId: [ScoresRange[0]?.pmsSetupId]
    });
  }
  errorMsgForRange: boolean = false;
  saveAddedScoreRange() {
    if (this.scoreRangeArrayForAdd[0].maxRange != null && this.scoreRangeArrayForAdd[0].normalizeScore != null) {
      if (!this.isInValidMaxRange && !this.isInValidNormalizScore) {
        this.errorMsgForRange = false;
        this.addScoresRange.push(this.createScoresRangeForOnce(this.scoreRangeArrayForAdd));
        this.addedScores.push(this.scoreRangeArrayForAdd[0]);
        this.scoreRangeArrayForAdd = [];
      }
    } else {
      this.errorMsgForRange = true;
    }
  }
  removecreateScoresRange() {
    this.errorMsgForRange = false;
    this.isInValidMaxRange = false;
    this.isInValidNormalizScore = false;
    this.scoreRangeArrayForAdd = [];
  }
  editIndexofCapRange: any;
  editRange(index: any, data: any) {
    this.editIndexofCapRange = index;
  }
  closeEditRange(index: any) {
    this.editIndexofCapRange = null;
  }
  deleteRange(index: any) {
    this.addScoresRange.removeAt(index);
    this.addedScores.splice(index, 1);
  }
  deleteAllRange() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to delete all ranges?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
        addScores.clear();
        this.addedScores = [];
      }
    });
  }
  editedRangeSave(index: any) {
    if (this.addedScores[index].maxRange != null && this.addedScores[index].normalizeScore != null) {
      const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
      addScores.clear();
      for (let i = 0; i < this.addedScores?.length; i++) {
        this.addMoreScoresRange();
      }
      this.pmsSetupInformationForm.controls['addScores'].setValue(this.addedScores);
      this.editIndexofCapRange = null;
    }
  }
  getColumnVisibility() {
    // this.httpService.callGetService(this.config.getColumnVisibility).subscribe((data: any) => {
    this.columnHeaderHideShowAllData = this.columnHeaderHideShowAllData?.sort((a: any, b: any) => a.position - b.position);
    this.columnHeaderHideShowAllData?.forEach((ele: any) => {
      if (ele.fieldName == 'Review Cycle') {
        ele.fieldName = this.sharedService.transform(this.selectedYearReviewCycle);
      }
      if (ele.fieldName == 'Review Status') {
        ele.isEditable = false;
      } else if (ele.fieldName == '% Achievement') {
        ele.isEditable = false;
      } else if (ele.fieldName == 'KPI Score') {
        ele.isEditable = false;
      } else {
        ele.isEditable = true;
      }
    });
    this.isAnyColumnInvisible = this.columnHeaderHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.columnHeaderHideShowAllData?.every((ele: any) => !ele.isVisible);
    if (this.allColumnsInvisible) {
      for (let i = 0; i < this.kpiDataListByUser.length; i++) {
        this.kpiDataListByUser[i].checkboxCheck = false;
      }
      this.selectAllCheckbox = false;
      this.selectedKPIList = [];
    }
    // })
  }
  onSelectHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.columnHeaderHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.columnHeaderHideShowAllData?.every((ele: any) => !ele.isVisible);
  }
  updateColumnVisibility(data: any, index: any) {
    this.columnHeaderHideShowAllData[index].isVisible = false;
    this.getColumnVisibility();
    // var requestArray: { columnId: any; visible: boolean; }[] = []
    // requestArray?.push({ columnId: data?.fieldId, visible: false })
    // this.httpService.callPostService(this.config.updateColumnVisibility, requestArray).subscribe((data: any) => {
    //   this.getColumnVisibility();
    // })
  }
  onClickShowAllHeader() {
    this.columnHeaderHideShowAllData?.forEach((ele: any, ind: any) => {
      this.columnHeaderHideShowAllData[ind].isVisible = true;
    });
    this.getColumnVisibility();
    // var requestArray: { columnId: any; visible: boolean; }[] = []
    // this.columnHeaderHideShowAllData?.forEach((ele: any) => {
    //   requestArray.push({ columnId: ele?.fieldId, visible: true });
    // });
    // this.httpService.callPostService(this.config.updateColumnVisibility, requestArray).subscribe((data: any) => {
    //   this.getColumnVisibility();
    // })
  }
  onMenuClose() {
    // Optional: Handle any cleanup when the menu is closed
  }
  onClickHideShowColumnHeader(menu: any) {
    // var requestArray: { columnId: any; visible: boolean; }[] = []
    // this.columnHeaderHideShowAllData?.forEach((ele: any) => {
    //   requestArray.push({ columnId: ele?.fieldId, visible: ele.isVisible });
    // });
    // this.httpService.callPostService(this.config.updateColumnVisibility, requestArray).subscribe((data: any) => {
    //   this.getColumnVisibility();
    //   menu.closeMenu();
    // })
  }
  updateYearControl(fiscalYear: string): void {
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    let yearValue = '';
    if (fiscalYear === 'Jan_Dec') {
      yearValue = `${currentYear}-${currentYear}`;
      this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
      this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
      this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
    } else {
      if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
        if (currentMonth < 3) {
          yearValue = `${currentYear - 1}-${currentYear}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        }
      }
      if (this.loggedInCompanyFiscalyear === 'July_Jun') {
        if (currentMonth < 6) {
          yearValue = `${currentYear - 1}-${currentYear}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        }
      }
      if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
        if (currentMonth < 9) {
          yearValue = `${currentYear - 1}-${currentYear}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        }
      }
    }
    this.getPMSSetUpByID();
  }
  onSelectYearForPMSSetup() {
    var year = this.pmsSetupInformationForm.value.year?.split('-');
    this.pmsSetupInformationForm.controls['fromYear'].setValue(year[0]);
    this.pmsSetupInformationForm.controls['toYear'].setValue(year[1]);
    this.getPMSSetUpByID();
  }

  onSavePMSSetup() {
    var flag = true;
    this.pmsSetupInformationForm.markAllAsTouched();
    if (this.pmsSetupInformationForm.value.cutoffDateApplicable == true) {
      this.pmsSetupInformationForm.controls['cutoffDate'].setValidators([Validators.required]);
      this.pmsSetupInformationForm.controls['gracePeriod'].setValidators([Validators.required]);
    } else {
      this.pmsSetupInformationForm.controls['cutoffDate'].clearValidators();
      this.pmsSetupInformationForm.controls['gracePeriod'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capValue == true) {
      this.pmsSetupInformationForm.controls['valueSelect'].setValidators([Validators.required]);
    } else {
      const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
      addScores.clear();
      this.pmsSetupInformationForm.controls['valueSelect'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capSelect == 'Straight') {
      this.pmsSetupInformationForm.controls['comment'].setValidators([Validators.required, this.minimumValueValidator(0)]);
    } else {
      this.pmsSetupInformationForm.controls['comment'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capSelect == 'Range') {
      if (this.pmsSetupInformationForm.controls['addScores'].value?.length == 0) {
        flag = false;
      }
    }
    this.pmsSetupInformationForm.controls['cutoffDate'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['valueSelect'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['comment'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['gracePeriod'].updateValueAndValidity();

    if (this.pmsSetupInformationForm.valid && flag) {
      var request = {};
      if (this.pmsSetupInformationForm.value.capValue == true) {
        request = {
          addScores: this.pmsSetupInformationForm.value.addScores,
          capSelect: this.pmsSetupInformationForm.value.capSelect,
          capValue: this.pmsSetupInformationForm.value.capValue,
          cftValue: this.pmsSetupInformationForm.value.cftValue,
          comment: this.pmsSetupInformationForm.value.comment,
          companyId: this.pmsSetupInformationForm.value.companyId,
          cutoffDate: this.pmsSetupInformationForm.value.cutoffDate,
          cutoffDateApplicable: this.pmsSetupInformationForm.value.cutoffDateApplicable,
          fiscalYear: this.pmsSetupInformationForm.value.fiscalYear,
          fromYear: this.pmsSetupInformationForm.value.fromYear,
          goalSettingAtllLevels: this.pmsSetupInformationForm.value.goalSettingAtllLevels,
          gracePeriod: this.pmsSetupInformationForm.value.gracePeriod,
          id: this.pmsSetupInformationForm.value.id,
          reviewCycle: this.pmsSetupInformationForm.value.reviewCycle,
          toYear: this.pmsSetupInformationForm.value.toYear,
          valueSelect: this.pmsSetupInformationForm.value.valueSelect
        };
      } else {
        request = {
          addScores: this.pmsSetupInformationForm.value.addScores,
          capValue: this.pmsSetupInformationForm.value.capValue,
          cftValue: this.pmsSetupInformationForm.value.cftValue,
          comment: this.pmsSetupInformationForm.value.comment,
          companyId: this.pmsSetupInformationForm.value.companyId,
          cutoffDate: this.pmsSetupInformationForm.value.cutoffDate,
          cutoffDateApplicable: this.pmsSetupInformationForm.value.cutoffDateApplicable,
          fiscalYear: this.pmsSetupInformationForm.value.fiscalYear,
          fromYear: this.pmsSetupInformationForm.value.fromYear,
          goalSettingAtllLevels: this.pmsSetupInformationForm.value.goalSettingAtllLevels,
          gracePeriod: this.pmsSetupInformationForm.value.gracePeriod,
          id: this.pmsSetupInformationForm.value.id,
          reviewCycle: this.pmsSetupInformationForm.value.reviewCycle,
          toYear: this.pmsSetupInformationForm.value.toYear
        };
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.addPMSSetup, request).subscribe((data: any) => {
        this.loader.dismissLoader();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.onClickBreadcrumPMS();
        });
      });
    }
  }
  updatePMSSetup() {
    var flag = true;
    this.pmsSetupInformationForm.markAllAsTouched();
    if (this.pmsSetupInformationForm.value.cutoffDateApplicable == true) {
      this.pmsSetupInformationForm.controls['cutoffDate'].setValidators([Validators.required]);
      this.pmsSetupInformationForm.controls['gracePeriod'].setValidators([Validators.required]);
    } else {
      this.pmsSetupInformationForm.controls['cutoffDate'].clearValidators();
      this.pmsSetupInformationForm.controls['gracePeriod'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capValue == true) {
      this.pmsSetupInformationForm.controls['valueSelect'].setValidators([Validators.required]);
    } else {
      this.pmsSetupInformationForm.controls['capSelect'].setValue('');
      this.pmsSetupInformationForm.controls['valueSelect'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capSelect == 'Straight') {
      this.pmsSetupInformationForm.controls['comment'].setValidators([Validators.required, this.minimumValueValidator(0)]);
    } else {
      this.pmsSetupInformationForm.controls['comment'].clearValidators();
    }
    if (this.pmsSetupInformationForm.value.capSelect == 'Range') {
      if (this.pmsSetupInformationForm.controls['addScores'].value?.length == 0) {
        flag = false;
      }
    }
    this.pmsSetupInformationForm.controls['cutoffDate'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['valueSelect'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['comment'].updateValueAndValidity();
    this.pmsSetupInformationForm.controls['gracePeriod'].updateValueAndValidity();

    if (this.pmsSetupInformationForm.valid && flag) {
      var request = {};
      if (this.pmsSetupInformationForm.value.capValue == true) {
        request = {
          addScores: this.pmsSetupInformationForm.value.addScores,
          capSelect: this.pmsSetupInformationForm.value.capSelect,
          capValue: this.pmsSetupInformationForm.value.capValue,
          cftValue: this.pmsSetupInformationForm.value.cftValue,
          comment: this.pmsSetupInformationForm.value.comment,
          companyId: this.pmsSetupInformationForm.value.companyId,
          cutoffDate: this.pmsSetupInformationForm.value.cutoffDate,
          cutoffDateApplicable: this.pmsSetupInformationForm.value.cutoffDateApplicable,
          fiscalYear: this.pmsSetupInformationForm.value.fiscalYear,
          fromYear: this.pmsSetupInformationForm.value.fromYear,
          goalSettingAtllLevels: this.pmsSetupInformationForm.value.goalSettingAtllLevels,
          gracePeriod: this.pmsSetupInformationForm.value.gracePeriod,
          id: this.pmsSetupInformationForm.value.id,
          reviewCycle: this.pmsSetupInformationForm.value.reviewCycle,
          toYear: this.pmsSetupInformationForm.value.toYear,
          valueSelect: this.pmsSetupInformationForm.value.valueSelect
        };
      } else {
        request = {
          addScores: this.pmsSetupInformationForm.value.addScores,
          capValue: this.pmsSetupInformationForm.value.capValue,
          cftValue: this.pmsSetupInformationForm.value.cftValue,
          comment: this.pmsSetupInformationForm.value.comment,
          companyId: this.pmsSetupInformationForm.value.companyId,
          cutoffDate: this.pmsSetupInformationForm.value.cutoffDate,
          cutoffDateApplicable: this.pmsSetupInformationForm.value.cutoffDateApplicable,
          fiscalYear: this.pmsSetupInformationForm.value.fiscalYear,
          fromYear: this.pmsSetupInformationForm.value.fromYear,
          goalSettingAtllLevels: this.pmsSetupInformationForm.value.goalSettingAtllLevels,
          gracePeriod: this.pmsSetupInformationForm.value.gracePeriod,
          id: this.pmsSetupInformationForm.value.id,
          reviewCycle: this.pmsSetupInformationForm.value.reviewCycle,
          toYear: this.pmsSetupInformationForm.value.toYear
        };
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.updatePMSSetup, request).subscribe((data: any) => {
        this.loader.dismissLoader();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.onClickBreadcrumPMS();
        });
      });
    }
  }
  getPMSSetUpByID() {
    this.httpService.callGetService(this.config.getPMSSetUpByID + this.loggedInUserCompanyID + '/' + this.pmsSetupInformationForm.value.fromYear + '/' + this.pmsSetupInformationForm.value.toYear).subscribe((data: any) => {
      const currentYear = new Date().getFullYear();
      if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
        this.isSelectedYearIsSameYeartoCurrentYear = true;
      } else {
        if (Number(this.pmsSetupInformationForm.value.fromYear) >= currentYear || Number(this.pmsSetupInformationForm.value.toYear) >= currentYear) {
          if (this.loggedInCompanyFiscalyear != null) {
            const currentDate = new Date();
            // Get the current month and year
            const currentMonth = currentDate.getMonth(); // 0 for January, 11 for December
            const currentYear = currentDate.getFullYear();

            var endMonth = this.loggedInCompanyFiscalyear?.split('_');
            // Create a Date object for the month you want to check
            const monthToCheck = new Date(this.pmsSetupInformationForm.value.toYear, this.getMonthIndex(this.sharedService.transform(endMonth[1])), 30);
            this.isSelectedYearIsSameYeartoCurrentYear = currentDate < monthToCheck;
          } else {
            this.isSelectedYearIsSameYeartoCurrentYear = false;
          }
          // Compare dates to check if the month has passed
          // this.currentMonthPassed = currentDate > monthToCheck;
        } else {
          this.isSelectedYearIsSameYeartoCurrentYear = false;
        }
      }
      if (data?.data != null) {
        this.editPMSSetUp = true;
        this.goalSettingAtAllLevels = data?.data?.goalSettingAtllLevels;

        if (data?.data?.goalSettingAtllLevels) {
          this.goalSettingAtAllLevels = true;
        } else {
          if (this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
            this.goalSettingAtAllLevels = true;
          } else {
            this.goalSettingAtAllLevels = false;
          }
        }
        const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
        addScores.clear();
        for (let i = 0; i < data?.data?.addScores?.length; i++) {
          this.addMoreScoresRange();
        }

        this.pmsSetupInformationForm.controls['fromYear'].setValue(data?.data?.fromYear);
        this.pmsSetupInformationForm.controls['toYear'].setValue(data?.data?.toYear);
        this.pmsSetupInformationForm.controls['year'].setValue(data?.data?.fromYear + '-' + data?.data?.toYear);
        if (data?.data?.addScores?.length != 0) {
          this.addedScores = data?.data?.addScores?.sort((a: any, b: any) => a.minRange - b.minRange);
          this.pmsSetupInformationForm.controls['addScores'].setValue(data?.data?.addScores?.sort((a: any, b: any) => a.minRange - b.minRange));
        }
        if (data?.data?.cutoffDate != null) {
          this.numbersOfDaysForGracePeriod = Array.from({ length: 31 - data?.data?.cutoffDate }, (_, i) => i);
        }
        this.pmsSetupInformationForm.controls['capSelect'].setValue(data?.data?.capSelect);
        this.pmsSetupInformationForm.controls['capValue'].setValue(data?.data?.capValue);
        this.pmsSetupInformationForm.controls['cftValue'].setValue(data?.data?.cftValue);
        this.pmsSetupInformationForm.controls['comment'].setValue(data?.data?.comment);
        this.pmsSetupInformationForm.controls['companyId'].setValue(data?.data?.companyId);
        this.pmsSetupInformationForm.controls['cutoffDate'].setValue(data?.data?.cutoffDate);
        this.pmsSetupInformationForm.controls['cutoffDateApplicable'].setValue(data?.data?.cutoffDateApplicable);
        this.pmsSetupInformationForm.controls['fiscalYear'].setValue(this.loggedInCompanyFiscalyear);
        this.pmsSetupInformationForm.controls['goalSettingAtllLevels'].setValue(data?.data?.goalSettingAtllLevels);
        this.pmsSetupInformationForm.controls['gracePeriod'].setValue(data?.data?.gracePeriod);
        this.pmsSetupInformationForm.controls['id'].setValue(data?.data?.id);
        this.pmsSetupInformationForm.controls['reviewCycle'].setValue(data?.data?.reviewCycle);
        this.pmsSetupInformationForm.controls['valueSelect'].setValue(data?.data?.valueSelect);
        sessionStorage.setItem('loggedInCompanyReviewCycle', data?.data?.reviewCycle);
        this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle');
        if (data?.data?.reviewCycle != null) {
          if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
            this.reviewCycleDisabled = false;
          } else {
            this.reviewCycleDisabled = true;
          }
        }
        if (this.pmsSetupInformationForm.value.capValue == true) {
          this.selectedCutOffValue = this.sharedService.transform(data?.data?.valueSelect);
          this.selectedCapType = data?.data?.capSelect;
        } else {
          this.selectedCutOffValue = 'NA';
          this.selectedCapType = 'NA';
        }
      } else {
        // this.pmsSetupInformationForm.controls['fromYear'].setValue(null);
        // this.pmsSetupInformationForm.controls['toYear'].setValue(null);
        this.reviewCycleDisabled = false;
        const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
        addScores.clear();
        this.pmsSetupInformationForm.controls['capSelect'].setValue('');
        this.pmsSetupInformationForm.controls['capValue'].setValue(false);
        this.pmsSetupInformationForm.controls['cftValue'].setValue(false);
        this.pmsSetupInformationForm.controls['comment'].setValue(null);
        this.pmsSetupInformationForm.controls['companyId'].setValue(this.loggedInUserCompanyID);
        this.pmsSetupInformationForm.controls['cutoffDate'].setValue(null);
        this.pmsSetupInformationForm.controls['cutoffDateApplicable'].setValue(false);
        this.pmsSetupInformationForm.controls['fiscalYear'].setValue(this.loggedInCompanyFiscalyear);
        this.pmsSetupInformationForm.controls['goalSettingAtllLevels'].setValue(false);
        this.pmsSetupInformationForm.controls['gracePeriod'].setValue(null);
        this.pmsSetupInformationForm.controls['id'].setValue(null);
        this.pmsSetupInformationForm.controls['reviewCycle'].setValue('');
        this.pmsSetupInformationForm.controls['valueSelect'].setValue('');
        this.editPMSSetUp = false;
      }
    });
  }
  onKpiSearch(data: any) {
    var search = '';
    this.searchKpiString = data;
    if (data == '') {
      this.searchKpiString = null;
      this.getKPIsByDateRange();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getKPIsByDateRange();
          }, 500);
        }
      }, 1500);
    }
  }
  onSelectSizeOfKpis() {
    this.getKPIsByDateRange();
  }
  previousPageKpi() {
    if (this.currentPageNumberOfKpis < 2) {
      return;
    } else {
      this.currentPageNumberOfKpis--;
      this.page--;
      this.getKPIsByDateRange();
    }
  }
  nextPageKpi() {
    if (this.currentPageNumberOfKpis >= this.totalPagesOfKpi) {
      return;
    }
    if (this.currentPageNumberOfKpis == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPageNumberOfKpis++;
    this.getKPIsByDateRange();
  }
  combinedData: any = {};
  kpiDataListByUserForTable: any;
  getKPIsByDateRange() {
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    if (this.selectedUserForKPISearch != null) {
      if (this.toDate != null && this.fromDate != null) {
        const request = {
          from: this.fromDate,
          fromYear: this.fromYear,
          search: this.searchKpiString,
          to: this.toDate,
          toYear: this.toYear,
          userId: this.selectedUserForKPISearch
        };
        this.httpService.callPostService(this.config.getKPIsByDateRange + '?page=' + this.page, request).subscribe((data: any) => {
          this.kpiDataListByUser = [];
          this.kpiDataListByUserForTable = [];
          this.getAllkpiIDsList = [];
          this.unLockIsOn = false;
          this.totalPagesOfKpi = data?.data?.totalPages;
          this.totalKpis = data?.data?.total;
          this.currentPageNumberOfKpis = data?.data?.currentPageNumber + 1;
          this.combinedData = {};
          if (data?.data?.gsi?.length != 0) {
            const today = new Date();
            for (let i = 0; i < data?.data?.gsi?.length; i++) {
              this.getAllkpiIDsList.push(data?.data?.gsi[i]?.id);
            }
            this.goalApprovalStatus = data?.data?.gsi?.every((ele: any) => ele.goalApprovalStatus == true);
            this.goalReviewStatus = data?.data?.gsi?.every((ele: any) => ele.goalReviewStatus == true);
            this.goalSubmitReviewStatus = data?.data?.gsi?.every((ele: any) => ele.goalSubmitReviewStatus == true);
            this.goalApproveReviewStatus = data?.data?.gsi?.every((ele: any) => ele.goalApproveReviewStatus == true);
            this.goalSettingStatus = data?.data?.gsi?.every((ele: any) => ele.goalSettingStatus == true);

            this.allReviewAreApproved = data?.data?.gsi?.every((item: { reviewStatus: string }) => item.reviewStatus === 'Approved');
            this.totalWeightage = data?.data?.gsi?.reduce((acc: any, val: any) => acc + val?.weightage, 0);
            this.totalKpiScore = data?.data?.gsi?.reduce((acc: any, val: any) => acc + val?.kpiScore, 0);
            this.totalKpiScore = parseFloat(this.totalKpiScore?.toFixed(2));
            data?.data?.gsi?.forEach((ele: any) => {
              var isEditable = true;
              var isRevoke = false;
              var calculateMonth = null;
              var toMonth = ele?.month?.split('-');
              var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
              if (selectedYearReviewCycle == 'Monthly') {
                var calculateMonth = toMonth[0];
              } else {
                var calculateMonth = toMonth[1];
              }
              if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
                this.isCuttofDateApplicable = true;
                isRevoke = true;
                if (ele.reviewStatus == 'Approved' || ele.reviewStatus == 'Rejected') {
                  isEditable = false;
                } else {
                  isEditable = true;
                }
                this.isCuttofDateApplicable = true;
              } else {
                if (this.pmsSetupInformationForm.value.cutoffDateApplicable) {
                  const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate);
                  calculatedCutoffDate.setHours(0, 0, 0, 0);
                  today.setHours(0, 0, 0, 0);
                  let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
                  let todayDateNumber = today.getTime();
                  if (calculatedDateCutoffDateNumber < todayDateNumber) {
                    const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate + this.pmsSetupInformationForm.value.gracePeriod);
                    calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);
                    let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
                    let todayDateNumber = today.getTime();
                    if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {
                      if (ele.reviewStatus == 'Rejected') {
                        isEditable = true;
                        // isRevoke = true;
                      } else if (ele.reviewStatus == 'Pending') {
                        isEditable = true;
                      } else {
                        isEditable = false;
                        isRevoke = false;
                      }
                    } else {
                      this.isCuttofDateApplicable = false;
                      isEditable = false;
                      isRevoke = false;
                    }
                  } else {
                    if (ele.reviewStatus == 'Approved' || ele.reviewStatus == 'Rejected') {
                      if (this.selectedTypeTabName == 'My Goals') {
                        if (ele.reviewStatus == 'Approved') {
                          isEditable = false;
                        } else {
                          isEditable = true;
                        }
                      } else {
                        isEditable = false;
                      }
                    } else {
                      isEditable = true;
                    }
                    isRevoke = true;
                    this.isCuttofDateApplicable = true;
                  }
                  const currentDate = new Date();
                  currentDate.getTime();

                  for (let i = 0; i < this.pmsUnlockStatusListByUser.length; i++) {
                    for (let j = 0; j < this.pmsUnlockStatusListByUser[i].month.length; j++) {
                      if (ele.month == this.pmsUnlockStatusListByUser[i].month[j]) {
                        let relockDate = new Date(this.pmsUnlockStatusListByUser[i].relockDate);
                        relockDate.setHours(0, 0, 0, 0);
                        today.setHours(0, 0, 0, 0);
                        if (relockDate.getTime() >= today.getTime()) {
                          isEditable = true;
                          this.unLockIsOn = true;
                        }
                      }
                    }
                  }
                  if (ele.isCftVerified == true && this.selectedTypeTabName == 'My Goals') {
                    isEditable = false;
                  }
                } else {
                  this.isCuttofDateApplicable = true;
                  isRevoke = true;
                  if (ele.reviewStatus == 'Approved' || ele.reviewStatus == 'Rejected') {
                    if (this.selectedTypeTabName == 'My Goals') {
                      if (ele.reviewStatus == 'Approved') {
                        for (let i = 0; i < this.pmsUnlockStatusListByUser.length; i++) {
                          for (let j = 0; j < this.pmsUnlockStatusListByUser[i].month.length; j++) {
                            if (ele.month == this.pmsUnlockStatusListByUser[i].month[j]) {
                              let relockDate = new Date(this.pmsUnlockStatusListByUser[i].relockDate);
                              relockDate.setHours(0, 0, 0, 0);
                              today.setHours(0, 0, 0, 0);
                              if (relockDate.getTime() >= today.getTime()) {
                                isEditable = true;
                                this.unLockIsOn = true;
                              } else {
                                isEditable = false;
                              }
                            }
                          }
                        }
                        if (this.pmsUnlockStatusListByUser.length == 0) {
                          isEditable = false;
                        }
                      } else {
                        isEditable = true;
                      }
                    } else {
                      isEditable = false;
                    }
                  } else {
                    isEditable = true;
                  }
                  if (ele.isCftVerified == true && this.selectedTypeTabName == 'My Goals') {
                    isEditable = false;
                  }
                }
              }
              if (this.selectedTypeTabName == 'Dept KPIs' || this.selectedTypeTabName == 'Dotted Goals') {
                isEditable = false;
              }
              const month = ele.month;

              if (!this.combinedData[month]) {
                this.combinedData[month] = [];
              }
              let obj = {
                isRevoke: isRevoke,
                isEditable: isEditable,
                id: ele.id,
                kra: ele.kra,
                kpi: ele.kpi,
                lesserIsBetter: ele.lesserIsBetter ? 'Yes' : 'No',
                milestoneFrom: this.toProperCase(ele.milestoneFrom),
                milestoneTo: this.toProperCase(ele.milestoneTo),
                weightage: ele.weightage,
                uom: ele.uom,
                month: this.sharedService.transform(ele.month),
                year: ele.year,
                fiscalYear: ele.fiscalYear,
                reviewCycle: ele.reviewCycle,
                target: ele.target,
                actual: ele.actual,
                percentageAchievement: ele.percentageAchievement,
                kpiScore: ele.kpiScore,
                employeeComment: ele.employeeComment,
                managerComment: ele.managerComment,
                misAttachment: ele.misAttachment,
                misFileName: ele.misFileName,
                reviewStatus: ele.reviewStatus,
                goalApprovalStatus: ele.goalApprovalStatus,
                goalReviewStatus: ele.goalReviewStatus,
                dottedManagerComment: ele.dottedManagerComment,
                fullMonthName: ele.month
              };
              this.combinedData[month].push(obj);
              this.kpiDataListByUser.push(obj);
            });
            this.kpiDataListByUserForTable = Object.keys(this.combinedData).map(month => ({
              month,
              datalist: this.combinedData[month]
            }));

            this.isAllReviewStatusNotApproved = this.kpiDataListByUser.some((ele: any) => ele.reviewStatus == 'Pending' || ele.reviewStatus == 'Rejected');
            this.isKPIInRejectedState = this.kpiDataListByUser.some((ele: any) => ele.reviewStatus == 'Rejected');
            this.isKPIInPendingState = this.kpiDataListByUser.some((ele: any) => ele.reviewStatus == 'Pending');
            this.paginationCountData();
            this.isAllMonthTotalWtHundred = this.checkAllMonthsTotalWT100(this.kpiDataListByUser);
            const resultOf = this.getAllMonthsTotalIsNotEqualTo100(this.kpiDataListByUser);
            this.greaterThan100WtMonths = resultOf.greaterThan100;
            this.lessThan100WtMonths = resultOf.lessThan100;
          } else {
            this.goalApprovalStatus = false;
            this.goalReviewStatus = false;
            this.isKPIInPendingState = false;
            this.isAllReviewStatusNotApproved = false;
            this.allReviewAreApproved = false;
            this.totalWeightage = 0;
            this.totalKpiScore = 0;
          }
          this.targetApprovedMonths();
          this.getCftVerification();
        });
      }
    } else {
      this.kpiDataListByUser = [];
    }
  }
  getFieldKey(fieldName: string): any {
    var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
    if (selectedYearReviewCycle == 'Monthly') {
      const fieldMap: { [key: string]: string } = {
        'Review Status': 'reviewStatus',
        KRA: 'kra',
        KPI: 'kpi',
        Monthly: 'month',
        'Lesser is Better': 'lesserIsBetter',
        'Milestone From': 'milestoneFrom',
        'Milestone To': 'milestoneTo',
        Weightage: 'weightage',
        UOM: 'uom',
        Target: 'target',
        Actual: 'actual',
        '% Achievement': 'percentageAchievement',
        'KPI Score': 'kpiScore',
        'Employee Comment': 'employeeComment',
        'Manager Comment': 'managerComment',
        'MIS Attachment': 'misAttachment',
        'MIS FileName': 'misFileName',
        'Dotted Manager Comment': 'dottedManagerComment'
      };
      return fieldMap[fieldName] || '';
    }
    if (selectedYearReviewCycle == 'Quarterly') {
      const fieldMap: { [key: string]: string } = {
        'Review Status': 'reviewStatus',
        KRA: 'kra',
        KPI: 'kpi',
        Quarterly: 'month',
        'Lesser is Better': 'lesserIsBetter',
        'Milestone From': 'milestoneFrom',
        'Milestone To': 'milestoneTo',
        Weightage: 'weightage',
        UOM: 'uom',
        Target: 'target',
        Actual: 'actual',
        '% Achievement': 'percentageAchievement',
        'KPI Score': 'kpiScore',
        'Employee Comment': 'employeeComment',
        'Manager Comment': 'managerComment',
        'MIS Attachment': 'misAttachment',
        'MIS FileName': 'misFileName',
        'Dotted Manager Comment': 'dottedManagerComment'
      };
      return fieldMap[fieldName] || '';
    }
    if (selectedYearReviewCycle == 'Semi-Annually') {
      const fieldMap: { [key: string]: string } = {
        'Review Status': 'reviewStatus',
        KRA: 'kra',
        KPI: 'kpi',
        'Semi-Annually': 'month',
        'Lesser is Better': 'lesserIsBetter',
        'Milestone From': 'milestoneFrom',
        'Milestone To': 'milestoneTo',
        Weightage: 'weightage',
        UOM: 'uom',
        Target: 'target',
        Actual: 'actual',
        '% Achievement': 'percentageAchievement',
        'KPI Score': 'kpiScore',
        'Employee Comment': 'employeeComment',
        'Manager Comment': 'managerComment',
        'MIS Attachment': 'misAttachment',
        'MIS FileName': 'misFileName',
        'Dotted Manager Comment': 'dottedManagerComment'
      };
      return fieldMap[fieldName] || '';
    }
    if (selectedYearReviewCycle == 'Annually') {
      const fieldMap: { [key: string]: string } = {
        'Review Status': 'reviewStatus',
        KRA: 'kra',
        KPI: 'kpi',
        Annually: 'month',
        'Lesser is Better': 'lesserIsBetter',
        'Milestone From': 'milestoneFrom',
        'Milestone To': 'milestoneTo',
        Weightage: 'weightage',
        UOM: 'uom',
        Target: 'target',
        Actual: 'actual',
        '% Achievement': 'percentageAchievement',
        'KPI Score': 'kpiScore',
        'Employee Comment': 'employeeComment',
        'Manager Comment': 'managerComment',
        'MIS Attachment': 'misAttachment',
        'MIS FileName': 'misFileName',
        'Dotted Manager Comment': 'dottedManagerComment'
      };
      return fieldMap[fieldName] || '';
    }
  }
  addKPISPopup() {
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      operation: 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserForKPISearch,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EditKPIPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getKPIsByDateRange();
    });
  }
  onClickEditKPIS(data: any) {
    if (!data?.isEditable) {
      return;
    }
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      operation: 'Edit',
      kpiId: data?.id,
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserForKPISearch,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EditKPIPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getKPIsByDateRange();
    });
  }
  sendGoalForApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to submit Target for Approval?',
        btn1: 'Cancel',
        btn2: 'Submit',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.selectedTypeTabName == 'My Goals') {
          this.selectedUserForKPISearch = this.loggedInUserId;
        }
        const request = {
          companyId: this.loggedInUserCompanyID,
          id: this.getAllkpiIDsList,
          userId: this.selectedUserForKPISearch
        };
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.sendGoalForApproval, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }
  onClickApprovaeGoals() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to Approve the Targets?',
        btn1: 'Cancel',
        btn2: 'Submit',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.selectedTypeTabName == 'My Goals') {
          this.selectedUserForKPISearch = this.loggedInUserId;
        }
        const request = {
          companyId: this.loggedInUserCompanyID,
          id: this.getAllkpiIDsList,
          userId: this.selectedUserForKPISearch
        };
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.managerApproveGoals, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }
  sendGoalForReview() {
    // for (let i = 0; i < this.kpiDataListByUser?.length; i++) {
    //   if (this.kpiDataListByUser[i].actual == null) {
    //     const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: '30%',
    //       data: {
    //         msg: 'Please Fill All KPIs Actual.',
    //         btn2: 'OK',
    //         btn2BgColor: this.buttonColorName,
    //         showSuccessIcon: false,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       },
    //     });
    //     successdialogRef.afterClosed().subscribe(result => {
    //     });
    //     return;
    //   }
    // }
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to submit Actuals for Approval?',
        btn1: 'Cancel',
        btn2: 'Submit',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.selectedTypeTabName == 'My Goals') {
          this.selectedUserForKPISearch = this.loggedInUserId;
        }
        var getPendingKpiIdList = [];
        for (let i = 0; i < this.kpiDataListByUser.length; i++) {
          if (this.kpiDataListByUser[i].reviewStatus == 'Pending' || this.kpiDataListByUser[i].reviewStatus == 'Rejected') {
            getPendingKpiIdList.push(this.kpiDataListByUser[i].id);
          }
        }
        const request = {
          companyId: this.loggedInUserCompanyID,
          id: getPendingKpiIdList,
          userId: this.selectedUserForKPISearch
        };
        this.httpService.callPostService(this.config.sendGoalForReview, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }
  approveRejectReview(item: any, status: any) {
    if (item.isEditable) {
      if (item.actual == null) {
        if (status == true) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: 'Are you sure you want to approve?',
              btn1: 'Cancel',
              btn2: 'Submit',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              if (item?.isEditable) {
                const request = {
                  compId: this.loggedInUserCompanyID,
                  goalId: [item?.id],
                  status: status,
                  userId: this.loggedInUserId
                };
                this.httpService.callPostService(this.config.changeReviewStatus, request).subscribe((data: any) => {
                  if (data?.status) {
                    // const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                    //   disableClose: true,
                    //   height: '25%',
                    //   width: '30%',
                    //   data: {
                    //     msg: data.message,
                    //     btn2: 'OK',
                    //     btn2BgColor: this.buttonColorName,
                    //     showSuccessIcon: true,
                    //     showSuccessMessage: false,
                    //     showCloseIcon: false
                    //   },
                    // });
                    // successdialogRef.afterClosed().subscribe(result => {
                    this.getKPIsByDateRange();
                    // });
                  } else {
                    const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                      disableClose: true,
                      height: '25%',
                      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
                      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                      data: {
                        msg: data.message,
                        btn2: 'OK',
                        btn2BgColor: this.buttonColorName,
                        showSuccessIcon: false,
                        showSuccessMessage: false,
                        showCloseIcon: false
                      }
                    });
                    successdialogRef.afterClosed().subscribe(result => {});
                  }
                });
              }
            }
          });
        } else {
          if (item?.isEditable) {
            const request = {
              compId: this.loggedInUserCompanyID,
              goalId: [item?.id],
              status: status,
              userId: this.loggedInUserId
            };
            this.httpService.callPostService(this.config.changeReviewStatus, request).subscribe((data: any) => {
              if (data?.status) {
                // const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                //   disableClose: true,
                //   height: '25%',
                //   width: '30%',
                //   data: {
                //     msg: data.message,
                //     btn2: 'OK',
                //     btn2BgColor: this.buttonColorName,
                //     showSuccessIcon: true,
                //     showSuccessMessage: false,
                //     showCloseIcon: false
                //   },
                // });
                // successdialogRef.afterClosed().subscribe(result => {
                this.getKPIsByDateRange();
                // });
              } else {
                const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
                  maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                  data: {
                    msg: data.message,
                    btn2: 'OK',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  }
                });
                successdialogRef.afterClosed().subscribe(result => {});
              }
            });
          }
        }
      } else {
        if (item?.isEditable) {
          const request = {
            compId: this.loggedInUserCompanyID,
            goalId: [item?.id],
            status: status,
            userId: this.loggedInUserId
          };
          this.httpService.callPostService(this.config.changeReviewStatus, request).subscribe((data: any) => {
            if (data?.status) {
              // const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              //   disableClose: true,
              //   height: '25%',
              //   width: '30%',
              //   data: {
              //     msg: data.message,
              //     btn2: 'OK',
              //     btn2BgColor: this.buttonColorName,
              //     showSuccessIcon: true,
              //     showSuccessMessage: false,
              //     showCloseIcon: false
              //   },
              // });
              // successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
              // });
            } else {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: data.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: false,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });
              successdialogRef.afterClosed().subscribe(result => {});
            }
          });
        }
      }
    }
  }
  onClickApproveAll() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to approve all?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var pendingIds = this.kpiDataListByUser?.filter((item: { isEditable: boolean; reviewStatus: string }) => (item.reviewStatus === 'Pending' || item.reviewStatus === 'Rejected') && item.isEditable).map((item: { id: any }) => item.id);
        const request = {
          compId: this.loggedInUserCompanyID,
          goalId: pendingIds,
          status: true,
          userId: this.loggedInUserId
        };
        this.httpService.callPostService(this.config.changeReviewStatus, request).subscribe((data: any) => {
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }
  managerReviewGoals() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to Approve the Actuals?',
        btn1: 'Cancel',
        btn2: 'Submit',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.selectedTypeTabName == 'My Goals') {
          this.selectedUserForKPISearch = this.loggedInUserId;
        }
        const request = {
          companyId: this.loggedInUserCompanyID,
          id: this.getAllkpiIDsList,
          userId: this.selectedUserForKPISearch
        };
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.managerReviewGoals, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getKPIsByDateRange();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }
  downloadUserKpis() {
    if (this.selectedTypeTabName == 'My Goals') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: this.fromDate,
      to: this.toDate,
      id: this.getAllkpiIDsList,
      userId: this.selectedUserForKPISearch,
      year: this.selectedYear
    };
    this.httpService.callPostService(this.config.downloadUserKpis, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, 'User_KPIs.xlsx');
    });
  }
  selectALLRecords(event: any) {
    if (event.checked) {
      this.selectedKPIList = [];
      this.selectAllCheckbox = true;
      for (let i = 0; i < this.kpiDataListByUser.length; i++) {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
          this.kpiDataListByUser[i].checkboxCheck = true;
          for (let j = 0; j < this.kpiDataListByUser[i].datalist?.length; j++) {
            this.kpiDataListByUserForTable[i].datalist[j].checkboxCheck = true;
          }
          this.selectedKPIList.push(this.kpiDataListByUser[i]);
        } else {
          if (!this.kpiDataListByUser[i].goalApprovalStatus) {
            this.kpiDataListByUser[i].checkboxCheck = true;
            for (let j = 0; j < this.kpiDataListByUser[i].datalist?.length; j++) {
              this.kpiDataListByUserForTable[i].datalist[j].checkboxCheck = true;
            }
            this.selectedKPIList.push(this.kpiDataListByUser[i]);
          }
        }
      }
    } else {
      for (let i = 0; i < this.kpiDataListByUser.length; i++) {
        for (let j = 0; j < this.kpiDataListByUser[i].datalist?.length; j++) {
          this.kpiDataListByUserForTable[i].datalist[j].checkboxCheck = false;
        }
        this.kpiDataListByUser[i].checkboxCheck = false;
      }
      this.selectAllCheckbox = false;
      this.selectedKPIList = [];
    }
  }
  selectSingleRecord(event: any, data: any, itemIndex: number, innerItemIndex: number) {
    if (event.checked) {
      this.kpiDataListByUserForTable[itemIndex].datalist[innerItemIndex].checkboxCheck = true;
      this.selectedKPIList.push(data);
    } else {
      this.selectAllCheckbox = false;
      this.kpiDataListByUserForTable[itemIndex].datalist[innerItemIndex].checkboxCheck = false;
      this.selectedKPIList.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.selectedKPIList.splice(ind, 1);
        }
      });
    }
  }
  softDeleteGoalSetting() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete these record(s)?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var ids = [];
        for (let i = 0; i < this.selectedKPIList.length; i++) {
          ids.push(this.selectedKPIList[i].id);
        }
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.softDeleteGoalSetting, { isDeleted: true, id: ids }).subscribe(
          (res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: res.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.selectedKPIList = [];
              this.selectAllCheckbox = false;
              this.getKPIsByDateRange();
            });
          },
          (err: any) => {
            this.loader.dismissLoader();
            console.log(err);
          }
        );
      }
    });
  }
  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.pmsYears.push(obj);
      });
      this.pmsYears?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';

        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        } else {
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.selectedYearTtdTable = ele?.year;
          this.selectedYearForCompanyScoreTrend = ele?.year;
          this.selectedKpiScoreSummaryYear = ele?.year;
          this.selectedYearTargetVsActual = ele?.year;
          this.selectedPerformingKpiYear = ele?.year;
          this.selectedYearForTopTenKpi = ele?.year;
          this.selectedlastThreeYearKpiScoreKpiYear = ele?.year;
          var test = ele?.year?.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
        }
      });
      this.getMonths(this.fromYear, this.toYear);
    });
  }
  getPmsYears() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: ''
    };
    this.httpService.callPostService(this.config.getPmsYears, request).subscribe((data: any) => {
      this.pmsYears = [];
      data?.data?.access?.forEach((ele: any) => {
        // var test = ele.split('_');
        let obj = {
          year: ele.fromYear + '-' + ele.toYear
        };
        if (ele.fromYear != null && ele.toYear != null) {
          this.pmsYears.push(obj);
        }
      });
      this.pmsYears?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
          this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
          this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
        } else {
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear - 1);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
              this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
              this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
              this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.selectedYearTtdTable = ele?.year;
          this.selectedYearForCompanyScoreTrend = ele?.year;
          this.selectedKpiScoreSummaryYear = ele?.year;
          this.selectedYearTargetVsActual = ele?.year;
          this.selectedPerformingKpiYear = ele?.year;
          this.selectedYearForTopTenKpi = ele?.year;
          this.selectedlastThreeYearKpiScoreKpiYear = ele?.year;
          var test = ele?.year?.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
        }
      });
      this.getMonths(this.fromYear, this.toYear);
      setTimeout(() => {
        this.getTeamOfManagerForTargetVSActual();
        this.getTeamOfManagerForPreviousThreeYearData();
        this.getTeamOfManagerForTopFourKPI();
        this.getTeamOfManagerForPerformingKPI();
      }, 1000);
    });
  }
  chnageSelectYear() {
    this.fromDate = null;
    this.toDate = null;
    this.fromDateGloabalDashboard = null;
    var year = this.selectedYear?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
      this.pmsSetupInformationForm.controls['fromYear'].setValue(this.fromYear);
      this.pmsSetupInformationForm.controls['toYear'].setValue(this.toYear);
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  KpiScoreSummaryYearchange() {
    this.selectedKpiScoreSummaryfromDate = null;
    this.selectedKpiUser = null;
    var year = this.selectedKpiScoreSummaryYear?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  KpiScoreSummaryformMonthChange() {
    this.selectedKpiUser = null;
    this.kpiGoalSummaryData = [];
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDateByDeptEmptyKPISummary();
    } else {
      this.getTeamOfManagerForKPISummary();
    }
  }
  getMonthsByFiscalandReviewCycleForReport: any[] = [];
  getMonths(fromYear: any, toYear: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: fromYear,
      toYear: toYear
    };
    this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
      this.selectedReviewCycle = [];
      this.getMonthsByFiscalandReviewCycleForReport = [];
      if (data?.data != null) {
        this.getMonthsByFiscalandReviewCycle = data.data?.months;
        data.data?.months?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: this.sharedService.transform(ele)
          };
          this.getMonthsByFiscalandReviewCycleForReport.push(obj);
        });
        this.selectedYearReviewCycle = data.data?.reviewCycle;
        const currentMonthIndex = new Date().getMonth(); // getMonth returns 0 for January, 11 for December
        let selectedIndex = 0;
        const today = new Date();
        const month = today.toLocaleString('default', { month: 'long' });

        if (this.selectedYearReviewCycle == 'Monthly') {
          this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
            var checkMonth = ele?.split('-');
            if (month == checkMonth[0]) {
              this.fromDate = ele;
              this.toDate = ele;
              this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
              this.fromDateYtdTable = this.fromDate;
              this.selectedKpiScoreSummaryfromDate = this.fromDate;
              this.selectedPerformingKpifromDate = this.fromDate;
              this.fromDateForTopTenKpi = this.fromDate;
              this.fromDateGloabalDashboard = this.fromDate;
              this.reportFormMonth = ele;
              this.reportToMonth = ele;
              this.getToMonths(this.fromDate);
              this.getTeamOfManagerForKPISummary();
            }
          });
        }

        if (this.selectedYearReviewCycle == 'Quarterly' || this.selectedYearReviewCycle == 'Semi_Annually' || this.selectedYearReviewCycle == 'Annually') {
          for (let range of this.getMonthsByFiscalandReviewCycle) {
            const [start, end] = range?.split('-');
            const startMonthIndex = this.getMonthIndex(start);
            const endMonthIndex = this.getMonthIndex(end);

            if ((currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) || (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))) {
              this.fromDate = range;
              this.toDate = range;
              this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
              this.fromDateYtdTable = this.fromDate;
              this.selectedKpiScoreSummaryfromDate = this.fromDate;
              this.selectedPerformingKpifromDate = this.fromDate;
              this.fromDateForTopTenKpi = this.fromDate;
              this.fromDateGloabalDashboard = this.fromDate;
              this.reportFormMonth = range;
              this.reportToMonth = range;
              this.getToMonths(this.fromDate);
              this.getTeamOfManagerForKPISummary();
            }
          }
        }
        if (this.loggedInUserRole == 'Admin') {
          this.getEmpsOfAdminByDateByDeptEmpty();
        }
        this.getPMSSetUpByID();
        this.getColumnVisibility();
        this.getKPIsByDateRange();
        // if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        //   || this.loggedInUserRole == 'PHI Admin') {
        //   this.getAllEmployeeDropdownByCompanyID();
        // }
        // // else if(this.loggedInUserRole == 'Employee' ){
        // //   this.selectedKpiUser = this.loggedInUserId;
        // //   this.selectedPerformingKpiUser = this.loggedInUserId;
        // //   this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
        // // }
        // else {
        this.getTeamOfManager();
        // }
        this.getDashboardCount();
        this.getPmsSetupData();
      } else {
        this.getMonthsByFiscalandReviewCycle = [];
        this.getToMonthsByFiscalandReviewCycle = [];
        this.kpiDataListByUser = [];
        this.getAllkpiIDsList = [];
        this.totalPagesOfKpi = 0;
        this.totalKpis = 0;
        this.currentPageNumberOfKpis = 1;
        this.goalApprovalStatus = false;
        this.goalReviewStatus = false;
        this.isKPIInPendingState = false;
        this.isAllReviewStatusNotApproved = false;
        this.allReviewAreApproved = false;
        this.totalWeightage = 0;
        this.totalKpiScore = 0;
        this.getPMSSetUpByID();
      }
    });
  }
  getToMonths(month: string) {
    const startIndex = this.getMonthsByFiscalandReviewCycle.indexOf(month);
    if (startIndex !== -1) {
      this.getToMonthsByFiscalandReviewCycle = this.getMonthsByFiscalandReviewCycle.slice(startIndex);
    } else {
      this.getToMonthsByFiscalandReviewCycle = [];
    }
  }
  getMonthName(monthIndex: number): string {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthIndex];
  }

  getMonthIndex(monthName: string): number {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }
  getDepartmentList() {
    this.httpService.callGetService(this.config.getDepartmentList + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.deptListOfCompany = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.deptListOfCompany.push(obj);
      });
      this.deptListOfCompany = this.deptListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.deptListOfCompany.length != 0) {
        this.selectedDeptForKPISearch = [];
        this.selectedDeptForKPISearch.push(this.deptListOfCompany[0]);
        this.getAllEmployeesByDept();
      }
    });
  }
  getEmployeeMonthDataScorecard(employee: any, month: string) {
    return (
      employee?.goals?.find((d: { month: string }) => d.month === month) || {
        wt: null,
        target: null,
        unit: null,
        actual: null,
        percentageAchievement: null,
        kpiScore: null
      }
    );
  }
  getEmployeeMonthDataAllMonthYtd(employee: any, month: string) {
    return employee?.response?.find((d: { month: string }) => d.month === month) || { wt: 0, kpiScore: 0 };
  }
  getReviewComplianceReportMonthData(employee: any, month: string) {
    return employee?.kpiuserdata?.find((d: { month: string }) => d.month === month) || { goalReviewStatus: 0 };
  }
  getEmployeeMonthDataAllKpiwiseYtd(employee: any, month: string) {
    return (
      employee?.monthlyData?.find((d: { month: string }) => d.month === month) || {
        wt: null,
        target: null,
        uom: null,
        actual: null,
        percentageAchievement: null,
        kpiScore: null
      }
    );
  }

  getAllEmployeesByDept() {
    this.selectedUserForKPISearch = null;
    const request = {
      companyId: this.loggedInUserCompanyID,
      department: null,
      departments: this.selectedDeptForKPISearch?.map((ele: { id: any }) => ele.id),
      from: this.fromDate,
      fromYear: this.fromYear,
      to: this.toDate,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getEmpsByDeptByDate, request).subscribe((data: any) => {
      this.teamOfManagerList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerList.push(obj);
      });
      this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerList.length != 0) {
        this.selectedUserForKPISearch = this.teamOfManagerList[0]?.id;
        this.getPmsUnlockSetupForUser();
        if (this.selectedTypeTabName == 'Employee Goals') {
          this.getKPIsByDateRange();
        }
      }
    });

    // this.selectedUserForKPISearch = null;
    // const request = {
    //   department: this.selectedDeptForKPISearch,
    //   companyId: this.loggedInUserCompanyID
    // }
    // this.httpService.callPostService(this.config.getAllEmployeesByDept, request).subscribe((data: any) => {
    //   this.teamOfManagerList = [];
    //   data?.data?.forEach((ele: any) => {
    //     let obj = {
    //       id: ele?.id,
    //       name: ele?.firstName + ' ' + ele?.lastName,
    //     }
    //     this.teamOfManagerList.push(obj);
    //   });
    //   this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    // })
  }
  toProperCase(str: any) {
    if (str == null) {
      return null;
    } else {
      return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    }
  }
  getMonthIndex1(monthName: string): number {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.indexOf(monthName);
  }
  convertMonthNameToDate(monthName: string, year: number = new Date().getFullYear()): Date {
    const monthIndex = this.getMonthIndex1(monthName);
    if (monthIndex === -1) {
      throw new Error('Invalid month name');
    }
    return new Date(year, monthIndex + 1, 0); // First day of the month
  }

  calculateEndOfMonthDateFromMonthName(monthName: string, daysToAdd: number, year?: number): Date {
    const startDate = this.convertMonthNameToDate(monthName, year);
    const resultDate = new Date(startDate);
    resultDate.setDate(resultDate.getDate() + daysToAdd);

    const endOfMonthDate = new Date(resultDate.getFullYear(), resultDate.getMonth() + 1, 0); // The 0th day of the next month is the last day of the current month

    if (resultDate > endOfMonthDate) {
      return endOfMonthDate;
    } else {
      return resultDate;
    }
  }
  revokeGoalStatus(item: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to revoke?',
        btn1: 'Cancel',
        btn2: 'Revoke',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          compId: this.loggedInUserCompanyID,
          goalId: [item?.id],
          status: true,
          userId: this.selectedUserForKPISearch
        };
        this.httpService.callPostService(this.config.revokeGoalStatus, request).subscribe((data: any) => {
          if (data?.status) {
            this.getKPIsByDateRange();
          }
        });
      }
    });
  }
  showScoreCardReport(item: any, index: any) {
    this.activeReportBtnName = item?.btnName;
    this.reportBtn?.forEach((ele: any, ind: any) => {
      ele.isActive = ind === index;
    });
    this.isAllEmpForReportToggle = true;
    if (this.loggedInUserRole != 'Employee') {
      this.selectedGoalForEmp = null;
    } else {
      this.selectedGoalForEmp = 'My Goals';
    }
    this.selectedDepartmentsForReport = [];
    this.reportColumnRowInfoData = [];
    this.selectedUserForKPIReport = [];
    this.renderDataCustomReportData = [];
    this.teamOfManagerList = [];
    this.employeeListByDept = [];
    this.monthsForScoreCardReport = [];
    this.employeesScoreCardReportData = [];
    this.currentPageReport = 1;
    this.pageReport = 0;
    this.totalNoOfPagesReport = 0;
    this.totalCountOfReport = 0;
    this.reportColumnHeaderInfo();
    if (this.activeReportBtnName == 'Custom Report') {
      this.submiForReportPreview();
    }
    if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedGoalForEmp = null;
        this.getManagerOfTeam();
      }
    }
    if (this.loggedInUserRole == 'Employee') {
      if (this.activeReportBtnName != 'Custom Report') {
        this.submiForReportPreview();
      }
    }
  }
  togglePanelForReportAllEmp() {
    if (this.isAllEmpForReportToggle) {
      if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
        this.selectedGoalForEmp = null;
        this.getManagerOfTeam();
      }
    } else {
      this.selectedGoalForEmp = 'My Goals';
      this.submiForReportPreview();
    }
  }
  getEmployeeListOnGoal() {
    this.teamOfManagerList = [];
    this.selectedUserForKPIReport = [];
    if (this.selectedGoalForEmp == 'Team Goals') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        from: this.fromDate,
        fromYear: this.fromYear,
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        userType: null,
        loggedInUserRole: this.loggedInUserRole
      };
      this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    }
    if (this.selectedGoalForEmp == 'Dept Goals') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        from: this.fromDate,
        fromYear: this.fromYear,
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        userType: null
      };
      this.httpService.callPostService(this.config.getDeptEmployeesByDate, request).subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    }
  }
  chnageSelectYearForReport() {
    var year = this.selectedYear?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
  }
  lastThreeYearRange: any = [];

  //   submiForReportPreview() {
  //  this.isReportLoading = true; // Start loader
  //     if (this.searchKpiReportString == '') {
  //       this.searchKpiString = null;
  //     }
  //     var userIds: any[] = [];
  //     if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
  //       || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD'
  //       || this.loggedInUserRole == 'Admin') {
  //       if (window.innerWidth <= 800) {
  //         userIds.push(this.selectedUserForKPIReport)
  //       } else {
  //         userIds = this.selectedUserForKPIReport?.map((ele: { id: any; }) => ele.id)
  //       }
  //     } else {
  //       if (this.selectedGoalForEmp == 'My Goals') {
  //         userIds.push(this.loggedInUserId)
  //       }
  //       if (this.selectedGoalForEmp == 'Team Goals') {
  //         if (window.innerWidth <= 800) {
  //           userIds.push(this.selectedUserForKPIReport)
  //         } else {
  //           userIds = this.selectedUserForKPIReport?.map((ele: { id: any; }) => ele.id)
  //         }
  //       }
  //       if (this.selectedGoalForEmp == 'Dept Goals') {
  //         if (window.innerWidth <= 800) {
  //           userIds.push(this.selectedUserForKPIReport)
  //         } else {
  //           userIds = this.selectedUserForKPIReport?.map((ele: { id: any; }) => ele.id)
  //         }
  //       }
  //       if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
  //         if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
  //           if (this.isAllEmpForReportToggle) {
  //             userIds = this.teamOfManagerList?.map((ele: { id: any; }) => ele.id);
  //             userIds.push(this.loggedInUserId);
  //           }
  //         }
  //       }
  //     }
  //     if (this.activeReportBtnName == 'Scorecard') {
  //       const request = {
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "month": this.selectedReviewCycle?.map((ele: { id: any; }) => ele.id),
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": userIds
  //       }
  //       this.httpService.callPostService(this.config.getScoreCardReport + '?page=' + this.pageReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           this.monthsForScoreCardReport = data?.data?.months;
  //           this.employeesScoreCardReportData = data?.data?.response;
  //           this.currentPageReport = data?.data?.currentPageNumber + 1;
  //           this.totalNoOfPagesReport = data?.data?.totalPages;
  //           this.totalCountOfReport = data?.data?.total;
  //         }
  //       })
  //     }
  //     if (this.activeReportBtnName == 'All Employee -Month-YTD') {
  //       const request = {
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "month": [],
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": userIds
  //       }
  //       this.httpService.callPostService(this.config.getMonthYTDReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           var year = this.selectedYear?.split('-')
  //           this.lastThreeYearRange = this.getLastThreeYearRanges(year[0]);
  //           this.monthsForScoreCardReport = data?.data?.months;
  //           this.employeesScoreCardReportData = data?.data?.employeeResponse;
  //         }
  //       })
  //     }

  //     if (this.activeReportBtnName == 'KPI wise YTD') {
  //       const request = {
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "month": this.selectedReviewCycle?.map((ele: { id: any; }) => ele.id),
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": userIds
  //       }
  //       this.httpService.callPostService(this.config.getKPIWiseYTDReport + '?page=' + this.pageReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           this.currentPageReport = data?.data?.currentPageNumber + 1;
  //           this.totalNoOfPagesReport = data?.data?.totalPages;
  //           this.totalCountOfReport = data?.data?.total;
  //           this.monthsForScoreCardReport = data?.data?.months;
  //           this.employeesScoreCardReportData = data?.data?.response;
  //         }
  //       })
  //     }
  //     if (this.activeReportBtnName == 'Review Compliance Report') {
  //       const request = {
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "month": this.selectedReviewCycle?.map((ele: { id: any; }) => ele.id),
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": userIds
  //       }
  //       this.httpService.callPostService(this.config.getCompilenceReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           this.monthsForScoreCardReport = data?.data?.months;
  //           this.employeesScoreCardReportData = data?.data?.finalresponse;
  //         }
  //       })

  //     }
  //     if (this.activeReportBtnName == 'Review Compliance Summary') {
  //       let departmentForReport: any = []
  //       if (window.innerWidth <= 800) {
  //         if (this.selectedDepartmentForReport.length === 0) {
  //           departmentForReport = this.selectedDepartmentForReport
  //         } else {
  //           departmentForReport.push(this.selectedDepartmentForReport)
  //         }
  //       } else {
  //         departmentForReport = this.selectedDepartmentForReport?.map((ele: { id: any; }) => ele.id)
  //       }
  //       const request = {
  //         "loggedInUserRole": this.loggedInUserRole,
  //         "deptName": departmentForReport,
  //         "summaryType": this.selectedSummaryTypeForReport,
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": this.loggedInUserId
  //       }
  //       this.httpService.callPostService(this.config.getReviewComplianceSummaryReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           this.employeesScoreCardReportData = data?.data?.response;
  //         }
  //       })
  //     }
  //     if (this.activeReportBtnName == 'Custom Report') {
  //       if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
  //         || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD'
  //         || this.loggedInUserRole == 'Admin') {
  //         userIds = this.selectedUserForKPIReport?.map((ele: { id: any; }) => ele.id)
  //       } else {
  //         userIds = [this.loggedInUserId]
  //       }
  //       const request = {
  //         "compId": this.loggedInUserCompanyID,
  //         "fromYear": this.fromYear,
  //         "month": [],
  //         "search": this.searchKpiReportString,
  //         "toYear": this.toYear,
  //         "userId": userIds,
  //         "loggedInUserRole": this.loggedInUserRole,
  //       }
  //       this.httpService.callPostService(this.config.getCustomReport + '?page=' + this.pageReport, request).subscribe((data: any) => {
  //         if (data?.status) {
  //           this.employeesScoreCardReportData = data?.data?.response;
  //           this.currentPageReport = data?.data?.currentPageNumber + 1;
  //           this.totalNoOfPagesReport = data?.data?.totalPages;
  //           this.totalCountOfReport = data?.data?.total;
  //           //   for(let i=0;i<data?.data?.response?.length;i++){
  //           //     data?.data?.response[i]?.forEach((ele: any) => {
  //           //       const month = ele.month;
  //           //       if (!this.combinedData[month]) {
  //           //         this.combinedData[month] = [];
  //           //       }
  //           //       let obj = {
  //           //         employeeId: ele.employeeId,
  //           //         firstName: ele.firstName,
  //           //         lastName: ele.lastName,
  //           //         officialEmail: ele.officialEmail,
  //           //         dateOfJoining: ele.dateOfJoining,
  //           //         dateOfExit: ele.dateOfExit,
  //           //         month: ele.month,
  //           //         reportingmanagercode: ele.reportingmanagercode,
  //           //         department: ele.department,
  //           //         location: ele.location,
  //           //         kra: ele.kra,
  //           //         kpi: ele.kpi,
  //           //         reviewCycle: ele.reviewCycle,
  //           //         lesserIsBetter: ele.lesserIsBetter,
  //           //         milestoneFrom: ele.milestoneFrom,
  //           //         milestoneTo: ele.milestoneTo,
  //           //         weightage: ele.weightage,
  //           //         uom: ele.uom,
  //           //         target: ele.target,
  //           //         actual: ele.actual,
  //           //         percentageAchievement: ele.percentageAchievement,
  //           //         kpiScore: ele.kpiScore,
  //           //         reviewStatus: ele.reviewStatus,
  //           //         managerComment: ele.managerComment,
  //           //         misAttachmentFileName: ele.misAttachmentFileName,
  //           //         misAttachment: ele.misAttachment,
  //           //         employeeComment: ele.employeeComment,
  //           //         dottedManagerComment: ele.dottedManagerComment,
  //           //       }
  //           //       this.combinedData[month].push(obj);
  //           //     })
  //           //   }
  //           //   this.employeesScoreCardReportData = Object.keys(this.combinedData).map(month => ({
  //           //     month,
  //           //     datalist: this.combinedData[month],
  //           //   }));
  //         }
  //       })

  //     }
  //   }
  isReportLoading: boolean = false; // Declare this at the top of your component

  submiForReportPreview() {
    this.isReportLoading = true; // ✅ Start loader immediately

    if (this.searchKpiReportString == '') {
      this.searchKpiString = null;
    }

    var userIds: any[] = [];

    // ✅ User role logic (unchanged)
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
      if (window.innerWidth <= 800) {
        userIds.push(this.selectedUserForKPIReport);
      } else {
        userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
      }
    } else {
      if (this.selectedGoalForEmp == 'My Goals') {
        userIds.push(this.loggedInUserId);
      }
      if (this.selectedGoalForEmp == 'Team Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.selectedGoalForEmp == 'Dept Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          if (this.isAllEmpForReportToggle) {
            userIds = this.teamOfManagerList?.map((ele: { id: any }) => ele.id);
            userIds.push(this.loggedInUserId);
          }
        }
      }
    }

    // ✅ Request and API call logic (unchanged)
    let apiCall: any;

    if (this.activeReportBtnName == 'Scorecard') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      apiCall = this.httpService.callPostService(this.config.getScoreCardReport + '?page=' + this.pageReport, request);
    }

    if (this.activeReportBtnName == 'All Employee -Month-YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      apiCall = this.httpService.callPostService(this.config.getMonthYTDReport, request);
    }

    if (this.activeReportBtnName == 'KPI wise YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      apiCall = this.httpService.callPostService(this.config.getKPIWiseYTDReport + '?page=' + this.pageReport, request);
    }

    if (this.activeReportBtnName == 'Review Compliance Report') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      apiCall = this.httpService.callPostService(this.config.getCompilenceReport, request);
    }

    if (this.activeReportBtnName == 'Review Compliance Summary') {
      let departmentForReport: any = [];
      if (window.innerWidth <= 800) {
        if (this.selectedDepartmentForReport.length === 0) {
          departmentForReport = this.selectedDepartmentForReport;
        } else {
          departmentForReport.push(this.selectedDepartmentForReport);
        }
      } else {
        departmentForReport = this.selectedDepartmentForReport?.map((ele: { id: any }) => ele.id);
      }

      const request = {
        loggedInUserRole: this.loggedInUserRole,
        deptName: departmentForReport,
        summaryType: this.selectedSummaryTypeForReport,
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: this.loggedInUserId
      };
      apiCall = this.httpService.callPostService(this.config.getReviewComplianceSummaryReport, request);
    }

    if (this.activeReportBtnName == 'Custom Report') {
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
        userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
      } else {
        userIds = [this.loggedInUserId];
      }

      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds,
        loggedInUserRole: this.loggedInUserRole
      };
      apiCall = this.httpService.callPostService(this.config.getCustomReport + '?page=' + this.pageReport, request);
    }

    // ✅ API Subscription (single unified loader handling)
    if (apiCall) {
      apiCall.subscribe({
        next: (data: any) => {
          this.isReportLoading = false; // ✅ Stop loader
          if (data?.status) {
            // Keep your original update logic
            this.employeesScoreCardReportData = data?.data?.response || data?.data?.employeeResponse || data?.data?.finalresponse;
            this.monthsForScoreCardReport = data?.data?.months;
            this.currentPageReport = (data?.data?.currentPageNumber ?? -1) + 1;
            this.totalNoOfPagesReport = data?.data?.totalPages;
            this.totalCountOfReport = data?.data?.total;
          }
        },
        error: () => {
          this.isReportLoading = false; // ✅ Stop loader on error
        }
      });
    } else {
      this.isReportLoading = false; // ✅ In case no API is triggered
    }
  }

  calculateTotalWtForScorecard(employeeData: any, month: any) {
    let totalWeighatge = 0;
    for (const employee of employeeData?.response) {
      for (const goal of employee.goals) {
        if (goal.month == month) {
          totalWeighatge += Number(goal.weighatge) ?? 0;
        }
      }
    }
    return totalWeighatge;
  }
  calculateTotalKpiScoreForScorecard(employeeData: any, month: any) {
    let totalkpiscore = 0;
    for (const employee of employeeData?.response) {
      for (const goal of employee.goals) {
        if (goal.month == month) {
          totalkpiscore += Number(goal.kpiScore) ?? 0;
        }
      }
    }
    return parseFloat(totalkpiscore?.toFixed(2));
  }
  calculateTotalAvgKpiScoreScorecard(employeeData: any) {
    let totalkpiScore = 0;
    for (const employee of employeeData) {
      for (const goal of employee.goals) {
        totalkpiScore += Number(goal.kpiScore) ?? 0;
      }
    }
    return parseFloat((totalkpiScore / this.monthsForScoreCardReport.length)?.toFixed(2));
  }
  calculateTotalAvgWtScorecard(employeeData: any) {
    let totalwt = 0;
    for (const employee of employeeData) {
      for (const goal of employee.goals) {
        totalwt += Number(goal.weighatge) ?? 0;
      }
    }
    return parseFloat((totalwt / this.monthsForScoreCardReport.length)?.toFixed(2));
  }
  calculateTotalWtForKPIwiseytd(employeeData: any, month: any) {
    let totalWeighatge = 0;
    for (const employee of employeeData) {
      for (const goal of employee.monthlyData) {
        if (goal.month == month) {
          totalWeighatge += Number(goal.weighatge) ?? 0;
        }
      }
    }
    return totalWeighatge;
  }
  calculateTotalKpiScoreForKPIwiseytd(employeeData: any, month: any) {
    let totalkpiscore = 0;
    for (const employee of employeeData) {
      for (const goal of employee.monthlyData) {
        if (goal.month == month) {
          totalkpiscore += Number(goal.kpiScore) ?? 0;
        }
      }
    }
    return parseFloat(totalkpiscore?.toFixed(2));
  }
  onClickClearFilterReport() {
    this.selectedGoalForEmp = null;
    this.selectedUserForKPIReport = [];
    this.isAllEmpForReportToggle = false;
    this.selectedReviewCycle = [];
    this.selectedDepartmentsForReport = [];
    this.employeesScoreCardReportData = [];
    this.renderDataCustomReportData = [];
  }
  checkAllMonthsTotalWT100(data: { month: string; total: number }[]): boolean {
    const monthTotals = this.kpiDataListByUser.reduce(
      (acc: { [x: string]: any }, { month, weightage }: any) => {
        acc[month] = (acc[month] || 0) + weightage;
        return acc;
      },
      {} as Record<string, number>
    );
    return Object.values(monthTotals).every(total => total === 100);
  }

  getAllMonthsTotalIsNotEqualTo100(data: { month: string; total: number }[]): { lessThan100: string[]; greaterThan100: string[] } {
    const monthTotals = this.kpiDataListByUser.reduce(
      (acc: { [key: string]: number }, { month, weightage }: { month: string; weightage: number }) => {
        acc[month] = (acc[month] || 0) + weightage;
        return acc;
      },
      {} as Record<string, number>
    );

    // Arrays to hold months based on their total values
    const lessThan100: string[] = [];
    const greaterThan100: string[] = [];

    // Populate the arrays based on the totals
    for (const [month, total] of Object.entries(monthTotals) as [string, number][]) {
      if (total < 100) {
        lessThan100.push(month);
      } else if (total > 100) {
        greaterThan100.push(month);
      }
    }
    return { lessThan100, greaterThan100 };
  }
  get isButtonDisabledOfSubmitTargetApproval(): boolean {
    const today = new Date();
    var isEditable = true;
    if (this.toDate != null) {
      var toMonth = this.toDate?.split('-');
      var calculateMonth = null;
      var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
      if (selectedYearReviewCycle == 'Monthly') {
        calculateMonth = toMonth[0];
      } else {
        calculateMonth = toMonth[1];
      }
      if (this.pmsSetupInformationForm.value.cutoffDateApplicable) {
        const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate);
        calculatedCutoffDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
        let todayDateNumber = today.getTime();
        if (calculatedDateCutoffDateNumber < todayDateNumber) {
          const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate + this.pmsSetupInformationForm.value.gracePeriod);
          calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
          let todayDateNumber = today.getTime();
          if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {
            if (this.isKPIInRejectedState) {
              isEditable = true;
            } else {
              isEditable = false;
            }
          } else {
            isEditable = false;
          }
        } else {
          isEditable = true;
        }
      } else {
        isEditable = true;
      }
    }
    return (this.isAllMonthTotalWtHundred && isEditable && !this.goalSettingStatus) || this.unLockIsOn;
  }
  get isButtonDisabledGoalApprove(): boolean {
    const today = new Date();
    var isEditable = true;
    if (this.toDate != null) {
      var toMonth = this.toDate?.split('-');
      var calculateMonth = null;
      var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
      if (selectedYearReviewCycle == 'Monthly') {
        calculateMonth = toMonth[0];
      } else {
        calculateMonth = toMonth[1];
      }
      if (this.pmsSetupInformationForm.value.cutoffDateApplicable) {
        const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate);
        calculatedCutoffDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
        let todayDateNumber = today.getTime();
        if (calculatedDateCutoffDateNumber < todayDateNumber) {
          const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate + this.pmsSetupInformationForm.value.gracePeriod);
          calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
          let todayDateNumber = today.getTime();
          if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {
            if (this.isKPIInRejectedState) {
              isEditable = true;
            } else {
              isEditable = false;
            }
          } else {
            isEditable = false;
          }
        } else {
          isEditable = true;
        }
      } else {
        isEditable = true;
      }
    }
    return (!this.goalApprovalStatus && this.isAllMonthTotalWtHundred && isEditable) || this.unLockIsOn;
  }

  get isButtonDisabledOfSubmitReviewApproval(): boolean {
    const today = new Date();
    var isEditable = true;
    if (this.toDate != null) {
      var toMonth = this.toDate?.split('-');
      var calculateMonth = null;
      var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
      if (selectedYearReviewCycle == 'Monthly') {
        calculateMonth = toMonth[0];
      } else {
        calculateMonth = toMonth[1];
      }
      if (this.pmsSetupInformationForm.value.cutoffDateApplicable) {
        const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate);
        calculatedCutoffDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
        let todayDateNumber = today.getTime();
        if (calculatedDateCutoffDateNumber < todayDateNumber) {
          const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate + this.pmsSetupInformationForm.value.gracePeriod);
          calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
          let todayDateNumber = today.getTime();
          if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {
            if (this.isKPIInRejectedState) {
              isEditable = true;
            } else {
              isEditable = false;
            }
          } else {
            isEditable = false;
          }
        } else {
          isEditable = true;
        }
      } else {
        isEditable = true;
      }
    }
    return (this.isAllMonthTotalWtHundred && isEditable && !this.goalSubmitReviewStatus) || this.unLockIsOn;
  }

  get isButtonDisabledOfSubmitReview(): boolean {
    const today = new Date();
    var isEditable = true;
    if (this.toDate != null) {
      var toMonth = this.toDate?.split('-');
      var calculateMonth = null;
      var selectedYearReviewCycle = this.sharedService.transform(this.selectedYearReviewCycle);
      if (selectedYearReviewCycle == 'Monthly') {
        calculateMonth = toMonth[0];
      } else {
        calculateMonth = toMonth[1];
      }
      if (this.pmsSetupInformationForm.value.cutoffDateApplicable) {
        const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate);
        calculatedCutoffDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
        let todayDateNumber = today.getTime();
        if (calculatedDateCutoffDateNumber < todayDateNumber) {
          const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(calculateMonth, this.pmsSetupInformationForm.value.cutoffDate + this.pmsSetupInformationForm.value.gracePeriod);
          calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
          let todayDateNumber = today.getTime();
          if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {
            if (this.isKPIInRejectedState) {
              isEditable = true;
            } else {
              isEditable = false;
            }
          } else {
            isEditable = false;
          }
        } else {
          isEditable = true;
        }
      } else {
        isEditable = true;
      }
    }
    return (this.goalReviewStatus && this.isAllMonthTotalWtHundred && isEditable && !this.goalApproveReviewStatus) || this.unLockIsOn;
  }
  reportColumnHeaderInfoData: any = [];
  reportColumnRowInfoData: any = [];
  renderDataCustomReportData: any = [];
  reportColumnHeaderInfo() {
    this.reportColumnHeaderInfoData = [];

    if (this.activeReportBtnName == 'Scorecard') {
      this.reportColumnHeaderInfoData.push({ label: 'Emp ID', propertyName: 'empId', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Emp Name', propertyName: 'empName', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KRA', propertyName: 'kra', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI', propertyName: 'kpi', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'WT', propertyName: 'wt', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI Score', propertyName: 'kpiscore', isVisible: true });
    }
    if (this.activeReportBtnName == 'All Employee -Month-YTD') {
      this.reportColumnHeaderInfoData.push({ label: 'Emp ID', propertyName: 'empId', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Emp Name', propertyName: 'empName', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Score', propertyName: 'Score', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI approval', propertyName: 'kpi', isVisible: true });
    }
    if (this.activeReportBtnName == 'KPI wise YTD') {
      this.reportColumnHeaderInfoData.push({ label: 'Emp ID', propertyName: 'empId', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Emp Name', propertyName: 'empName', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KRA', propertyName: 'kra', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI', propertyName: 'kpi', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Lesser is better', propertyName: 'lesserisbetter', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'WT', propertyName: 'wt', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI Score', propertyName: 'kpiscore', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'WT', propertyName: 'wt', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: '%ge achievement', propertyName: 'kpiscore', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI Score', propertyName: 'kpiscore', isVisible: true });
    }
    if (this.activeReportBtnName == 'Review Compliance Report') {
      this.reportColumnHeaderInfoData.push({ label: 'Emp ID', propertyName: 'empId', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Emp Name', propertyName: 'empName', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Department', propertyName: 'dept', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Manager', propertyName: 'manager', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Location', propertyName: 'loaction', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Score', propertyName: 'kpiscore', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Goal setting status', propertyName: 'goalsettingstatus', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Goal review status', propertyName: 'goalreviewstatus', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Approve/Reject by manager', propertyName: 'approvereject', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'MIS status', propertyName: 'misstatus', isVisible: true });
    }
    if (this.activeReportBtnName == 'Review Compliance Summary') {
      this.reportColumnHeaderInfoData.push({ label: 'Month', propertyName: 'month', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Active', propertyName: 'active', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Exited', propertyName: 'exited', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'GS Completed', propertyName: 'gs', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'GR Completed', propertyName: 'gr', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Approval By Manager', propertyName: 'approvalbymanager', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: '% GS Completed', propertyName: 'gscompleted', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: '% GR Completed', propertyName: 'grcompleted', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: '% Approval By Manager', propertyName: 'petapprovalbymanager', isVisible: true });
    }
    if (this.activeReportBtnName == 'Custom Report') {
      this.reportColumnHeaderInfoData.push({ label: 'Emp. ID', propertyName: 'empid', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Emp Name', propertyName: 'empname', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Email', propertyName: 'email', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Date of Joining', propertyName: 'dateofjoining', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Date of Exit', propertyName: 'dateofeod', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Month', propertyName: 'month', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Manager', propertyName: 'manager', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Department', propertyName: 'department', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Location', propertyName: 'location', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KRA', propertyName: 'kra', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI', propertyName: 'kpi', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Review Cycle', propertyName: 'reviewcycle', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Lesser is Better', propertyName: 'lesserisbetter', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Milestone From', propertyName: 'milestonefrom', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Milestone To', propertyName: 'milestoneto', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'WT', propertyName: 'wt', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'UOM', propertyName: 'uom', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Target', propertyName: 'target', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Actual', propertyName: 'actual', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: '% Achivement', propertyName: 'achivement', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'KPI Score', propertyName: 'kpiscore', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Approval/Reject status', propertyName: 'reviewstatus', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Employee Comment', propertyName: 'empcomment', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Manager Comment', propertyName: 'managercomment', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'Dotted Manager Comment', propertyName: 'managercomment', isVisible: true });
      this.reportColumnHeaderInfoData.push({ label: 'MIS Attachment', propertyName: 'missattchment', isVisible: true });
    }
  }
  renderDataOfReport(listData: any) {
    this.reportColumnRowInfoData = [];
    this.renderDataCustomReportData = [];
    if (this.activeReportBtnName == 'Review Compliance Summary') {
      for (let i = 0; i < listData?.length; i++) {
        this.reportColumnRowInfoData.push({
          month: listData[i].month,
          active: listData[i].active,
          exited: listData[i].exited,
          gs: listData[i].gs,
          gr: listData[i].gr,
          approvalbymanager: listData[i].managerApproval,
          gscompleted: listData[i].percentageGsCompleted,
          grcompleted: listData[i].percentageGrCompleted,
          petapprovalbymanager: listData[i].percentageManagerApproval
        });
      }
    }
    if (this.activeReportBtnName == 'Custom Report') {
      for (let i = 0; i < listData?.length; i++) {
        this.reportColumnRowInfoData.push({
          empid: listData[i].employeeId,
          empname: listData[i].firstName + ' ' + listData[i].lastName,
          email: listData[i].officialEmail,
          dateofjoining: this.datePipe.transform(listData[i]?.dateOfJoining, 'dd-MM-yyyy'),
          dateofeod: this.datePipe.transform(listData[i]?.dateOfExit, 'dd-MM-yyyy'),
          month: listData[i].month,
          manager: listData[i].reportingmanagercode,
          department: listData[i].department,
          location: listData[i].location,
          kra: listData[i].kra,
          kpi: listData[i].kpi,
          reviewcycle: listData[i].reviewCycle,
          lesserisbetter: listData[i].lesserIsBetter,
          milestonefrom: listData[i].milestoneFrom,
          milestoneto: listData[i].milestoneTo,
          wt: listData[i].weightage,
          uom: listData[i].uom,
          target: listData[i].target,
          actual: listData[i].actual,
          achivement: listData[i].percentageAchievement,
          kpiscore: listData[i].kpiScore,
          reviewstatus: listData[i].reviewStatus,
          empcomment: listData[i].employeeComment,
          managercomment: listData[i].managerComment,
          missattchment: listData[i].misAttachment
        });
      }
    }
    this.mapRenderData();
  }
  mapRenderData() {
    this.renderDataCustomReportData = [];
    for (let i = 0; i < this.reportColumnRowInfoData.length; i++) {
      var output = Object.entries(this.reportColumnRowInfoData[i]).map(([key, value]) => ({ key, value }));
      this.renderDataCustomReportData.push(output);
    }
  }
  downloadExcelReport() {
    if (this.searchKpiReportString == '') {
      this.searchKpiString = null;
    }
    var userIds: any[] = [];
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
      if (window.innerWidth <= 800) {
        userIds.push(this.selectedUserForKPIReport);
      } else {
        userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
      }
    } else {
      if (this.selectedGoalForEmp == 'My Goals') {
        userIds.push(this.loggedInUserId);
      }
      if (this.selectedGoalForEmp == 'Team Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.selectedGoalForEmp == 'Dept Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          if (this.isAllEmpForReportToggle) {
            userIds = this.teamOfManagerList?.map((ele: { id: any }) => ele.id);
            userIds.push(this.loggedInUserId);
          }
        }
      }
    }
    if (this.activeReportBtnName == 'Scorecard') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.downloadScoreCardReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'All Employee -Month-YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.downloadMonthYTDReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'KPI wise YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.downloadYTDWiseKPIReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Review Compliance Report') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.downloadReviewCompilenceReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Review Compliance Summary') {
      let departmentForReport: any[] = [];
      if (window.innerWidth <= 800) {
        departmentForReport.push(this.selectedDepartmentForReport);
      } else {
        departmentForReport = this.selectedDepartmentForReport?.map((ele: { id: any }) => ele.id);
      }
      const request = {
        deptName: departmentForReport,
        summaryType: this.selectedSummaryTypeForReport,
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        loggedInUserRole: this.loggedInUserRole
      };
      this.httpService.callPostService(this.config.downloadExcelReviewComplianceSummaryReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Custom Report') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds,
        loggedInUserRole: this.loggedInUserRole
      };
      this.httpService.callPostService(this.config.downloadCustomReportExcel, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
    }
  }
  downloadPdfReport() {
    var userIds: any[] = [];
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
      if (window.innerWidth <= 800) {
        userIds.push(this.selectedUserForKPIReport);
      } else {
        userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
      }
    } else {
      if (this.selectedGoalForEmp == 'My Goals') {
        userIds.push(this.loggedInUserId);
      }
      if (this.selectedGoalForEmp == 'Team Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.selectedGoalForEmp == 'Dept Goals') {
        if (window.innerWidth <= 800) {
          userIds.push(this.selectedUserForKPIReport);
        } else {
          userIds = this.selectedUserForKPIReport?.map((ele: { id: any }) => ele.id);
        }
      }
      if (this.activeReportBtnName == 'All Employee -Month-YTD' || this.activeReportBtnName == 'Review Compliance Report') {
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          if (this.isAllEmpForReportToggle) {
            userIds = this.teamOfManagerList?.map((ele: { id: any }) => ele.id);
            userIds.push(this.loggedInUserId);
          }
        }
      }
    }
    if (this.activeReportBtnName == 'Scorecard') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.generateScoreCardPDFReportV2, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'All Employee -Month-YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.generateMonthYTDPDFReportV2, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'KPI wise YTD') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.generateKPIwiseYTDPDFReportV2, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Review Compliance Report') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: this.selectedReviewCycle?.map((ele: { id: any }) => ele.id),
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.generateReviewCompliencePDFReportV2, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Review Compliance Summary') {
      let departmentForReport: any[] = [];
      if (window.innerWidth <= 800) {
        departmentForReport.push(this.selectedDepartmentForReport);
      } else {
        departmentForReport = this.selectedDepartmentForReport?.map((ele: { id: any }) => ele.id);
      }
      const request = {
        deptName: departmentForReport,
        summaryType: this.selectedSummaryTypeForReport,
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: this.loggedInUserId,
        loggedInUserRole: this.loggedInUserRole
      };
      this.httpService.callPostService(this.config.downloadPdfReviewComplianceSummaryReport, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
    if (this.activeReportBtnName == 'Custom Report') {
      const request = {
        compId: this.loggedInUserCompanyID,
        fromYear: this.fromYear,
        month: [],
        search: this.searchKpiReportString,
        toYear: this.toYear,
        userId: userIds
      };
      this.httpService.callPostService(this.config.generateCustomPDFReport, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
  }
  changeSummaryReport() {
    if (this.selectedSummaryTypeForReport == 'Company Summary') {
      if (window.innerWidth <= 800) {
        this.selectedDepartmentForReport = null;
      } else {
        this.selectedDepartmentForReport = [];
      }
    }
  }
  getEmpsByDept() {
    if (this.loggedInUserRole == 'Admin') {
      const request = {
        companyId: this.loggedInUserCompanyID,
        depts: this.selectedDepartmentsForReport?.map((ele: { id: any }) => ele.id),
        from: this.fromDate,
        fromYear: this.fromYear,
        moduleName: 'PMS',
        to: this.toDate,
        toYear: this.toYear,
        userId: this.loggedInUserId
      };
      this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
        this.employeeListByDept = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.employeeListByDept.push(obj);
        });
        this.employeeListByDept = this.employeeListByDept.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    } else {
      const request = {
        companyId: this.loggedInUserCompanyID,
        department: null,
        departments: this.selectedDepartmentsForReport?.map((ele: { id: any }) => ele.id),
        from: this.reportFormMonth,
        fromYear: this.fromYear,
        to: this.reportToMonth,
        toYear: this.toYear
      };
      this.httpService.callPostService(this.config.getEmpsByDeptByDate, request).subscribe((data: any) => {
        this.employeeListByDept = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName
          };
          this.employeeListByDept.push(obj);
        });
        this.employeeListByDept = this.employeeListByDept.sort((a: any, b: any) => a.name.localeCompare(b.name));
      });
    }
  }
  onClickRecalculate(recalculate: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to ' + recalculate + '?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var pendingIds = [];
        if (recalculate == 'recalculate all') {
          pendingIds = [];
        } else {
          pendingIds = this.kpiDataListByUser?.filter((item: { reviewStatus: string }) => item.reviewStatus === 'Pending').map((item: { id: any }) => item.id);
        }
        this.loader.simpleLoaderWithDuration();
        const request = {
          compId: this.loggedInUserCompanyID,
          from: this.fromDate,
          fromYear: this.fromYear,
          goalId: pendingIds,
          status: true,
          to: this.toDate,
          toYear: this.toYear,
          userId: this.selectedUserForKPISearch,
          loggedInUserRole: this.loggedInUserRole
        };
        this.httpService.callPostService(this.config.recalculateScore, request).subscribe(
          (res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: res.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.selectedKPIList = [];
              this.getKPIsByDateRange();
            });
          },
          (err: any) => {
            this.loader.dismissLoader();
            console.log(err);
          }
        );
      }
    });
  }
  showingCount: any = 1;
  showingOfCount: any = 0;
  previousPageTotalCount: any = 0;
  paginationCountData() {
    if (this.previousPageTotalCount != this.totalKpis) {
      this.showingCount = 1;
      this.showingOfCount = 0;
    }
    if (this.currentPageNumberOfKpis - 1 == 0) {
      this.showingCount = 1;
      this.showingOfCount = 0;
    }
    if (this.totalKpis >= this.kpiDataListByUser.length) {
      if (this.selectedSizeOfPMS == this.kpiDataListByUser.length) {
        this.showingOfCount = (this.currentPageNumberOfKpis - 1 + 1) * this.selectedSizeOfPMS;
      } else {
        this.showingOfCount = this.showingOfCount + this.kpiDataListByUser.length;
      }
      this.previousPageTotalCount = this.totalKpis;
    }
    if (this.currentPageNumberOfKpis - 1 == 0) {
      this.showingCount = 1;
    } else {
      this.showingCount = this.selectedSizeOfPMS * (this.currentPageNumberOfKpis - 1) + 1;
    }
  }
  formMonthChange() {
    this.toDate = null;
    this.getToMonths(this.fromDate);
    // this.selectedDeptForKPISearch = null;
    // this.teamOfManagerList = [];
    // if (this.selectedTypeTabName == 'My Goals') {
    //   this.selectedUserForKPISearch = this.loggedInUserId;
    // }else{
    //   this.selectedUserForKPISearch = null;
    // }
  }
  selectAllOnReportDept(items: any): void {
    this.selectedDepartmentsForReport = items;
    this.getEmpsByDept();
  }
  onDeSelectAllReportDept() {
    this.selectedDepartmentsForReport = [];
    this.employeeListByDept = [];
    this.selectedUserForKPIReport = [];
  }
  selectAllReportEmp(items: any): void {
    this.selectedUserForKPIReport = items;
  }
  onDeSelectAllReportEmp() {
    this.selectedUserForKPIReport = [];
  }
  selectAllReportMonth(items: any): void {
    this.selectedReviewCycle = items;
    this.selectedDepartmentsForReport = [];
    this.selectedUserForKPIReport = [];
    const indexMap = new Map(this.getMonthsByFiscalandReviewCycleForReport.map((item, index) => [item.id, index]));
    const sortedSecondArray = this.selectedReviewCycle.sort((a, b) => {
      const indexA = indexMap.get(a.id);
      const indexB = indexMap.get(b.id);
      return (indexA !== undefined ? indexA : Infinity) - (indexB !== undefined ? indexB : Infinity);
    });

    if (sortedSecondArray.length != 0) {
      this.reportFormMonth = sortedSecondArray[0]?.id;
      this.reportToMonth = sortedSecondArray[sortedSecondArray.length - 1]?.id;
    }
  }
  onDeSelectAllReportMonth() {
    this.selectedReviewCycle = [];
    this.selectedDepartmentsForReport = [];
    this.selectedUserForKPIReport = [];
  }
  reportFormMonth: any;
  reportToMonth: any;
  onDeSelectMonthReport() {
    this.selectedDepartmentsForReport = [];
    this.selectedUserForKPIReport = [];
    const indexMap = new Map(this.getMonthsByFiscalandReviewCycleForReport.map((item, index) => [item.id, index]));
    const sortedSecondArray = this.selectedReviewCycle.sort((a, b) => {
      const indexA = indexMap.get(a.id);
      const indexB = indexMap.get(b.id);
      return (indexA !== undefined ? indexA : Infinity) - (indexB !== undefined ? indexB : Infinity);
    });

    if (sortedSecondArray.length != 0) {
      this.reportFormMonth = sortedSecondArray[0]?.id;
      this.reportToMonth = sortedSecondArray[sortedSecondArray.length - 1]?.id;
    }
  }
  onSelectMonthReport() {
    this.selectedDepartmentsForReport = [];
    this.selectedUserForKPIReport = [];
    const indexMap = new Map(this.getMonthsByFiscalandReviewCycleForReport.map((item, index) => [item.id, index]));
    const sortedSecondArray = this.selectedReviewCycle.sort((a, b) => {
      const indexA = indexMap.get(a.id);
      const indexB = indexMap.get(b.id);
      return (indexA !== undefined ? indexA : Infinity) - (indexB !== undefined ? indexB : Infinity);
    });
    if (sortedSecondArray.length != 0) {
      this.reportFormMonth = sortedSecondArray[0]?.id;
      this.reportToMonth = sortedSecondArray[sortedSecondArray.length - 1]?.id;
    }
  }
  scorecardShowEmplIDCol: boolean = true;
  scorecardShowEmpNameCol: boolean = true;
  scorecardShowKRACol: boolean = true;
  scorecardShowkpiCol: boolean = true;
  scorecardShowWTCol: boolean = true;
  scorecardShowKpiScoreCol: boolean = true;
  updateHideShowColReport(colHeaderName: any, isVisible: any) {
    if (this.activeReportBtnName == 'Scorecard') {
      if (colHeaderName == 'Emp ID') {
        this.scorecardShowEmplIDCol = isVisible;
      }
      if (colHeaderName == 'Emp Name') {
        this.scorecardShowEmpNameCol = isVisible;
      }
      if (colHeaderName == 'KRA') {
        this.scorecardShowKRACol = isVisible;
      }
      if (colHeaderName == 'KPI') {
        this.scorecardShowkpiCol = isVisible;
      }
      if (colHeaderName == 'WT') {
        this.scorecardShowWTCol = isVisible;
      }
      if (colHeaderName == 'KPI Score') {
        this.scorecardShowKpiScoreCol = isVisible;
      }
    }
    if (this.activeReportBtnName == 'All Employee -Month-YTD') {
    }
    if (this.activeReportBtnName == 'KPI wise YTD') {
    }
    if (this.activeReportBtnName == 'Review Compliance Report') {
    }
    if (this.activeReportBtnName == 'Review Compliance Summary') {
    }
    if (this.activeReportBtnName == 'Custom Report') {
    }
  }
  downloadMisFile(url: any, fileName: any) {
    console.log(url, fileName);

    saveAs(url, fileName);
    // this.viewDocument(fileName);
  }

  viewDocument(fileUrl: string): void {
    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  chnageCutOffDate() {
    if (this.pmsSetupInformationForm.value.cutoffDate == 30) {
      this.numbersOfDaysForGracePeriod = [0];
      this.pmsSetupInformationForm.controls['gracePeriod'].setValue(0);
    } else {
      this.pmsSetupInformationForm.controls['gracePeriod'].setValue(null);
      this.numbersOfDaysForGracePeriod = Array.from({ length: 31 - this.pmsSetupInformationForm.value.cutoffDate }, (_, i) => i);
    }
  }
  minimumValueValidator(minValue: number) {
    return (control: { value: any }) => {
      const value = control.value;
      if (isNaN(value) || value < minValue) {
        return {
          minValue: {
            valid: false,
            min: minValue
          }
        };
      }
      return null;
    };
  }
  isInValidMaxRange = false;
  isInValidNormalizScore = false;
  onMaxRangeChange(data: any) {
    if (data.maxRange > data.minRange || isNaN(data.maxRange)) {
      this.isInValidMaxRange = false;
    } else {
      this.isInValidMaxRange = true;
    }
  }
  checkNonZero(data: any) {
    if (data.normalizeScore < 0 || isNaN(data.normalizeScore)) {
      this.isInValidNormalizScore = true;
    } else {
      this.isInValidNormalizScore = false;
    }
  }
  onSelectCapChnage() {
    const addScores = this.pmsSetupInformationForm.get('addScores') as FormArray;
    addScores.clear();
    this.addedScores = [];
  }
  selectAllDept(items: any): void {
    this.selectedDeptForKPISearch = items;
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDate();
    } else {
      this.getAllEmployeesByDept();
    }
  }
  onSelectDeptOfEmpGoals() {
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDate();
    } else {
      this.getAllEmployeesByDept();
    }
  }
  onDeSelectAllDept() {
    this.selectedDeptForKPISearch = [];
    this.selectedUserForKPISearch = null;
  }
  onClickChroneJob() {
    this.httpService.callGetService(this.config.runCutOff).subscribe((data: any) => {});
  }
  onDeSelectAllDeptForReport() {
    this.selectedDepartmentForReport = [];
  }
  selectAllDeptForReport(data: any) {
    this.selectedDepartmentForReport = data;
  }
  onClickBack() {
    // this.showMangerTable = true;
    this.isBackBtnPress = true;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'Admin') {
      if (this.scoreCardtrendMangerID == null) {
        this.showMangerTable = true;
        this.compnayScoreCard();
      } else {
        this.showMangerTable = false;
        this.employeeScoreCard(this.scoreCardtrendMangerID);
      }
    } else {
      if (this.companyScoreCardTrendManagerId == this.loggedInUserId) {
        this.showMangerTable = true;
        this.compnayScoreCard();
      } else {
        this.showMangerTable = false;
        this.employeeScoreCard(this.scoreCardtrendMangerID);
      }
    }
  }
  managerName: any;
  scoreCardtrendMangerID: any = null;
  companyScoreCardTrendManagerId: any = null;
  isBackBtnPress: boolean = false;
  onClickManagerData(item: any) {
    if (!item.isEmployee) {
      this.showMangerTable = false;
      this.isBackBtnPress = false;
      this.managerName = item.managerName;
      this.companyScoreCardTrendManagerId = item.managerId;
      this.employeeScoreCard(item.id);
    }
  }

  employeeScoreCard(id: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: null,
      name: null,
      type: '',
      userId: id,
      year: this.selectedYearForCompanyScoreTrend,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.companyScoreCard, request).subscribe((data: any) => {
      this.companyScoreMonths = data.data.months.map((month: any) => ({ months: month }));
      // Get employee data
      this.employeeData = [];
      for (let i = 0; i < data.data.response.length; i++) {
        const employeeResponse = data.data.response[i];
        const kpiScores = employeeResponse.response.map((kpi: any) => ({
          kpiScore: kpi.kpiScore,
          month: kpi.month
        }));

        this.employeeData.push({
          managerName: `${employeeResponse.firstName} ${employeeResponse.lastName}`,
          ytdScore: employeeResponse.ytd,
          kpiScores: kpiScores,
          id: employeeResponse.id,
          managerId: employeeResponse.managerId,
          managersManagerId: employeeResponse.managersManagerId,
          managersManagerName: employeeResponse.managersManagerName,
          managerNames: employeeResponse.managerName,
          isEmployee: data?.data?.response[i]?.isEmployee
        });
      }
      if (this.employeeData.length != 0) {
        this.scoreCardtrendMangerID = this.employeeData[0]?.managersManagerId;
        if (this.isBackBtnPress) {
          this.managerName = this.employeeData[0]?.managerNames;
        }
        this.companyScoreCardTrendManagerId = this.employeeData[0]?.managerId;
      }
    });
  }

  getKpiScoreForMonth(kpiScores: any[], month: string): number {
    const score = kpiScores.find(kpi => kpi.month === month);
    return score ? score.kpiScore : 0;
  }
  mergeArrays(dataArray: any[], totalArray: any[]): any[] {
    return dataArray.map((item, index) => {
      return { ...item, ...totalArray[index] };
    });
  }
  onClickEyeIcon(data: any) {
    const pairs = this.mergeArrays(this.companyScoreMonths, this.kpiScoreData);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    // dialogConfig.width = '62%';
    dialogConfig.width = this.mobileResponsiveService.modelWidthForMobileDevice;
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      btn2: 'OK',
      popupName: 'Company Score Trend',
      month: this.fromDate,
      name: data.managerName,
      year: this.selectedYearForCompanyScoreTrend,
      btn2BgColor: '#CC0000',
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false,
      graphData: pairs,
      ytdScore: data?.ytdScore,
      downloadGraphID: data?.id
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(DashboardDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});

    // const successdialogRef = this.dialog.open(DashboardDetailsPopupComponent, {
    //   disableClose: true,
    //   height: '40%',
    //   width: '80%',
    //   data: {
    //     btn2: 'OK',
    //     popupName: 'Company Score Trend',
    //     month: this.fromDate,
    //     name: managerName,
    //     year: this.selectedYearForCompanyScoreTrend,
    //     btn2BgColor: '#CC0000',
    //     showSuccessIcon: true,
    //     showSuccessMessage: false,
    //     showCloseIcon: false
    //   },
    // });
    // successdialogRef.afterClosed().subscribe(result => { });
  }
  onClickEmployeeEyeIcon(data: any) {
    var graphDataToShow: { months: any; kpiScore: any }[] = [];
    data?.kpiScores?.forEach((ele: any) => {
      let obj = {
        months: ele.month,
        kpiScore: ele.kpiScore
      };
      graphDataToShow.push(obj);
    });
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    // dialogConfig.width = '62%';
    dialogConfig.width = this.mobileResponsiveService.modelWidthForMobileDevice;
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      btn2: 'OK',
      popupName: 'Company Score Trend',
      month: this.fromDate,
      name: data?.employeeName,
      year: this.selectedYearForCompanyScoreTrend,
      btn2BgColor: '#CC0000',
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false,
      graphData: graphDataToShow,
      ytdScore: data?.ytdScore,
      downloadGraphID: data?.id
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(DashboardDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});

    // const successdialogRef = this.dialog.open(DashboardDetailsPopupComponent, {
    //   disableClose: true,
    //   height: '40%',
    //   width: '80%',
    //   data: {
    //     btn2: 'OK',
    //     popupName: 'Company Score Trend',
    //     month: this.fromDate,
    //     name: employeeName,
    //     year: this.selectedYearForCompanyScoreTrend,
    //     btn2BgColor: '#CC0000',
    //     showSuccessIcon: true,
    //     showSuccessMessage: false,
    //     showCloseIcon: false
    //   },
    // });
    // successdialogRef.afterClosed().subscribe(result => { });
  }
  compnayScoreCard() {
    var loggedUser = 'LoggedUser';
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      id = this.loggedInCompanyMDID;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: null,
      name: null,
      type: loggedUser,
      userId: id,
      year: this.selectedYearForCompanyScoreTrend,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.companyScoreCard, request).subscribe((data: any) => {
      this.showMangerTable;
      this.companyScoreMonths = [];
      this.managerData = [];
      this.kpiScoreData = [];

      this.companyScoreMonths = data.data.months.map((month: any) => ({ months: month }));
      for (let i = 0; i < data?.data?.response?.length; i++) {
        const employeeResponse = data.data.response[i];
        const kpiScores = employeeResponse.response.map((kpi: any) => ({
          kpiScore: kpi.kpiScore,
          month: kpi.month
        }));
        this.managerData.push({
          managerName: data?.data?.response[i].firstName + ' ' + data?.data?.response[i].lastName,
          ytdScore: this.sharedService.formatDecimalValue(data?.data?.response[i].ytd),
          id: data?.data?.response[i].id,
          managerId: data?.data?.response[i].managerId,
          managersManagerId: data?.data?.response[i].managersManagerId,
          managersManagerName: data?.data?.response[i].managersManagerName,
          kpiScores: kpiScores,
          isEmployee: data?.data?.response[i]?.isEmployee
        });

        for (let k = 0; k < data?.data?.response[i].response?.length; k++) {
          this.kpiScoreData.push({
            kpiScore: data?.data?.response[i].response[k]?.kpiScore
          });
        }
        if (this.managerData.length != 0) {
          this.scoreCardtrendMangerID = this.managerData[0]?.managersManagerId;
        }
      }
    });
  }
  //Dashboard
  chnageSelectYearDashboard() {
    this.selectedYearTtdTable = this.selectedYear;
    this.selectedYearForCompanyScoreTrend = this.selectedYear;
    this.selectedKpiScoreSummaryYear = this.selectedYear;
    this.selectedYearTargetVsActual = this.selectedYear;
    this.selectedPerformingKpiYear = this.selectedYear;
    this.selectedYearForTopTenKpi = this.selectedYear;
    this.selectedlastThreeYearKpiScoreKpiYear = this.selectedYear;

    this.fromDate = null;
    this.toDate = null;
    this.fromDateGloabalDashboard = null;
    var year = this.selectedYear?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  formMonthChangeDashboard() {
    this.fromDateYtdTable = this.fromDateGloabalDashboard;
    this.selectedKpiScoreSummaryfromDate = this.fromDateGloabalDashboard;
    this.selectedPerformingKpifromDate = this.fromDateGloabalDashboard;
    this.fromDateForTopTenKpi = this.fromDateGloabalDashboard;
    this.fromDateGloabalDashboard = this.fromDateGloabalDashboard;
    this.getTeamOfManagerForTargetVSActual();
    this.getTeamOfManagerForPreviousThreeYearData();
    this.getTeamOfManagerForTopFourKPI();
    this.getTeamOfManagerForPerformingKPI();
    this.getTeamOfManagerForKPISummary();
    this.getDashboardCount();
  }
  onClickCard(event: any) {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      popupName: 'Quarterly Vs YTD',
      month: this.fromDateGloabalDashboard,
      year: this.selectedYear,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(DashboardDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
    // const successdialogRef = this.dialog.open(DashboardDetailsPopupComponent, {
    //   disableClose: true,
    //   height: '50%',
    //   width: '70%',
    //   data: {
    //     btn2: 'OK',
    //     moduleName: event,
    //     popupName: 'Quarterly Vs YTD',
    //     month: this.fromDate,
    //     year: this.selectedYear,
    //     btn2BgColor: this.buttonColorName,
    //     showSuccessIcon: true,
    //     showSuccessMessage: false,
    //     showCloseIcon: false
    //   },
    // });
    // successdialogRef.afterClosed().subscribe(result => { });
  }
  onClickImport() {
    this.router.navigate(['/home/hrportal/importFiles', { module: 'importgoals' }]);
  }
  selectedYearTtdTable: any;
  fromDateYtdTable: any;
  selectedKpiScoreSummaryYear: any;
  selectedKpiScoreSummaryfromDate: any;
  kpiGoalSummaryData: any = [];
  selectedYearTargetVsActual: any;
  selectedUserTargetVsActual: any;
  selectedKpiTargetVsActual: any;
  selectedUomTargetVsActual: any;
  selectedPerformingKpiYear: any;
  selectedPerformingKpifromDate: any;
  selectedPerformingKpiUser: any;
  selectedYearForTopTenKpi: any;
  selectedUserForlastThreeYearKpiScoreKpi: any;
  selectedlastThreeYearKpiScoreKpiYear: any;
  fromDateForTopTenKpi: any;
  fromDateGloabalDashboard: any;
  chnageSelectYearDashboardYtdTable() {
    var year = this.selectedYearTtdTable?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  formMonthChangeDashboardYtdTable() {
    this.getYtdVsScore();
  }
  getTeamListOfloggedInUser: any;
  ///Dashboard

  yearList: any = [];
  monthList: any = [];
  chatOptions: any;
  cutOffDate: any;
  capValue: any;
  pmsMonths: any = [];
  getYtdReport: any = [];
  getTeamList: any = [];
  moduleName: any;
  kpiUsersList: any = [];
  showQuarterlyBarChart: boolean = false;
  hideQuarterlyTable: boolean = true;
  showQuarterlyLineChart: boolean = false;
  goalsettingId: any;
  targetVsActualChartData: any = [];
  topPerformingKpiData: any = [];
  bottomPerformingKpiData: any = [];
  showKpiScoreTableChart: boolean = false;
  showKpiScoreBarChart: boolean = false;
  showKpiScorePieChart: boolean = true;
  showKpiScoreLineChart: boolean = false;
  kpiGoalSummaryTableData: any = [];

  showTargetTable: boolean = false;
  showTargetBarChart: any = true;
  showTargetLineChart: any = false;
  showTargetPieChart: any = false;
  actualChartPieChartData: any = [];
  targetChartPieChartData: any = [];

  showPerformingTable: boolean = false;
  showPerformingBar: boolean = false;
  showPerformingLine: boolean = true;
  showPerformingPie: boolean = false;
  topPerformingKpiPieData: any;
  bottomPerformingKpiPieData: any;
  topFourKpiWeithageData: any = [];
  secondKpiWeithageData: any = [];
  firstKpiWeithageData: any = [];
  kpi1: any;
  kpi2: any;
  kpi3: any;
  kpi4: any;
  thirdKpiWeithageData: any = [];
  fourthKpiWeithageData: any = [];
  showTopTenKpiTable: boolean = false;
  showTopTenKpiBar: boolean = true;
  showTopTenKpiLine: boolean = false;
  showTopTenKpiPie: boolean = false;
  kpiList: any = [];
  selectedUser: any;
  selectedKpi: any;
  selectedUom: any;
  selectedKpiUser: any;
  capSelect: any;
  valueSelect: any;
  addScoreData: any;
  minRange: any;
  maxRange: any;
  comment: any;
  employeeName: any;
  indexId: any;
  employeeScoreKpiScore: any = [];
  showKpiScoreAreaChart: boolean = false;

  getDashboardCount() {
    const isAdmin = ['Super Admin', 'PHI Admin', 'HR Admin'].includes(this.loggedInUserRole?.trim());

    console.log(this.loggedInCompanyMDID);

    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.fromDateGloabalDashboard,
      // "userId": Checkid,
      userId: isAdmin ? this.loggedInMDID : this.loggedInUserId,
      year: this.selectedYear,
      loggedInUserRole: this.loggedInUserRole
    };
    console.log(request);

    this.httpService.callPostService(this.config.dashboardCount, request).subscribe((data: any) => {
      this.dashboardCounterModule.forEach((item: any) => {
        console.log(item);

        if (item.ModuleName == 'Active Employees') {
          item.totalCount = data.countOfActiveEmployee;
        }
        if (item.ModuleName == 'Exited Employees') {
          item.totalCount = data.countOfExitedEmployee;
        }
        if (item.ModuleName == 'Goal Setting Status') {
          item.totalCount = data.countOfGoalSetting;
        }
        if (item.ModuleName == 'Goal Review Status') {
          item.totalCount = data.countOfReviewStatus;
        }
        if (item.ModuleName == 'Manager Approval Status') {
          item.totalCount = data.countOfManagerApprovalStatus;
        }
        if (item.ModuleName == 'My Goal Setting Status') {
          item.totalCount = data.countOfMyGoalSetting;
        }
        if (item.ModuleName == 'My Goal Review Status') {
          item.totalCount = data.countOfMyReviewStatus;
        }
        if (item.ModuleName == 'My Approved Status') {
          item.totalCount = data.countOfMyApprovedStatus;
        }
      });
    });
  }

  getTopPerformingKpiData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.selectedPerformingKpifromDate,
      name: null,
      type: null,
      userId: this.selectedPerformingKpiUser,
      year: this.selectedPerformingKpiYear
    };
    this.httpService.callPostService(this.config.topPerformingKpi, request).subscribe((data: any) => {
      this.topPerformingKpiData = [];
      for (let i = 0; i < data?.data?.gsi.length; i++) {
        this.topPerformingKpiData.push({
          kpi: data?.data?.gsi[i]?.kpi,
          kpiScore: this.sharedService.formatDecimalValue(data?.data?.gsi[i].percentageAchievement)
        });
      }
      // this.performingKPILineChartBottom();
      // this.performingKPILineChartTop();
      // this.PerforminingBarBottomChart();
      // this.PerforminingBarTopChart();
      // this.PerformoningPieChartTop();
      // this.PerformoningPieChartBottom();
      this.initChartPerfomanceOfKpi();
      this.chartOptionsTopPerfomanceOfKpi.line = this.getLineChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      this.chartOptionsTopPerfomanceOfKpi.bar = this.getBarChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      this.chartOptionsTopPerfomanceOfKpi.pie = this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      this.chartOptionsTopPerfomanceOfKpi.area = this.getAreaChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      // Set the chart to default type initially
      this.setChartTypePerfomanceOfKpi('line');
    });
  }
  perfomanceOfKpiGraphType: any = 'line';
  setChartTypePerfomanceOfKpi(type: string) {
    this.perfomanceOfKpiGraphType = type;
    this.showPerformingTable = false;
    const dom1 = document.getElementById('topPerfomanceOfKpi') as HTMLDivElement;
    const dom2 = document.getElementById('bottomPerfomanceOfKpi') as HTMLDivElement;
    this.chartTopPerfomanceOfKpi = echarts.init(dom1);
    this.chartBottomPerfomanceOfKpi = echarts.init(dom2);
    if (this.chartTopPerfomanceOfKpi) {
      this.chartTopPerfomanceOfKpi.setOption(this.chartOptionsTopPerfomanceOfKpi[type]);
      this.chartBottomPerfomanceOfKpi.setOption(this.chartOptionsBottomPerfomanceOfKpi[type]);
      if (type == 'pie') {
        this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
        this.getPieChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      }
      if (type == 'line') {
        this.getLineChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
        this.getLineChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      }
      if (type == 'bar') {
        this.getBarChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
        this.getBarChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      }
      if (type == 'area') {
        this.getAreaChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
        this.getAreaChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartTopPerfomanceOfKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartBottomPerfomanceOfKpi);
  }
  initChartPerfomanceOfKpi() {
    const dom1 = document.getElementById('topPerfomanceOfKpi') as HTMLDivElement;
    const dom2 = document.getElementById('bottomPerfomanceOfKpi') as HTMLDivElement;
    this.chartTopPerfomanceOfKpi = echarts.init(dom1);
    this.chartBottomPerfomanceOfKpi = echarts.init(dom2);
    this.setChartTypePerfomanceOfKpi('line'); // Set default chart type
    this.mobileResponsiveService.chartResizeFn(this.chartTopPerfomanceOfKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartBottomPerfomanceOfKpi);
  }
  getLineChartOptionsTopPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopPerfomanceOfKpi) {
        this.chartTopPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      series: [
        {
          name: ' KPIs',
          type: 'line',
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: '#393186' },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getBarChartOptionsTopPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopPerfomanceOfKpi) {
        this.chartTopPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      series: [
        {
          name: ' KPIs',
          type: 'bar',
          barWidth: 20,
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: '#393186' },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getPieChartOptionsTopPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopPerfomanceOfKpi) {
        this.chartTopPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'item',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false }, // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptionsTopPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopPerfomanceOfKpi) {
        this.chartTopPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      xAxis: {
        show: true,
        type: 'category',
        boundaryGap: false,
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      series: [
        {
          areaStyle: {},
          name: ' KPIs',
          type: 'line',
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: '#393186' },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getLineChartOptionsBottomPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartBottomPerfomanceOfKpi) {
        this.chartBottomPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      series: [
        {
          name: ' KPIs',
          type: 'line',
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getBarChartOptionsBottomPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartBottomPerfomanceOfKpi) {
        this.chartBottomPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      series: [
        {
          name: 'KPIs',
          type: 'bar',
          barWidth: 20,
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getPieChartOptionsBottomPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartBottomPerfomanceOfKpi) {
        this.chartBottomPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false }, // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptionsBottomPerfomanceOfKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartBottomPerfomanceOfKpi) {
        this.chartBottomPerfomanceOfKpi.clear();
      }
      return {};
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999,
        formatter: function (params: any) {
          return `
            <div style="width: 200px; white-space: normal; word-wrap: break-word;">
              <span>${params[0].axisValue}</span><br>
              ${params.map((item: any) => `${item.seriesName}: ${item.data}`).join('<br>')}
            </div>`;
        }
      },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        name: '℅ge Achievement',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10
        }
      },
      xAxis: {
        show: true,
        type: 'category',
        boundaryGap: false,
        data: data.map((ele: { kpi: any }) => ele.kpi),
        name: 'KPI',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6
        },
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      series: [
        {
          areaStyle: {},
          name: ' KPIs',
          type: 'line',
          data: data.map((ele: { kpiScore: any }) => ele.kpiScore),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }

  getBottomPerformingKpiData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.selectedPerformingKpifromDate,
      name: null,
      type: null,
      userId: this.selectedPerformingKpiUser,
      year: this.selectedPerformingKpiYear
    };
    this.httpService.callPostService(this.config.bottomPerformingKpi, request).subscribe((data: any) => {
      this.bottomPerformingKpiData = [];
      for (let i = 0; i < data?.data?.gsi.length; i++) {
        this.bottomPerformingKpiData.push({
          kpi: data?.data?.gsi[i]?.kpi,
          kpiScore: this.sharedService.formatDecimalValue(data?.data?.gsi[i].percentageAchievement)
        });
      }
      this.initChartPerfomanceOfKpi();
      this.chartOptionsBottomPerfomanceOfKpi.line = this.getLineChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      this.chartOptionsBottomPerfomanceOfKpi.bar = this.getBarChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      this.chartOptionsBottomPerfomanceOfKpi.pie = this.getPieChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      this.chartOptionsBottomPerfomanceOfKpi.area = this.getAreaChartOptionsBottomPerfomanceOfKpi(this.bottomPerformingKpiData);
      // Set the chart to default type initially
      this.setChartTypePerfomanceOfKpi('line');
    });
  }
  revirewCycleName: any = '';
  getYtdVsScore() {
    this.revirewCycleName = '';
    if (this.selectedYearReviewCycle == 'Monthly') {
      this.revirewCycleName = 'Month';
    }
    if (this.selectedYearReviewCycle == 'Quarterly') {
      this.revirewCycleName = 'Quarter';
    }
    if (this.selectedYearReviewCycle == 'Semi_Annually') {
      this.revirewCycleName = 'Semi Annual';
    }
    if (this.selectedYearReviewCycle == 'Annually') {
      this.revirewCycleName = 'Annual';
    }
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.fromDateYtdTable,
      name: null,
      type: null,
      userId: id,
      year: this.selectedYearTtdTable,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.ytdScore, request).subscribe((data: any) => {
      this.getYtdReport = [];
      this.quarterlyBarChartData = [];
      this.getYtdReport = data?.data;
      for (let i = 0; i < data?.data.length; i++) {
        this.quarterlyBarChartData.push({
          name: data?.data[i]?.employee?.firstName + ' ' + data?.data[i]?.employee.lastName,
          yearWise: data?.data[i].ytdWise,
          quarterWise: parseFloat(data?.data[i].quarterWise?.toFixed(2))
        });
      }
      this.initChartQuaterlyytdScoreChart();
      if (this.hideQuarterlyTable == false) {
        this.chartOptionsQuaterlyYtdScore.line = this.getLineChartOptionsQuaterlyytdScoreChart(this.quarterlyBarChartData);
        this.chartOptionsQuaterlyYtdScore.bar = this.getBarChartOptionsQuaterlyytdScoreChart(this.quarterlyBarChartData);
        // Set the chart to default type initially
        this.setChartTypeQuaterlyytdScoreChart('bar');
      }
    });
  }
  quaterlyytdScoreChartGraphType: any = '';
  setChartTypeQuaterlyytdScoreChart(type: string) {
    this.quaterlyytdScoreChartGraphType = type;
    this.hideQuarterlyTable = false;
    const dom = document.getElementById('quaterlyytdscorechart') as HTMLDivElement;
    setTimeout(() => {
      this.chartQuaterlyYtdScore = echarts.init(dom);
      if (this.chartQuaterlyYtdScore) {
        this.chartQuaterlyYtdScore.setOption(this.chartOptionsQuaterlyYtdScore[type]);
        if (type == 'line') {
          this.getLineChartOptionsQuaterlyytdScoreChart(this.quarterlyBarChartData);
        }
        if (type == 'bar') {
          this.getBarChartOptionsQuaterlyytdScoreChart(this.quarterlyBarChartData);
        }
      }
      this.mobileResponsiveService.chartResizeFn(this.chartQuaterlyYtdScore);
    }, 800);
  }
  initChartQuaterlyytdScoreChart() {
    // const dom = document.getElementById('quaterlyytdscorechart') as HTMLDivElement;
    // this.chartQuaterlyYtdScore = echarts.init(dom);
    this.setChartTypeQuaterlyytdScoreChart('bar'); // Set default chart type
    // this.mobileResponsiveService.chartResizeFn(this.chartQuaterlyYtdScore);
  }
  getBarChartOptionsQuaterlyytdScoreChart(data: any): echarts.EChartsOption {
    var revirewCycleName = '';
    if (this.selectedYearReviewCycle == 'Monthly') {
      revirewCycleName = 'Month';
    }
    if (this.selectedYearReviewCycle == 'Quarterly') {
      revirewCycleName = 'Quarter';
    }
    if (this.selectedYearReviewCycle == 'Semi_Annually') {
      revirewCycleName = 'Semi Annual';
    }
    if (this.selectedYearReviewCycle == 'Annually') {
      revirewCycleName = 'Annual';
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999
        // formatter: function (params:any) {
        //   return `
        //     <div style="width: 200px; white-space: normal; word-wrap: break-word;">
        //       <span>${params[0].axisValue}</span><br>
        //       ${params.map((item:any) => `${item.seriesName}: ${item.data}`).join('<br>')}
        //     </div>`;
        // },
      },
      legend: { data: [revirewCycleName, 'YTD'], top: 0 },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { name: any }) => ele.name),
        axisLabel: {
          formatter: function (value) {
            return value.length > 3 ? value.slice(0, 2) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      dataZoom: [
        {
          // Add dataZoom here
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: revirewCycleName,
          type: 'bar',
          barWidth: 18,
          data: data.map((ele: { quarterWise: any }) => ele.quarterWise),
          color: this.fisrtDashboardColor,
          label: { show: true, position: 'top', fontSize: 8 }
        },
        {
          name: 'YTD',
          type: 'bar',
          barWidth: 18,
          data: data.map((ele: { yearWise: any }) => ele.yearWise),
          color: this.secondDashboardColor,
          label: { show: true, position: 'top', fontSize: 8 }
        }
      ]
    };
  }
  getLineChartOptionsQuaterlyytdScoreChart(data: any): echarts.EChartsOption {
    var revirewCycleName = '';
    if (this.selectedYearReviewCycle == 'Monthly') {
      revirewCycleName = 'Month';
    }
    if (this.selectedYearReviewCycle == 'Quarterly') {
      revirewCycleName = 'Quarter';
    }
    if (this.selectedYearReviewCycle == 'Semi_Annually') {
      revirewCycleName = 'Semi Annual';
    }
    if (this.selectedYearReviewCycle == 'Annually') {
      revirewCycleName = 'Annual';
    }
    return {
      tooltip: {
        trigger: 'axis',
        z: 999999
        // formatter: function (params:any) {
        //   return `
        //     <div style="width: 200px; white-space: normal; word-wrap: break-word;">
        //       <span>${params[0].axisValue}</span><br>
        //       ${params.map((item:any) => `${item.seriesName}: ${item.data}`).join('<br>')}
        //     </div>`;
        // },
      },
      legend: { data: [revirewCycleName, 'Year wise'], top: 0 },
      xAxis: {
        show: true,
        type: 'category',
        data: data.map((ele: { name: any }) => ele.name),
        axisLabel: {
          formatter: function (value) {
            return value.length > 3 ? value.slice(0, 2) + '...' : value; // Truncate to 4 characters + ...
          }
        }
      },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      dataZoom: [
        {
          // Add dataZoom here
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: revirewCycleName,
          type: 'line',
          data: data.map((ele: { quarterWise: any }) => ele.quarterWise),
          color: this.fisrtDashboardColor,
          label: { show: true, position: 'top', fontSize: 9 }
        },
        {
          name: 'Year wise',
          type: 'line',
          data: data.map((ele: { yearWise: any }) => ele.yearWise),
          color: this.secondDashboardColor,
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getKpiGoalSummary() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.selectedKpiScoreSummaryfromDate,
      name: null,
      type: null,
      userId: this.selectedKpiUser,
      year: this.selectedKpiScoreSummaryYear,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.kpiGoalSummary, request).subscribe((data: any) => {
      this.kpiGoalSummaryData = [];
      var kpiGoalSummaryData = data?.data?.percentageRanges?.sort((a: any, b: any) => a.range.localeCompare(b.range));
      for (let i = 0; i < kpiGoalSummaryData?.length; i++) {
        var range;
        if (data?.data?.percentageRanges[i].range.includes('-')) {
          range = data?.data?.percentageRanges[i].range;
        } else {
          range = '>' + data?.data?.percentageRanges[i].range;
        }
        this.kpiGoalSummaryData.push({
          name: range,
          numberOfEmployees: data?.data?.percentageRanges[i].numberOfEmployees,
          value: data?.data?.percentageRanges[i].percentage
        });
      }
      this.initChart();
      if (this.kpiGoalSummaryData.every((ele: any) => ele.value == 0)) {
        this.kpiGoalSummaryData = [];
      }
      this.chartOptionsKpiSummary.line = this.getLineChartOptions(this.kpiGoalSummaryData);
      this.chartOptionsKpiSummary.bar = this.getBarChartOptions(this.kpiGoalSummaryData);
      this.chartOptionsKpiSummary.pie = this.getPieChartOptions(this.kpiGoalSummaryData);
      this.chartOptionsKpiSummary.area = this.getAreaChartOptions(this.kpiGoalSummaryData);
      // Set the chart to default type initially
      this.setChartType('pie');
    });
  }
  ngAfterViewInit() {
    // this.initChart();
    // this.initChartQuaterlyytdScoreChart();
    // this.initChartTargetvsActual();
    // this.initChartPerfomanceOfKpi();
    // this.initTopTenKpis();
    // this.initChartlastThreeYearKpiScore();
  }
  kpiScoreSummaryGraphType: any = 'pie';
  setChartType(type: string) {
    this.kpiScoreSummaryGraphType = type;
    this.showKpiScoreTableChart = false;
    const dom = document.getElementById('chart') as HTMLDivElement;
    this.chartKpiSummary = echarts.init(dom);
    if (this.chartKpiSummary) {
      this.chartKpiSummary.setOption(this.chartOptionsKpiSummary[type]);
      if (type == 'pie') {
        this.getPieChartOptions(this.kpiGoalSummaryData);
      }
      if (type == 'line') {
        this.getLineChartOptions(this.kpiGoalSummaryData);
      }
      if (type == 'bar') {
        this.getBarChartOptions(this.kpiGoalSummaryData);
      }
      if (type == 'area') {
        this.getAreaChartOptions(this.kpiGoalSummaryData);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartKpiSummary);
  }
  initChart() {
    const dom = document.getElementById('chart') as HTMLDivElement;
    this.chartKpiSummary = echarts.init(dom);
    this.setChartType('pie'); // Set default chart type
    this.mobileResponsiveService.chartResizeFn(this.chartKpiSummary);
  }
  getLineChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          // Type assertion to provide the correct type
          const param = params as unknown as {
            name: string;
            value: number;
            data: { name: string; numberOfEmployees: number; value: number };
          };

          const total = data.reduce((acc: any, item: { value: any }) => acc + item.value, 0);
          const percentage = ((param.value / total) * 100).toFixed(2);

          return `${param.name}: ${param.value}% (${param.data.numberOfEmployees})`;
        }
      },
      legend: { show: false, bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'Score',
          type: 'line',
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: {
            color: function (params: any) {
              const value = params.name; // Get the value of the current bar
              const colors = ['#F42700', '#E4BEA4', '#FBBC3C', '#403684', '#FF8B00', '#32AB4A'];

              // Check if the value is above 90
              if (value == '0-50') {
                return colors[0]; // First color if value is above 90
              }
              if (value == '50-60') {
                return colors[1]; // First color if value is above 90
              }
              if (value == '60-70') {
                return colors[2]; // First color if value is above 90
              }
              if (value == '70-80') {
                return colors[3]; // First color if value is above 90
              }
              if (value == '80-90') {
                return colors[4]; // First color if value is above 90
              }
              if (value == '>90') {
                return colors[5]; // First color if value is above 90
              } else {
                return colors[params.dataIndex % colors.length]; // Cycle through colors otherwise
              }
            }
          },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getBarChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          // If params is an array, use the first item
          const param = Array.isArray(params) ? params[0] : params;

          const index = param.dataIndex; // Access dataIndex from the param

          if (index !== undefined) {
            // Ensure index is defined before accessing data
            const employeeData = data[index];
            const total = data.reduce((acc: number, item: { value: number }) => acc + item.value, 0);
            const percentage = ((employeeData.value / total) * 100).toFixed(2);

            return `${employeeData.name}: ${employeeData.value}% (${employeeData.numberOfEmployees})`;
          } else {
            return 'No data available'; // Fallback in case index is undefined
          }
        }
      },
      legend: { show: false, bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: 20,
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: {
            color: function (params: any) {
              const value = params.name; // Get the value of the current bar
              const colors = ['#F42700', '#E4BEA4', '#FBBC3C', '#403684', '#FF8B00', '#32AB4A'];

              // Check if the value is above 90
              if (value == '0-50') {
                return colors[0]; // First color if value is above 90
              }
              if (value == '50-60') {
                return colors[1]; // First color if value is above 90
              }
              if (value == '60-70') {
                return colors[2]; // First color if value is above 90
              }
              if (value == '70-80') {
                return colors[3]; // First color if value is above 90
              }
              if (value == '80-90') {
                return colors[4]; // First color if value is above 90
              }
              if (value == '>90') {
                return colors[5]; // First color if value is above 90
              } else {
                return colors[params.dataIndex % colors.length]; // Cycle through colors otherwise
              }
            }
          },
          label: { show: false, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          // Type assertion to provide the correct type
          const param = params as unknown as {
            name: string;
            value: number;
            data: { name: string; numberOfEmployees: number; value: number };
          };

          const total = data.reduce((acc: any, item: { value: any }) => acc + item.value, 0);
          const percentage = ((param.value / total) * 100).toFixed(2);

          return `${param.name}: ${param.value}% (${param.data.numberOfEmployees})`;
        }
      },
      legend: {
        bottom: 10
      },
      series: [
        {
          name: 'Range',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'outside', // Place labels outside
            formatter: '{b}: {d}%' // Label format: category and percentage
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 20,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data,
          itemStyle: {
            color: function (params: any) {
              const value = params.name; // Get the value of the current bar
              const colors = ['#F42700', '#E4BEA4', '#FBBC3C', '#403684', '#FF8B00', '#32AB4A'];

              // Check if the value is above 90
              if (value == '0-50') {
                return colors[0]; // First color if value is above 90
              }
              if (value == '50-60') {
                return colors[1]; // First color if value is above 90
              }
              if (value == '60-70') {
                return colors[2]; // First color if value is above 90
              }
              if (value == '70-80') {
                return colors[3]; // First color if value is above 90
              }
              if (value == '80-90') {
                return colors[4]; // First color if value is above 90
              }
              if (value == '>90') {
                return colors[5]; // First color if value is above 90
              } else {
                return colors[params.dataIndex % colors.length]; // Cycle through colors otherwise
              }
            }
          }
        }
      ],
      xAxis: { show: false }, // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          // Type assertion to provide the correct type
          const param = params as unknown as {
            name: string;
            value: number;
            data: { name: string; numberOfEmployees: number; value: number };
          };

          const total = data.reduce((acc: any, item: { value: any }) => acc + item.value, 0);
          const percentage = ((param.value / total) * 100).toFixed(2);

          return `${param.name}: ${param.value}% (${param.data.numberOfEmployees})`;
        }
      },
      grid: { show: false },
      legend: { show: false, bottom: 10 },
      xAxis: { show: true, type: 'category', boundaryGap: false, data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          areaStyle: {},
          name: 'Score',
          type: 'line',
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: {
            color: function (params: any) {
              const value = params.name; // Get the value of the current bar
              const colors = ['#F42700', '#E4BEA4', '#FBBC3C', '#403684', '#FF8B00', '#32AB4A'];

              // Check if the value is above 90
              if (value == '0-50') {
                return colors[0]; // First color if value is above 90
              }
              if (value == '50-60') {
                return colors[1]; // First color if value is above 90
              }
              if (value == '60-70') {
                return colors[2]; // First color if value is above 90
              }
              if (value == '70-80') {
                return colors[3]; // First color if value is above 90
              }
              if (value == '80-90') {
                return colors[4]; // First color if value is above 90
              }
              if (value == '>90') {
                return colors[5]; // First color if value is above 90
              } else {
                return colors[params.dataIndex % colors.length]; // Cycle through colors otherwise
              }
            }
          },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      companyId: this.loggedInUserCompanyID
    };
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request).subscribe(
      (data: any) => {
        this.getTeamList = [];
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          };
          this.getTeamList.push(obj);
        });
        this.getTeamList = this.getTeamList.sort((a: any, b: any) => a.name.localeCompare(b.name));
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
          this.selectedKpiUser = this.loggedInCompanyMDID;
          this.selectedPerformingKpiUser = this.loggedInCompanyMDID;
          this.selectedKpiUserForTargetVsActual = this.loggedInCompanyMDID;
          this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInCompanyMDID;
          this.selectedUserForTopTenKpi = this.loggedInCompanyMDID;
        }
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          this.selectedKpiUser = this.loggedInUserId;
          this.selectedPerformingKpiUser = this.loggedInUserId;
          this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
          this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId;
          this.selectedUserForTopTenKpi = this.loggedInUserId;
        }
        if (this.selectedTypeTabName == 'Dashboard') {
          this.getTargetVsActualUsersList();
          this.getTopPerformingKpiData();
          this.getBottomPerformingKpiData();
          this.getTopTenKpis();
          this.compnayScoreCard();
          this.getYtdVsScore();
          this.getKpiGoalSummary();
          this.lastThreeYearKpiScoreGraph();
        }
      },
      (error: any) => {},
      () => {}
    );
  }
  getTeamOfManager() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      userId: id,
      userType: null
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.getTeamList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          name: ele?.firstName + ' ' + ele?.lastName,
          id: ele?.id
        };
        this.getTeamList.push(obj);
      });
      this.getTeamList = this.getTeamList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedKpiUser = this.loggedInCompanyMDID;
        this.selectedPerformingKpiUser = this.loggedInCompanyMDID;
        this.selectedKpiUserForTargetVsActual = this.loggedInCompanyMDID;
        this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInCompanyMDID;
        this.selectedUserForTopTenKpi = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedKpiUser = this.loggedInUserId;
        this.selectedPerformingKpiUser = this.loggedInUserId;
        this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
        this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId;
        this.selectedUserForTopTenKpi = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Employee') {
        this.selectedKpiUser = this.loggedInUserId;
        this.selectedPerformingKpiUser = this.loggedInUserId;
        this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
        this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId;
        this.selectedUserForTopTenKpi = this.loggedInUserId;
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.getTargetVsActualUsersList();
        this.getTopPerformingKpiData();
        this.getBottomPerformingKpiData();
        this.getTopTenKpis();
        this.compnayScoreCard();
        this.getYtdVsScore();
        this.getKpiGoalSummary();
        this.lastThreeYearKpiScoreGraph();
      }
    });
  }
  chartOptionsForTopTenKpi: any;
  graphsForTopFirstKPIs: any = [];
  graphsForTopSecondKPIs: any = [];
  graphsForTopThirdKPIs: any = [];
  graphsForTopFourthKPIs: any = [];
  getTopTenKpis() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.fromDateForTopTenKpi,
      name: null,
      type: null,
      userId: this.selectedUserForTopTenKpi,
      year: this.selectedYearForTopTenKpi
    };
    this.httpService.callPostService(this.config.topTenKpis, request).subscribe((data: any) => {
      this.graphsForTopFirstKPIs = [];
      this.graphsForTopSecondKPIs = [];
      this.graphsForTopThirdKPIs = [];
      this.graphsForTopFourthKPIs = [];

      if (data?.data?.gsi[0]?.kpi) {
        this.graphsForTopFirstKPIs.push({
          title: data?.data?.gsi[0]?.kpi,
          categories: [this.sharedService.transform(this.fromDateForTopTenKpi), this.sharedService.transformYearToYTDFormat(this.selectedYearForTopTenKpi)],
          actual: [this.sharedService.formatDecimalValue(data?.data?.gsi[0]?.kpiScore), this.sharedService.formatDecimalValue(data?.data?.gsi[0]?.ytdKpiScore)],
          target: [this.sharedService.formatDecimalValue(data?.data?.gsi[0]?.percentageAchievement), this.sharedService.formatDecimalValue(data?.data?.gsi[0]?.ytdPercentageAchievement)]
        });
      }
      if (data?.data?.gsi[1]?.kpi) {
        this.graphsForTopSecondKPIs.push({
          title: data?.data?.gsi[1]?.kpi,
          categories: [this.sharedService.transform(this.fromDateForTopTenKpi), this.sharedService.transformYearToYTDFormat(this.selectedYearForTopTenKpi)],
          actual: [this.sharedService.formatDecimalValue(data?.data?.gsi[1]?.kpiScore), this.sharedService.formatDecimalValue(data?.data?.gsi[1]?.ytdKpiScore)],
          target: [this.sharedService.formatDecimalValue(data?.data?.gsi[1]?.percentageAchievement), this.sharedService.formatDecimalValue(data?.data?.gsi[1]?.ytdPercentageAchievement)]
        });
      }
      if (data?.data?.gsi[2]?.kpi) {
        this.graphsForTopThirdKPIs.push({
          title: data?.data?.gsi[2]?.kpi,
          categories: [this.sharedService.transform(this.fromDateForTopTenKpi), this.sharedService.transformYearToYTDFormat(this.selectedYearForTopTenKpi)],
          actual: [this.sharedService.formatDecimalValue(data?.data?.gsi[2]?.kpiScore), this.sharedService.formatDecimalValue(data?.data?.gsi[2]?.ytdKpiScore)],
          target: [this.sharedService.formatDecimalValue(data?.data?.gsi[2]?.percentageAchievement), this.sharedService.formatDecimalValue(data?.data?.gsi[2]?.ytdPercentageAchievement)]
        });
      }
      if (data?.data?.gsi[3]?.kpi) {
        this.graphsForTopFourthKPIs.push({
          title: data?.data?.gsi[3]?.kpi,
          categories: [this.sharedService.transform(this.fromDateForTopTenKpi), this.sharedService.transformYearToYTDFormat(this.selectedYearForTopTenKpi)],
          actual: [this.sharedService.formatDecimalValue(data?.data?.gsi[3]?.kpiScore), this.sharedService.formatDecimalValue(data?.data?.gsi[3]?.ytdKpiScore)],
          target: [this.sharedService.formatDecimalValue(data?.data?.gsi[3]?.percentageAchievement), this.sharedService.formatDecimalValue(data?.data?.gsi[3]?.ytdPercentageAchievement)]
        });
      }

      this.initTopTenKpis();
      this.chartOptionsTopFirstKpi.line = this.getLineChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
      this.chartOptionsTopSecondKpi.line = this.getLineChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
      this.chartOptionsTopThirdKpi.line = this.getLineChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
      this.chartOptionsTopFourthKpi.line = this.getLineChartOptionsFirstKpi(this.graphsForTopFourthKPIs);

      this.chartOptionsTopFirstKpi.bar = this.getBarChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
      this.chartOptionsTopSecondKpi.bar = this.getBarChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
      this.chartOptionsTopThirdKpi.bar = this.getBarChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
      this.chartOptionsTopFourthKpi.bar = this.getBarChartOptionsFirstKpi(this.graphsForTopFourthKPIs);

      // this.chartOptionsTopTenKpi.pie = this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      // this.chartOptionsTopTenKpi.pie = this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      // this.chartOptionsTopTenKpi.pie = this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);
      // this.chartOptionsTopTenKpi.pie = this.getPieChartOptionsTopPerfomanceOfKpi(this.topPerformingKpiData);

      this.chartOptionsTopFirstKpi.area = this.getAreaChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
      this.chartOptionsTopSecondKpi.area = this.getAreaChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
      this.chartOptionsTopThirdKpi.area = this.getAreaChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
      this.chartOptionsTopFourthKpi.area = this.getAreaChartOptionsFirstKpi(this.graphsForTopFourthKPIs);
      this.setChartTypeTopTenKpis('bar');
    });
  }
  chartTopFirstKpi: echarts.ECharts | undefined;
  chartTopSecondKpi: echarts.ECharts | undefined;
  chartTopThirdKpi: echarts.ECharts | undefined;
  chartTopFourthKpi: echarts.ECharts | undefined;

  chartOptionsTopFirstKpi: any = { line: {}, bar: {}, pie: {}, area: {} };
  chartOptionsTopSecondKpi: any = { line: {}, bar: {}, pie: {}, area: {} };
  chartOptionsTopThirdKpi: any = { line: {}, bar: {}, pie: {}, area: {} };
  chartOptionsTopFourthKpi: any = { line: {}, bar: {}, pie: {}, area: {} };
  topTenKpiChartGraphType: any = 'bar';
  initTopTenKpis() {
    const dom1 = document.getElementById('topOnePerfomanceOfKpi') as HTMLDivElement;
    const dom2 = document.getElementById('topSecondPerfomanceOfKpi') as HTMLDivElement;
    const dom3 = document.getElementById('topthrirdPerfomanceOfKpi') as HTMLDivElement;
    const dom4 = document.getElementById('topFourthPerfomanceOfKpi') as HTMLDivElement;
    this.chartTopFirstKpi = echarts.init(dom1);
    this.chartTopSecondKpi = echarts.init(dom2);
    this.chartTopThirdKpi = echarts.init(dom3);
    this.chartTopFourthKpi = echarts.init(dom4);
    this.setChartTypeTopTenKpis('bar'); // Set default chart type
    this.mobileResponsiveService.chartResizeFn(this.chartTopFirstKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopSecondKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopThirdKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopFourthKpi);
  }
  setChartTypeTopTenKpis(type: string) {
    this.topTenKpiChartGraphType = type;
    this.showTopTenKpiTable = false;
    const dom1 = document.getElementById('topOnePerfomanceOfKpi') as HTMLDivElement;
    const dom2 = document.getElementById('topSecondPerfomanceOfKpi') as HTMLDivElement;
    const dom3 = document.getElementById('topthrirdPerfomanceOfKpi') as HTMLDivElement;
    const dom4 = document.getElementById('topFourthPerfomanceOfKpi') as HTMLDivElement;
    this.chartTopFirstKpi = echarts.init(dom1);
    this.chartTopSecondKpi = echarts.init(dom2);
    this.chartTopThirdKpi = echarts.init(dom3);
    this.chartTopFourthKpi = echarts.init(dom4);

    if (this.chartTopFirstKpi) {
      this.chartTopFirstKpi.setOption(this.chartOptionsTopFirstKpi[type]);
      this.chartTopSecondKpi.setOption(this.chartOptionsTopSecondKpi[type]);
      this.chartTopThirdKpi.setOption(this.chartOptionsTopThirdKpi[type]);
      this.chartTopFourthKpi.setOption(this.chartOptionsTopFourthKpi[type]);

      if (type == 'pie') {
      }
      if (type == 'line') {
        this.getLineChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
        this.getLineChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
        this.getLineChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
        this.getLineChartOptionsFirstKpi(this.graphsForTopFourthKPIs);
      }
      if (type == 'bar') {
        this.getBarChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
        this.getBarChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
        this.getBarChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
        this.getBarChartOptionsFirstKpi(this.graphsForTopFourthKPIs);
      }
      if (type == 'area') {
        this.getAreaChartOptionsFirstKpi(this.graphsForTopFirstKPIs);
        this.getAreaChartOptionsFirstKpi(this.graphsForTopSecondKPIs);
        this.getAreaChartOptionsFirstKpi(this.graphsForTopThirdKPIs);
        this.getAreaChartOptionsFirstKpi(this.graphsForTopFourthKPIs);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartTopFirstKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopSecondKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopThirdKpi);
    this.mobileResponsiveService.chartResizeFn(this.chartTopFourthKpi);
  }
  getLineChartOptionsFirstKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopFirstKpi && this.graphsForTopFirstKPIs.length == 0) {
        this.chartTopFirstKpi.clear();
      }
      if (this.chartTopSecondKpi && this.graphsForTopSecondKPIs.length == 0) {
        this.chartTopSecondKpi.clear();
      }
      if (this.chartTopThirdKpi && this.graphsForTopThirdKPIs.length == 0) {
        this.chartTopThirdKpi.clear();
      }
      if (this.chartTopFourthKpi && this.graphsForTopFourthKPIs.length == 0) {
        this.chartTopFourthKpi.clear();
      }
      return {}; // Return an empty chart option, meaning no chart will be rendered
    }
    return {
      title: { text: data[0]?.title, left: 'left' },
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'category',
        data: [data[0]?.categories[0], data[0]?.categories[1]],
        axisLabel: {
          rotate: 65, // Set to any angle like 45 if space is still tight
          fontSize: 9 // Adjust font size if needed
        }
      },
      xAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: '% Achievement',
          type: 'line',
          data: [data[0]?.target[0], data[0]?.target[1]],
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'right' }
        },
        {
          name: 'KPI Score',
          type: 'line',
          data: [data[0]?.actual[0], data[0]?.actual[1]],
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'right' }
        }
      ]
    };
  }
  getBarChartOptionsFirstKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopFirstKpi && this.graphsForTopFirstKPIs.length == 0) {
        this.chartTopFirstKpi.clear();
      }
      if (this.chartTopSecondKpi && this.graphsForTopSecondKPIs.length == 0) {
        this.chartTopSecondKpi.clear();
      }
      if (this.chartTopThirdKpi && this.graphsForTopThirdKPIs.length == 0) {
        this.chartTopThirdKpi.clear();
      }
      if (this.chartTopFourthKpi && this.graphsForTopFourthKPIs.length == 0) {
        this.chartTopFourthKpi.clear();
      }
      return {}; // Return an empty chart option, meaning no chart will be rendered
    }
    return {
      title: { text: data[0]?.title, left: 'left' },
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'category',
        data: [data[0]?.categories[0], data[0]?.categories[1]],
        axisLabel: {
          rotate: 65, // Set to any angle like 45 if space is still tight
          fontSize: 9 // Adjust font size if needed
        }
      },
      xAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: '% Achievement',
          type: 'bar',
          barWidth: 20,
          data: [data[0]?.target[0], data[0]?.target[1]],
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'right' }
        },
        {
          name: 'KPI Score',
          type: 'bar',
          barWidth: 20,
          data: [data[0]?.actual[0], data[0]?.actual[1]],
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'right' }
        }
      ]
    };
  }
  getAreaChartOptionsFirstKpi(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.chartTopFirstKpi && this.graphsForTopFirstKPIs.length == 0) {
        this.chartTopFirstKpi.clear();
      }
      if (this.chartTopSecondKpi && this.graphsForTopSecondKPIs.length == 0) {
        this.chartTopSecondKpi.clear();
      }
      if (this.chartTopThirdKpi && this.graphsForTopThirdKPIs.length == 0) {
        this.chartTopThirdKpi.clear();
      }
      if (this.chartTopFourthKpi && this.graphsForTopFourthKPIs.length == 0) {
        this.chartTopFourthKpi.clear();
      }
      return {}; // Return an empty chart option, meaning no chart will be rendered
    }
    return {
      title: { text: data[0]?.title, left: 'left' },
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      yAxis: {
        show: true,
        type: 'category',
        boundaryGap: false,
        data: [data[0]?.categories[0], data[0]?.categories[1]],
        axisLabel: {
          rotate: 65, // Set to any angle like 45 if space is still tight
          fontSize: 9 // Adjust font size if needed
        }
      },
      xAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          areaStyle: {},
          name: '% Achievement',
          type: 'line',
          data: [data[0]?.target[0], data[0]?.target[1]],
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'right' }
        },
        {
          areaStyle: {},
          name: 'KPI Score',
          type: 'line',
          data: [data[0]?.actual[0], data[0]?.actual[1]],
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'right' }
        }
      ]
    };
  }
  selectedKpiUserForTargetVsActual: any;
  getTargetVsActualUsersList() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: this.fromDate,
      name: null,
      type: null,
      userId: this.selectedKpiUserForTargetVsActual,
      year: this.selectedYearTargetVsActual
    };
    this.httpService.callPostService(this.config.getKpiUsers, request).subscribe((data: any) => {
      this.kpiUsersList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          kpi: ele?.kpi,
          uom: ele?.uom
        };
        this.kpiUsersList.push(obj);
      });
      if (this.kpiUsersList.length != 0) {
        this.selectedKpi = this.kpiUsersList[0].id;
        this.selectedUom = this.kpiUsersList[0].uom;
        this.getTargetVsActualDetails();
      } else {
        this.selectedKpi = null;
        this.selectedUom = null;
      }
    });
  }
  mileStoneMonth: any = [];
  getTargetVsActualDetails() {
    for (let i = 0; i < this.kpiUsersList?.length; i++) {
      if (this.kpiUsersList[i]?.id == this.selectedKpi) {
        this.selectedUom = this.kpiUsersList[i].uom;
      }
    }
    var formYear = this.selectedYearTargetVsActual?.split('-');
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    const request = {
      from: this.fromDate,
      fromYear: formYear[0],
      goalSettingId: this.selectedKpi,
      search: null,
      to: null,
      toYear: formYear[1],
      userId: id
    };
    this.httpService.callPostService(this.config.targetVsActualApi, request).subscribe((data: any) => {
      this.targetVsActualChartData = [];
      this.mileStoneMonth = [];
      for (let i = 0; i < data?.data?.gsi.length; i++) {
        this.targetVsActualChartData.push({
          month: data?.data?.gsi[i]?.month,
          actual: data?.data?.gsi[i].actual,
          target: data?.data?.gsi[i].target,
          milestoneFrom: data?.data?.gsi[i].milestoneFrom,
          milestoneTo: data?.data?.gsi[i].milestoneTo
        });
      }
      var arrayList = [];
      for (let i = 0; i < data?.data?.gsi.length; i++) {
        if (data?.data?.gsi[i].milestoneFrom != null && data?.data?.gsi[i].milestoneTo != null) {
          arrayList.push(this.sharedService.transform(this.toProperCase(data?.data?.gsi[i].milestoneFrom)) + '-' + this.sharedService.transform(this.toProperCase(data?.data?.gsi[i].milestoneTo)));
        }
      }
      this.mileStoneMonth = [...new Set(arrayList)];
      this.initChartTargetvsActual();
      this.chartOptionsTargetvsActual.line = this.getLineChartOptionsTargetvsActual(this.targetVsActualChartData);
      this.chartOptionsTargetvsActual.bar = this.getBarChartOptionsTargetvsActual(this.targetVsActualChartData);
      this.chartOptionsTargetvsActual.pie = this.getPieChartOptionsTargetvsActual(this.targetVsActualChartData);
      this.chartOptionsTargetvsActual.area = this.getAreaChartOptionsTargetvsActual(this.targetVsActualChartData);
      // Set the chart to default type initially
      this.setChartTypeTargetvsActual('bar');
    });
  }
  targetvsActualGraphType: any = 'bar';
  setChartTypeTargetvsActual(type: string) {
    this.targetvsActualGraphType = type;
    this.showTargetTable = false;
    const dom = document.getElementById('targetvsActual') as HTMLDivElement;
    this.chartTargetvsActual = echarts.init(dom);
    if (this.chartTargetvsActual) {
      this.chartTargetvsActual.setOption(this.chartOptionsTargetvsActual[type]);
      if (type == 'pie') {
        this.getPieChartOptionsTargetvsActual(this.targetVsActualChartData);
      }
      if (type == 'line') {
        this.getLineChartOptionsTargetvsActual(this.targetVsActualChartData);
      }
      if (type == 'bar') {
        this.getBarChartOptionsTargetvsActual(this.targetVsActualChartData);
      }
      if (type == 'area') {
        this.getAreaChartOptionsTargetvsActual(this.targetVsActualChartData);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartTargetvsActual);
  }
  initChartTargetvsActual() {
    const dom = document.getElementById('targetvsActual') as HTMLDivElement;
    this.chartTargetvsActual = echarts.init(dom);
    this.setChartTypeTargetvsActual('bar'); // Set default chart type
    this.mobileResponsiveService.chartResizeFn(this.chartTargetvsActual);
  }
  getLineChartOptionsTargetvsActual(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      dataZoom: [
        {
          // Add dataZoom here
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      legend: { top: 0 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { month: any }) => this.sharedService.transform(ele.month)) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'Target',
          type: 'line',
          data: data.map((ele: { target: any }) => ele.target),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data.map((ele: { actual: any }) => ele.actual),
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getBarChartOptionsTargetvsActual(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      dataZoom: [
        {
          // Add dataZoom here
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      legend: { top: 0 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { month: any }) => this.sharedService.transform(ele.month)) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'Target',
          type: 'bar',
          barWidth: 10,
          data: data.map((ele: { target: any }) => ele.target),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: 10,
          data: data.map((ele: { actual: any }) => ele.actual),
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getPieChartOptionsTargetvsActual(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false }, // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptionsTargetvsActual(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      dataZoom: [
        {
          // Add dataZoom here
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      legend: { top: 0 },
      xAxis: { show: true, type: 'category', boundaryGap: false, data: data.map((ele: { month: any }) => this.sharedService.transform(ele.month)) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          areaStyle: {},
          name: 'Target',
          type: 'line',
          data: data.map((ele: { target: any }) => ele.target),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        },
        {
          areaStyle: {},
          name: 'Actual',
          type: 'line',
          data: data.map((ele: { actual: any }) => ele.actual),
          itemStyle: { color: this.secondDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }

  onClickQuarterlyTable() {
    this.hideQuarterlyTable = true;
    this.showQuarterlyBarChart = false;
    this.showQuarterlyLineChart = false;
    this.quaterlyytdScoreChartGraphType = '';
  }

  onClickKpiScoreTable() {
    this.showKpiScoreBarChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScorePieChart = false;
    this.showKpiScoreTableChart = true;
    this.showKpiScoreLineChart = false;
    this.showKpiScoreAreaChart = false;
    this.kpiScoreSummaryGraphType = '';
  }

  onClickKpiScoreBarChart() {
    this.showKpiScoreBarChart = true;
    this.showKpiScoreLineChart = false;
    this.showKpiScorePieChart = false;
    this.showKpiScoreTableChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScoreAreaChart = false;
    this.getKpiGoalSummary();
  }

  graphType: any;
  onClickKpiScorePieChart(type: any) {
    this.graphType = type;
    this.showKpiScoreBarChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScorePieChart = true;
    this.showKpiScoreTableChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScoreAreaChart = false;
    this.getKpiGoalSummary();
  }

  onClickKpiScoreAreaChart() {
    this.showKpiScoreBarChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScorePieChart = false;
    this.showKpiScoreTableChart = false;
    this.showKpiScoreLineChart = false;
    this.showKpiScoreAreaChart = true;
  }

  onClickTargetTable() {
    this.showTargetPieChart = false;
    this.showTargetBarChart = false;
    this.showTargetLineChart = false;
    this.showTargetTable = true;
    this.targetvsActualGraphType = '';
  }

  onClickKpiTeamList(event: any) {
    this.loggedInUserId = event;
    this.getKpiGoalSummary();
  }

  onClickKpiYear(event: any) {
    this.selectedYear = event;
    this.getKpiGoalSummary();
  }

  onClickKpiMonths(event: any) {
    this.fromDate = event;
    this.getKpiGoalSummary();
  }

  // onClickTargetTeam(event: any) {
  //   this.goalsettingId = event;
  //   this.getTargetVsActualDetails();
  // }

  // onClickTargetKpiUsers(event: any) {
  //   this.loggedInUserId = event;
  //   this.getTargetVsActualDetails();
  // }

  // onClickTargetYear(event: any) {
  //   this.selectedYear = event;
  //   this.getTargetVsActualDetails();
  // }

  // onClickTargetMonth(event: any) {
  //   this.fromDate = event;
  //   this.getTargetVsActualDetails();
  // }

  onClickPeformingTable() {
    this.showPerformingBar = false;
    this.showPerformingLine = false;
    this.showPerformingPie = false;
    this.showPerformingTable = true;
    this.perfomanceOfKpiGraphType = '';
  }

  onClickPerformingKpi(event: any, value: any) {
    if (value == 'User') {
      this.loggedInUserId = event;
    } else if (value == 'Month') {
      this.fromDate = event;
    } else if (value == 'Year') {
      this.selectedYear = event;
    }
    this.getTopPerformingKpiData();
  }

  onClickTopTenKpiTable(value: any) {
    if (value == 'Table') {
      this.showTopTenKpiTable = true;
      this.showTopTenKpiLine = false;
      this.showTopTenKpiPie = false;
      this.showTopTenKpiBar = false;
      this.topTenKpiChartGraphType = '';
    }
  }

  getKPIs() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    const request = {
      search: null,
      userId: id
    };
    this.httpService.callPostService(this.config.getAllKpis, request).subscribe((data: any) => {
      this.kpiList = data?.data?.gsi;
    });
  }

  getPmsSetupData() {
    this.httpService.callGetService(this.config.getPMSSetUpByID + this.loggedInUserCompanyID + '/' + this.fromYear + '/' + this.toYear).subscribe((data: any) => {
      //value select
      if (data?.data?.valueSelect == null) {
        this.valueSelect = 'NA';
      } else {
        this.valueSelect = 'YTD';
      }
      //cut off date
      if (data?.data?.cutoffDate == null) {
        this.cutOffDate = 'NA';
      } else {
        this.cutOffDate = data?.data?.cutoffDate;
      }
      //capselect
      if (data?.data?.capSelect == 'Straight') {
        this.capSelect = 'Straight';
        this.comment = data?.data?.comment;
      } else if (data?.data?.capSelect == null) {
        this.capSelect = 'NA';
      } else if (data?.data?.capSelect == 'Range') {
        this.capSelect = 'Range';
        this.minRange = data?.data?.addScores[0].minRange;
        this.maxRange = data?.data?.addScores[0].maxRange;
      }

      this.addScoreData = [];
      for (let i = 0; i < data?.data?.addScores?.length; i++) {
        this.addScoreData.push({
          minRange: data?.data?.addScores[i].minRange,
          maxRange: data?.data?.addScores[i].maxRange
        });
      }
    });
  }
  chnageSelectedYearTargetVsActual() {
    this.selectedKpiUserForTargetVsActual = null;
    this.targetVsActualChartData = [];
    if (this.loggedInUserRole == 'Employee') {
      this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
    }
    this.selectedKpi = null;
    this.selectedUom = null;
    var year = this.selectedYearTargetVsActual?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }

    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDateByDeptEmptyTargetVSActual();
    } else {
      this.getTeamOfManagerForTargetVSActual();
    }
    // this.getMonths(this.fromYear, this.toYear)
  }
  chnagePerformingKpiYear() {
    this.selectedPerformingKpifromDate = null;
    this.selectedPerformingKpiUser = null;
    this.selectedUserForlastThreeYearKpiScoreKpi = null;
    var year = this.selectedPerformingKpiYear?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  chnageSelectYearForTopTenKpi() {
    this.fromDateForTopTenKpi = null;
    var year = this.selectedYearForTopTenKpi?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getTeamOfManagerForTopFourKPI();
  }
  getLength(data: any) {}
  targetApprovedMonthsList: any = [];
  targetApprovedMonths() {
    const request = {
      from: this.fromDate,
      fromYear: this.fromYear,
      goalSettingId: null,
      search: null,
      to: this.toDate,
      toYear: this.toYear,
      userId: this.selectedUserForKPISearch
    };
    this.httpService.callPostService(this.config.targetApprovedMonths, request).subscribe((data: any) => {
      this.targetApprovedMonthsList = [];
      data.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: this.sharedService.transform(ele)
        };
        this.targetApprovedMonthsList.push(obj);
      });
    });
  }
  addNewSystemUnlock(operation: any, id: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      operation: operation,
      id: id,
      addNewUnlockSystemCurrentYear: this.addNewUnlockSystemCurrentYear
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(PmsSystemUnlockPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.searchPmsUnlockStatusOfCompany();
    });
  }
  deletePmsUnlockStatus(id: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete these record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.deletePmsUnlockStatus, { isDeleted: true, id: [id] }).subscribe(
          (res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: res.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.searchPmsUnlockStatusOfCompany();
            });
          },
          (err: any) => {
            this.loader.dismissLoader();
            console.log(err);
          }
        );
      }
    });
  }
  pmsUnlockStatusList: any = [];
  pageOfRelock: any = 0;
  currentPageNumberOfPmsUnlockStatus: any = 1;
  totalPagesOfPmsUnlockStatus: any = 0;
  totalPmsUnlockStatus: any = 0;
  searchPmsUnlockStatusOfCompany() {
    var test = this.selectedYearForUnlockStatus?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      search: null,
      toYear: test[1]
    };
    this.httpService.callPostService(this.config.searchPmsUnlockStatusOfCompany + '?page=' + this.pageOfRelock, request).subscribe((data: any) => {
      this.pmsUnlockStatusList = data?.data?.pmsUnlockStatus;
      this.totalPagesOfPmsUnlockStatus = data?.data?.totalPages;
      this.totalPmsUnlockStatus = data?.data?.total;
      this.currentPageNumberOfPmsUnlockStatus = data?.data?.currentPageNumber + 1;
      this.paginationCountDataPmsUnlockStatus();
    });
  }
  previousPagePmsUnlockStatus() {
    if (this.currentPageNumberOfPmsUnlockStatus < 2) {
      return;
    } else {
      this.currentPageNumberOfPmsUnlockStatus--;
      this.pageOfRelock--;
      this.searchPmsUnlockStatusOfCompany();
    }
  }
  nextPagePmsUnlockStatus() {
    if (this.currentPageNumberOfPmsUnlockStatus >= this.totalPagesOfPmsUnlockStatus) {
      return;
    }
    if (this.currentPageNumberOfPmsUnlockStatus == 1) {
      this.pageOfRelock = 1;
    } else {
      this.pageOfRelock++;
    }
    this.currentPageNumberOfPmsUnlockStatus++;
    this.searchPmsUnlockStatusOfCompany();
  }
  showingCountPmsUnlockStatus: any = 1;
  showingOfCountPmsUnlockStatus: any = 0;
  previousPageTotalCountPmsUnlockStatus: any = 0;
  addNewUnlockSystemCurrentYear: any;

  paginationCountDataPmsUnlockStatus() {
    if (this.previousPageTotalCountPmsUnlockStatus != this.totalPmsUnlockStatus) {
      this.showingCountPmsUnlockStatus = 1;
      this.showingOfCountPmsUnlockStatus = 0;
    }
    if (this.currentPageNumberOfPmsUnlockStatus - 1 == 0) {
      this.showingCountPmsUnlockStatus = 1;
      this.showingOfCountPmsUnlockStatus = 0;
    }
    if (this.totalPmsUnlockStatus >= this.pmsUnlockStatusList.length) {
      if (25 == this.pmsUnlockStatusList.length) {
        this.showingOfCountPmsUnlockStatus = (this.currentPageNumberOfKpis - 1 + 1) * 25;
      } else {
        this.showingOfCountPmsUnlockStatus = this.showingOfCountPmsUnlockStatus + this.pmsUnlockStatusList.length;
      }
      this.previousPageTotalCountPmsUnlockStatus = this.totalPmsUnlockStatus;
    }
    if (this.currentPageNumberOfPmsUnlockStatus - 1 == 0) {
      this.showingCountPmsUnlockStatus = 1;
    } else {
      this.showingCountPmsUnlockStatus = 25 * (this.currentPageNumberOfPmsUnlockStatus - 1) + 1;
    }
  }
  getPMSYearForUnlock() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: ''
    };
    this.httpService.callPostService(this.config.getPmsYears, request).subscribe((data: any) => {
      this.pmsYearsForUnlockStatus = [];
      data?.data?.access?.forEach((ele: any) => {
        let obj = {
          year: ele.fromYear + '-' + ele.toYear
        };
        if (ele.fromYear != null && ele.toYear != null) {
          this.pmsYearsForUnlockStatus.push(obj);
        }
      });
      this.pmsYearsForUnlockStatus?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYearForUnlockStatus = ele?.year;
          this.addNewUnlockSystemCurrentYear = ele?.year;
        }
      });
      this.searchPmsUnlockStatusOfCompany();
    });
  }
  pmsUnlockStatusListByUser: any = [];
  getPmsUnlockSetupForUser() {
    const request = {
      fromYear: this.fromYear,
      toYear: this.toYear,
      userId: this.selectedUserForKPISearch
    };
    this.httpService.callPostService(this.config.getPmsUnlockSetupForUser, request).subscribe((data: any) => {
      this.pmsUnlockStatusListByUser = data?.data?.pmsUnlockStatus;
    });
  }
  lastThreeYearDataForGraphKpi: any = [];
  lastThreeYearKpiScoreGraph() {
    if (this.loggedInUserRole == 'Employee') {
      this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      month: null,
      name: null,
      type: null,
      userId: this.selectedUserForlastThreeYearKpiScoreKpi,
      year: this.selectedlastThreeYearKpiScoreKpiYear
    };
    this.httpService.callPostService(this.config.lastThreeYearKpiScoreGraph, request).subscribe((data: any) => {
      var year = this.selectedlastThreeYearKpiScoreKpiYear?.split('-');
      var lastThreeYearRange = this.getLastThreeYearRanges(year[0]);
      this.lastThreeYearDataForGraphKpi = [
        {
          name: lastThreeYearRange[0],
          value: data?.data?.lastYearScore
        },
        {
          name: lastThreeYearRange[1],
          value: data?.data?.lastToLastYearScore
        },
        {
          name: lastThreeYearRange[2],
          value: data?.data?.yearBeforeLastToLastYearScore
        }
      ];
      this.initChartlastThreeYearKpiScore();
      this.chartOptionslastThreeYearKpiScore.line = this.getLineChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      this.chartOptionslastThreeYearKpiScore.bar = this.getBarChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      this.chartOptionslastThreeYearKpiScore.pie = this.getPieChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      this.chartOptionslastThreeYearKpiScore.area = this.getAreaChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      // Set the chart to default type initially
      this.setChartTypelastThreeYearKpiScore('bar');
    });
  }
  lastThreeYearKpiScoreGraphType: any = 'bar';
  showlastThreeYearKpiScoreTable: boolean = false;
  onClicklastThreeYearKpiScoreTable() {
    this.showlastThreeYearKpiScoreTable = true;
    this.lastThreeYearKpiScoreGraphType = '';
  }
  lastThreeYearKpiScoreChartGraphType: any = 'bar';
  setChartTypelastThreeYearKpiScore(type: string) {
    this.lastThreeYearKpiScoreGraphType = type;
    this.showlastThreeYearKpiScoreTable = false;
    const dom = document.getElementById('lastThreeYearKpiScore') as HTMLDivElement;
    this.lastThreeYearKpiScore = echarts.init(dom);
    if (this.lastThreeYearKpiScore) {
      this.lastThreeYearKpiScore.setOption(this.chartOptionslastThreeYearKpiScore[type]);
      if (type == 'line') {
        this.getLineChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      }
      if (type == 'bar') {
        this.getBarChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      }
      if (type == 'pie') {
        this.getPieChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      }
      if (type == 'area') {
        this.getAreaChartOptionslastThreeYearKpiScore(this.lastThreeYearDataForGraphKpi);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.lastThreeYearKpiScore);
  }
  initChartlastThreeYearKpiScore() {
    const dom = document.getElementById('lastThreeYearKpiScore') as HTMLDivElement;
    this.lastThreeYearKpiScore = echarts.init(dom);
    this.setChartTypelastThreeYearKpiScore('line'); // Set default chart type
    this.mobileResponsiveService.chartResizeFn(this.lastThreeYearKpiScore);
  }
  getLineChartOptionslastThreeYearKpiScore(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'KPI Score',
          type: 'line',
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getBarChartOptionslastThreeYearKpiScore(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          name: 'KPI Score',
          type: 'bar',
          barWidth: 20,
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getPieChartOptionslastThreeYearKpiScore(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        bottom: 10
      },
      series: [
        {
          name: 'Range',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false }, // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptionslastThreeYearKpiScore(data: any): echarts.EChartsOption {
    return {
      grid: { show: false },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', boundaryGap: false, data: data.map((ele: { name: any }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [
        {
          areaStyle: {},
          name: 'KPI Score',
          type: 'line',
          data: data.map((ele: { value: any }) => ele.value),
          itemStyle: { color: this.fisrtDashboardColor },
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ]
    };
  }
  getLastThreeYearRanges(startYear: any): string[] {
    const ranges: string[] = [];
    if (this.loggedInCompanyFiscalyear == 'Jan_Dec') {
      for (let i = 0; i < 3; i++) {
        const year = Number(startYear) - 1 - i;
        ranges.push(`${year}`);
      }
    } else {
      for (let i = 0; i < 3; i++) {
        const year = Number(startYear) - 1 - i;
        ranges.push(`FY ${year}-${(year + 1)?.toString()?.slice(-2)}`);
      }
    }
    return ranges;
  }
  checkLengthOfField(string: any) {
    if (string.length > 254) {
      this.toastr.warning('The text cannot exceed 255 characters.', '', {
        timeOut: 3000
      });
    }
  }
  addDottedManagerComment(data: any) {
    const request = {
      from: data?.fullMonthName,
      fromYear: this.fromYear,
      dottedManagerComment: data?.dottedManagerComment,
      to: data?.fullMonthName,
      toYear: this.toYear,
      userId: this.selectedUserForKPISearch
    };
    this.httpService.callPostService(this.config.addDottedManagerComment, request).subscribe((result: any) => {
      this.getKPIsByDateRange();
    });
  }
  getManagerOfTeam() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: this.fromDate,
      fromYear: this.fromYear,
      to: this.toDate,
      toYear: this.toYear,
      userId: this.loggedInUserId,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerList.push(obj);
      });
      this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.submiForReportPreview();
    });
  }
  getFormattedString(data: any): string {
    return data?.length > 10 ? data.substring(0, 10) + '...' : data;
  }
  changeMonthOfPerformingKpi() {
    this.selectedPerformingKpiUser = null;
    this.bottomPerformingKpiData = [];
    this.topPerformingKpiData = [];
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDateByDeptEmptyPerformingKpi();
    } else {
      this.getTeamOfManagerForPerformingKPI();
    }
  }
  changeMonthOfTopTenKpi() {
    this.selectedUserForTopTenKpi = null;
    this.graphsForTopFirstKPIs = [];
    this.graphsForTopSecondKPIs = [];
    this.graphsForTopThirdKPIs = [];
    this.graphsForTopFourthKPIs = [];
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDateByDeptEmptyTopTenKpis();
    } else {
      this.getTeamOfManagerForTopFourKPI();
    }
  }
  transFormMileStoneMonth(month: any) {
    if (month == '') {
      return null;
    } else {
      var month = month?.split('-');
      var showData;
      if (month[0] && month[1]) {
        showData = this.sharedService.transform(month[0]?.charAt(0)?.toUpperCase() + month[0]?.slice(1)?.toLowerCase()) + '-' + this.sharedService.transform(month[1]?.charAt(0)?.toUpperCase() + month[1]?.slice(1)?.toLowerCase());
      } else {
        showData = this.sharedService.transform(month[0]?.charAt(0)?.toUpperCase() + month[0]?.slice(1)?.toLowerCase());
      }
      return showData;
    }
  }
  teamOfManagerListForKPISummary: any = [];
  teamOfManagerListForTargetVSActual: any = [];
  teamOfManagerListForPreviousThreeYearData: any = [];
  teamOfManagerListForPerformingKPI: any = [];
  teamOfManagerListForTopFourKPI: any = [];
  getTeamOfManagerForKPISummary() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    var year = this.selectedKpiScoreSummaryYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: this.selectedKpiScoreSummaryfromDate,
      fromYear: year[0],
      to: this.selectedKpiScoreSummaryfromDate,
      toYear: year[1],
      userId: id,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForKPISummary = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForKPISummary.push(obj);
      });
      this.teamOfManagerListForKPISummary = this.teamOfManagerListForKPISummary.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedKpiUser = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedKpiUser = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Admin') {
        if (this.teamOfManagerListForKPISummary.length != 0) {
          this.selectedKpiUser = this.teamOfManagerListForKPISummary[0].id;
        }
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.getKpiGoalSummary();
      }
    });
  }
  getTeamOfManagerForTargetVSActual() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    var year = this.selectedYearTargetVsActual?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: null,
      fromYear: year[0],
      to: null,
      toYear: year[1],
      userId: id,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForTargetVSActual = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTargetVSActual.push(obj);
      });
      this.teamOfManagerListForTargetVSActual = this.teamOfManagerListForTargetVSActual.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedKpiUserForTargetVsActual = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedKpiUserForTargetVsActual = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Admin') {
        if (this.teamOfManagerListForTargetVSActual.length != 0) {
          this.selectedKpiUserForTargetVsActual = this.teamOfManagerListForTargetVSActual[0].id;
        }
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.getTargetVsActualUsersList();
      }
    });
  }
  changegetTeamOfManagerForPreviousThreeYearData() {
    if (this.loggedInUserRole == 'Admin') {
      this.getEmpsOfAdminByDateByDeptEmptylastThreeYearKpiScoreKpiYear();
    } else {
      this.getTeamOfManagerForPreviousThreeYearData();
    }
  }
  getTeamOfManagerForPreviousThreeYearData() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }

    var year = this.selectedlastThreeYearKpiScoreKpiYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: null,
      fromYear: year[0],
      to: null,
      toYear: year[1],
      userId: id,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForPreviousThreeYearData = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPreviousThreeYearData.push(obj);
      });
      this.teamOfManagerListForPreviousThreeYearData = this.teamOfManagerListForPreviousThreeYearData.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Admin') {
        if (this.teamOfManagerListForPreviousThreeYearData.length != 0) {
          this.selectedUserForlastThreeYearKpiScoreKpi = this.teamOfManagerListForPreviousThreeYearData[0].id;
        }
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.lastThreeYearKpiScoreGraph();
      }
    });
  }
  getTeamOfManagerForPerformingKPI() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    var year = this.selectedPerformingKpiYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: this.selectedPerformingKpifromDate,
      fromYear: year[0],
      to: this.selectedPerformingKpifromDate,
      toYear: year[1],
      userId: id,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForPerformingKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPerformingKPI.push(obj);
      });
      this.teamOfManagerListForPerformingKPI = this.teamOfManagerListForPerformingKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedPerformingKpiUser = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedPerformingKpiUser = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Admin') {
        if (this.teamOfManagerListForPerformingKPI.length != 0) {
          this.selectedPerformingKpiUser = this.teamOfManagerListForKPISummary[0].id;
        }
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.getTopPerformingKpiData();
        this.getBottomPerformingKpiData();
      }
    });
  }
  getTeamOfManagerForTopFourKPI() {
    var id;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }
    var year = this.selectedPerformingKpiYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      from: this.fromDateForTopTenKpi,
      fromYear: year[0],
      to: this.fromDateForTopTenKpi,
      toYear: year[1],
      userId: id,
      userType: null,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForTopFourKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTopFourKPI.push(obj);
      });
      this.teamOfManagerListForTopFourKPI = this.teamOfManagerListForTopFourKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
        this.selectedUserForTopTenKpi = this.loggedInCompanyMDID;
      }
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        this.selectedUserForTopTenKpi = this.loggedInUserId;
      }
      if (this.loggedInUserRole == 'Admin') {
        if (this.teamOfManagerListForTopFourKPI.length != 0) {
          this.selectedUserForTopTenKpi = this.teamOfManagerListForKPISummary[0].id;
        }
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.getTopTenKpis();
      }
    });
  }
  getDeptsOfAdminByDate() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: this.fromDate,
      fromYear: this.fromYear,
      moduleName: 'PMS',
      to: this.toDate,
      toYear: this.toYear,
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getDeptsOfAdminByDate, request).subscribe((data: any) => {
      this.deptListOfCompany = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.deptListOfCompany.push(obj);
      });
      this.deptListOfCompany = this.deptListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.deptListOfCompany.length != 0) {
        this.selectedDeptForKPISearch = [];
        this.selectedDeptForKPISearch.push(this.deptListOfCompany[0]);
        this.getEmpsOfAdminByDate();
      }
    });
  }
  getEmpsOfAdminByDate() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: this.selectedDeptForKPISearch?.map((ele: { id: any }) => ele.id),
      from: this.fromDate,
      fromYear: this.fromYear,
      moduleName: 'PMS',
      to: this.toDate,
      toYear: this.toYear,
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerList.push(obj);
      });
      this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerList.length != 0) {
        this.selectedUserForKPISearch = this.teamOfManagerList[0]?.id;
        this.getPmsUnlockSetupForUser();
        if (this.selectedTypeTabName == 'Employee Goals') {
          this.getKPIsByDateRange();
        }
      }
    });
  }
  getEmpsOfAdminByDateByDeptEmpty() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: this.fromDate,
      fromYear: this.fromYear,
      moduleName: 'PMS',
      to: this.toDate,
      toYear: this.toYear,
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForTargetVSActual = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTargetVSActual.push(obj);
      });
      this.teamOfManagerListForKPISummary = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForKPISummary.push(obj);
      });
      this.teamOfManagerListForKPISummary = this.teamOfManagerListForKPISummary.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.teamOfManagerListForPerformingKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPerformingKPI.push(obj);
      });
      this.teamOfManagerListForPerformingKPI = this.teamOfManagerListForPerformingKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.teamOfManagerListForPreviousThreeYearData = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPreviousThreeYearData.push(obj);
      });
      this.teamOfManagerListForPreviousThreeYearData = this.teamOfManagerListForPreviousThreeYearData.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.teamOfManagerListForTopFourKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTopFourKPI.push(obj);
      });
      this.teamOfManagerListForTopFourKPI = this.teamOfManagerListForTopFourKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForTargetVSActual.length != 0) {
        this.selectedKpiUserForTargetVsActual = this.teamOfManagerListForTargetVSActual[0]?.id;
        this.selectedKpiUser = this.teamOfManagerListForTargetVSActual[0]?.id;
        this.selectedPerformingKpiUser = this.teamOfManagerListForTargetVSActual[0]?.id;
        this.selectedUserForlastThreeYearKpiScoreKpi = this.teamOfManagerListForTargetVSActual[0]?.id;
        this.selectedUserForTopTenKpi = this.teamOfManagerListForTargetVSActual[0]?.id;
      } else {
        this.selectedKpiUser = null;
        this.selectedPerformingKpiUser = null;
        this.selectedKpiUserForTargetVsActual = null;
        this.selectedUserForlastThreeYearKpiScoreKpi = null;
        this.selectedUserForTopTenKpi = null;
      }

      this.getTargetVsActualUsersList();
      this.getTopPerformingKpiData();
      this.getBottomPerformingKpiData();
      this.getTopTenKpis();
      this.compnayScoreCard();
      this.getYtdVsScore();
      this.getKpiGoalSummary();
      this.lastThreeYearKpiScoreGraph();
    });
  }
  getEmpsOfAdminByDateByDeptEmptyKPISummary() {
    var year = this.selectedKpiScoreSummaryYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: this.selectedKpiScoreSummaryfromDate,
      fromYear: year[0],
      moduleName: 'PMS',
      to: this.selectedKpiScoreSummaryfromDate,
      toYear: year[1],
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForKPISummary = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForKPISummary.push(obj);
      });
      this.teamOfManagerListForKPISummary = this.teamOfManagerListForKPISummary.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForKPISummary.length != 0) {
        this.selectedKpiUser = this.teamOfManagerListForKPISummary[0]?.id;
      } else {
        this.selectedKpiUser = null;
      }
      this.getKpiGoalSummary();
    });
  }
  getEmpsOfAdminByDateByDeptEmptyTargetVSActual() {
    var year = this.selectedYearTargetVsActual?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: null,
      fromYear: year[0],
      moduleName: 'PMS',
      to: null,
      toYear: year[1],
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForTargetVSActual = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTargetVSActual.push(obj);
      });
      this.teamOfManagerListForTargetVSActual = this.teamOfManagerListForTargetVSActual.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForTargetVSActual.length != 0) {
        this.selectedKpiUserForTargetVsActual = this.teamOfManagerListForTargetVSActual[0]?.id;
      } else {
        this.selectedKpiUserForTargetVsActual = null;
      }
      this.getTargetVsActualUsersList();
    });
  }
  getEmpsOfAdminByDateByDeptEmptylastThreeYearKpiScoreKpiYear() {
    var year = this.selectedlastThreeYearKpiScoreKpiYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: null,
      fromYear: year[0],
      moduleName: 'PMS',
      to: null,
      toYear: year[1],
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForPreviousThreeYearData = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPreviousThreeYearData.push(obj);
      });
      this.teamOfManagerListForPreviousThreeYearData = this.teamOfManagerListForPreviousThreeYearData.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForPreviousThreeYearData.length != 0) {
        this.selectedUserForlastThreeYearKpiScoreKpi = this.teamOfManagerListForPreviousThreeYearData[0]?.id;
      } else {
        this.selectedUserForlastThreeYearKpiScoreKpi = null;
      }
      this.lastThreeYearKpiScoreGraph();
    });
  }
  getEmpsOfAdminByDateByDeptEmptyPerformingKpi() {
    var year = this.selectedPerformingKpiYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: this.selectedPerformingKpifromDate,
      fromYear: year[0],
      moduleName: 'PMS',
      to: this.selectedPerformingKpifromDate,
      toYear: year[1],
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForPerformingKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForPerformingKPI.push(obj);
      });
      this.teamOfManagerListForPerformingKPI = this.teamOfManagerListForPerformingKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForPerformingKPI.length != 0) {
        this.selectedPerformingKpiUser = this.teamOfManagerListForPerformingKPI[0]?.id;
      } else {
        this.selectedPerformingKpiUser = null;
      }
      this.getTopPerformingKpiData();
      this.getBottomPerformingKpiData();
    });
  }
  getEmpsOfAdminByDateByDeptEmptyTopTenKpis() {
    var year = this.selectedYearForTopTenKpi?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      depts: [],
      from: this.fromDateForTopTenKpi,
      fromYear: year[0],
      moduleName: 'PMS',
      to: this.fromDateForTopTenKpi,
      toYear: year[1],
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getEmpsOfAdminByDate, request).subscribe((data: any) => {
      this.teamOfManagerListForTopFourKPI = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        };
        this.teamOfManagerListForTopFourKPI.push(obj);
      });
      this.teamOfManagerListForTopFourKPI = this.teamOfManagerListForTopFourKPI.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (this.teamOfManagerListForTopFourKPI.length != 0) {
        this.selectedUserForTopTenKpi = this.teamOfManagerListForTopFourKPI[0]?.id;
      } else {
        this.selectedUserForTopTenKpi = null;
      }
      this.getTopTenKpis();
    });
  }
  onClickVerifyByCFT() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to verify?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var year = this.selectedYear?.split('-');
        const request = {
          from: this.fromDate,
          fromYear: year[0],
          to: this.toDate,
          toYear: year[1],
          userId: this.selectedUserForKPISearch
        };
        this.httpService.callPostService(this.config.verifyByCftMember, request).subscribe((data: any) => {
          if (data?.data) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            this.getCftVerification();
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
          }
        });
      }
    });
  }
  cftApprovedMonths: any = [];
  cftMemberName: any;
  cftVerificationDate: any;
  allCFTMonthsVerified: boolean = false;
  getCftVerification() {
    var year = this.selectedYear?.split('-');
    const request = {
      from: this.fromDate,
      fromYear: year[0],
      to: this.toDate,
      toYear: year[1],
      userId: this.selectedUserForKPISearch
    };
    this.httpService.callPostService(this.config.getCftVerification, request).subscribe((data: any) => {
      this.cftApprovedMonths = data?.data;
      let loggedInUserApprovedMonths = [];
      for (let i = 0; i < data?.data?.length; i++) {
        if (this.loggedInUserId == data?.data[i]?.cftMemberId) {
          loggedInUserApprovedMonths.push(data?.data[i]);
        }
      }
      this.allCFTMonthsVerified = false;
      const index1 = this.getToMonthsByFiscalandReviewCycle.indexOf(this.toDate);
      var slicedArray: any = [];
      if (index1 !== -1) {
        slicedArray = this.getToMonthsByFiscalandReviewCycle.slice(0, index1 + 1); // Slice from index1 to the end
      }
      if (loggedInUserApprovedMonths.length != 0) {
        this.allCFTMonthsVerified = loggedInUserApprovedMonths.every((item1: any) => slicedArray.every((item2: any) => item1.month === item2));
      }
    });
  }

  misPriview(event: any, filename: any) {
    console.log(event, filename);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '90%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '100%' : '80%';
    // dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container'; // Only set this class once
    dialogConfig.data = {
      msiAttached: event,
      filename: filename
    };

    const dialogRef = this.dialog.open(MisAttachmentViewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
  }
  downloadFiles(url: any, fileName: any) {
    // console.log(url,fileName);

    // saveAs(url[0], fileName);
    this.misPriview(url, fileName);
  }
  pmsDashboardGraphDownloadReviewCycleVsYTD() {
    const title = this.sharedService.transform(`${this.loggedInCompanyReviewCycle} vs YTD Score`);
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearTtdTable);
    const month = this.sharedService.transform(this.fromDateYtdTable);

    this.pdfDownload.PMSGraphPDFDownload(
      'quaterlyytdscorechart', // chartId
      'quaterlyytdscorechartTable', // tableId
      title, // Title
      year, // Year
      month, // Month
      null, // Employee name
      null, // Kpi
      null
    );
    // var id;
    // var reportType;
    // if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
    //   || this.loggedInUserRole == 'HR Admin') {
    //   id= this.loggedInCompanyMDID;
    // }else{
    //   id = this.loggedInUserId
    // }
    // if(this.hideQuarterlyTable){
    //   reportType = 'Table'
    // }else{
    //   if(this.quaterlyytdScoreChartGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.quaterlyytdScoreChartGraphType == 'line'){
    //     reportType ='Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "fromYear": this.selectedYearTtdTable,
    //   "loggedInUserRole": this.loggedInUserRole,
    //   "month": this.fromDateYtdTable,
    //   "reportName": 'ReviewCycleVsYtd',
    //   "reportType": reportType,
    //   "userId": id,
    //   "name": null,
    //   "type": null
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  pmsDashboardGraphDownloadKPIScoreSummary() {
    let selectedEmployee: any;
    if (this.loggedInUserRole != 'Employee') {
      if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') && this.loggedInCompanyMDID != null) {
        if (this.selectedKpiUser == this.loggedInCompanyMDID) {
          selectedEmployee = 'My Chart';
        } else {
          const getEmp = this.teamOfManagerListForKPISummary.find((emp: any) => emp.id === this.selectedKpiUser);
          selectedEmployee = getEmp?.name;
        }
      } else if (this.loggedInUserRole == 'Manager' || (this.loggedInUserRole == 'HOD' && this.loggedInCompanyMDID == null)) {
        selectedEmployee = 'My Chart';
      } else {
        const getEmp = this.teamOfManagerListForKPISummary.find((emp: any) => emp.id === this.selectedKpiUser);
        selectedEmployee = getEmp?.name ? getEmp?.name : 'My Chart';
      }
    }
    const year = this.sharedService.transformYearToFyFormat(this.selectedKpiScoreSummaryYear);
    const month = this.sharedService.transform(this.selectedKpiScoreSummaryfromDate);

    this.pdfDownload.PMSGraphPDFDownload(
      'chart', // chartId
      'KPIScoreSummaryTable', // tableId
      'KPI Score Summary', // Title
      year, // Year
      month, // Month
      selectedEmployee, // Employee name
      null, // Kpi
      null
    );

    // var reportType;
    // if(this.showKpiScoreTableChart){
    //   reportType = 'Table'
    // }else{
    //   if(this.kpiScoreSummaryGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.kpiScoreSummaryGraphType == 'pie'){
    //     reportType ='Donut Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": this.selectedKpiScoreSummaryfromDate,
    //   "reportName": 'KPIScoreSummary',
    //   "reportType": reportType,
    //   "userId": this.selectedKpiUser,
    //   "fromYear": this.selectedKpiScoreSummaryYear,
    //   "loggedInUserRole": this.loggedInUserRole,
    //   "name": null,
    //   "type": null
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  pmsDashboardGraphDownloadTargetVsActual() {
    let selectedEmployee: any;
    if (this.loggedInUserRole != 'Employee') {
      if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') && this.loggedInCompanyMDID != null) {
        if (this.selectedKpiUserForTargetVsActual == this.loggedInCompanyMDID) {
          selectedEmployee = 'My Chart';
        } else {
          const getEmp = this.teamOfManagerListForTargetVSActual.find((emp: any) => emp.id === this.selectedKpiUserForTargetVsActual);
          selectedEmployee = getEmp?.name;
        }
      } else if (this.loggedInUserRole == 'Manager' || (this.loggedInUserRole == 'HOD' && this.loggedInCompanyMDID == null)) {
        selectedEmployee = 'My Chart';
      } else {
        const getEmp = this.teamOfManagerListForTargetVSActual.find((emp: any) => emp.id === this.selectedKpiUserForTargetVsActual);
        selectedEmployee = getEmp?.name ? getEmp?.name : 'My Chart';
      }
    }
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearTargetVsActual);
    const selectKpi = this.kpiUsersList.find((emp: any) => emp.id === this.selectedKpi) || null;

    this.pdfDownload.PMSGraphPDFDownload(
      'targetvsActual', // chartId
      'targetVsActualTable', // tableId
      'Target vs Actual', // Title
      year, // Year
      null, // Month
      selectedEmployee, // Employee name
      selectKpi?.kpi ? selectKpi?.kpi : null, // Kpi
      this.selectedUom ? this.selectedUom : null //selectedUom
    );

    // var reportType;
    // if(this.showTargetTable){
    //   reportType = 'Table'
    // }else{
    //   if(this.targetvsActualGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.targetvsActualGraphType == 'line'){
    //     reportType ='Line Graph'
    //   }
    //   if(this.targetvsActualGraphType == 'area'){
    //     reportType ='Area Graph'
    //   }
    // }
    // var id;
    // if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
    //   || this.loggedInUserRole == 'HR Admin') {
    //   id= this.loggedInCompanyMDID;
    // }else{
    //   id = this.loggedInUserId
    // }
    // var formYear = this.selectedYearTargetVsActual?.split('-');
    // const request = {
    //   "from": this.fromDate,
    //   "fromYear": formYear[0],
    //   "goalSettingId": this.selectedKpi,
    //   "search": null,
    //   "to": null,
    //   "toYear": formYear[1],
    //   "userId": id,
    //   "reportName": 'TargetVsActual',
    //   "reportType": reportType,
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": this.fromDate,
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  pmsDashboardGraphDownloadPrevious3YearsData() {
    let selectedEmployee: any;
    if (this.loggedInUserRole != 'Employee') {
      if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') && this.loggedInCompanyMDID != null) {
        if (this.selectedUserForlastThreeYearKpiScoreKpi == this.loggedInCompanyMDID) {
          selectedEmployee = 'My Chart';
        } else {
          const getEmp = this.teamOfManagerListForPreviousThreeYearData.find((emp: any) => emp.id === this.selectedUserForlastThreeYearKpiScoreKpi);
          selectedEmployee = getEmp?.name;
        }
      } else if (this.loggedInUserRole == 'Manager' || (this.loggedInUserRole == 'HOD' && this.loggedInCompanyMDID == null)) {
        selectedEmployee = 'My Chart';
      } else {
        const getEmp = this.teamOfManagerListForPreviousThreeYearData.find((emp: any) => emp.id === this.selectedUserForlastThreeYearKpiScoreKpi);
        selectedEmployee = getEmp?.name ? getEmp?.name : 'My Chart';
      }
    }
    const year = this.sharedService.transformYearToFyFormat(this.selectedlastThreeYearKpiScoreKpiYear);

    this.pdfDownload.PMSGraphPDFDownload(
      'lastThreeYearKpiScore', // chartId
      'lastThreeYearKpiScoreTable', // tableId
      'Previous 3 Years Data', // Title
      year, // Year
      null, // Month
      selectedEmployee, // Employee name
      null, // Kpi
      null //selectedUom
    );

    // var reportType;
    // if(this.showlastThreeYearKpiScoreTable){
    //   reportType = 'Table'
    // }else{
    //   if(this.lastThreeYearKpiScoreGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.lastThreeYearKpiScoreGraphType == 'line'){
    //     reportType ='Line Graph'
    //   }
    //   if(this.lastThreeYearKpiScoreGraphType == 'area'){
    //     reportType ='Area Graph'
    //   }
    //   if(this.lastThreeYearKpiScoreGraphType == 'pie'){
    //     reportType ='Donut Graph'
    //   }
    // }
    // if(this.loggedInUserRole == 'Employee'){
    //   this.selectedUserForlastThreeYearKpiScoreKpi = this.loggedInUserId
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": null,
    //   "name": null,
    //   "type": null,
    //   "userId": this.selectedUserForlastThreeYearKpiScoreKpi,
    //   "fromYear": this.selectedlastThreeYearKpiScoreKpiYear,
    //   "reportName": 'Previous3YearsData',
    //   "reportType": reportType,
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  pmsDashboardGraphDownloadScoreTrend(id: any) {
    // var reportType = 'Table';
    // var loggedUser = 'LoggedUser';
    // var id;
    // if(this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee'){
    //   id = this.loggedInUserId
    // }
    // if(this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
    //   || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD'){
    //   id= this.loggedInCompanyMDID
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": null,
    //   "name": null,
    //   "type": loggedUser,
    //   "userId": id,
    //   "fromYear": this.selectedYearForCompanyScoreTrend,
    //   "loggedInUserRole": this.loggedInUserRole,
    //   "reportName": 'ScoreTrend',
    //   "reportType": reportType,
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
    this.loader.simpleLoader();
    setTimeout(() => {
      const tableId = id;
      const table = document.getElementById(tableId) as HTMLTableElement;
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
      if (!table) {
        alert('Table not found!');
        return;
      }
      const clonedTable = table.cloneNode(true) as HTMLTableElement;
      const viewReportColIndex = Array.from(clonedTable.rows[0].cells).findIndex(cell => cell.textContent?.includes('View Report'));
      Array.from(clonedTable.rows).forEach(row => {
        if (viewReportColIndex !== -1) {
          row.deleteCell(viewReportColIndex);
        }
      });
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(clonedTable);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `Score Trend_${formattedDate}.xlsx`);
      this.loader.dismissLoader();
    }, 1000);
  }
  pmsDashboardGraphDownloadTopAndBottomPerformingKPIs() {
    let selectedEmployee: any;
    if (this.loggedInUserRole != 'Employee') {
      if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') && this.loggedInCompanyMDID != null) {
        if (this.selectedPerformingKpiUser == this.loggedInCompanyMDID) {
          selectedEmployee = 'My Chart';
        } else {
          const getEmp = this.teamOfManagerListForPerformingKPI.find((emp: any) => emp.id === this.selectedPerformingKpiUser);
          selectedEmployee = getEmp?.name;
        }
      } else if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
        selectedEmployee = 'My Chart';
      } else {
        const getEmp = this.teamOfManagerListForPerformingKPI.find((emp: any) => emp.id === this.selectedPerformingKpiUser);
        selectedEmployee = getEmp?.name;
      }
    }
    const year = this.sharedService.transformYearToFyFormat(this.selectedPerformingKpiYear);
    const month = this.sharedService.transform(this.selectedPerformingKpifromDate);

    this.pdfDownload.PMSGraphPDFDownload(
      'showPerformingGraph', // chartId
      null, // tableId
      'Performing KPIs', // Title
      null, // Year
      null, // Month
      null, // Employee name
      null, // Kpi
      null
    );
    // var reportType;
    // if(this.showPerformingTable){
    //   reportType = 'Table'
    // }else{
    //   if(this.perfomanceOfKpiGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.perfomanceOfKpiGraphType == 'line'){
    //     reportType ='Line Graph'
    //   }
    //   if(this.perfomanceOfKpiGraphType == 'area'){
    //     reportType ='Area Graph'
    //   }
    //   if(this.perfomanceOfKpiGraphType == 'pie'){
    //     reportType ='Donut Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": this.selectedPerformingKpifromDate,
    //   "name": null,
    //   "type": null,
    //   "userId": this.selectedPerformingKpiUser,
    //   "fromYear": this.selectedPerformingKpiYear,
    //   "reportName": 'TopAndBottomPerformingKPIs',
    //   "reportType": reportType,
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {
    //   if(data?.data!=null){
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  pmsDashboardGraphDownloadTop4KPIsBasisWeightage() {
    if (this.topTenKpiChartGraphType == 'bar' || this.topTenKpiChartGraphType == 'line' || this.topTenKpiChartGraphType == 'area' || this.topTenKpiChartGraphType == 'pie') {
      let selectedEmployee: any;
      if (this.loggedInUserRole != 'Employee') {
        if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') && this.loggedInCompanyMDID != null) {
          if (this.selectedUserForTopTenKpi === this.loggedInCompanyMDID) {
            selectedEmployee = 'My Chart';
          } else {
            const getEmp = this.teamOfManagerListForTopFourKPI.find((emp: any) => emp.id === this.selectedUserForTopTenKpi);
            selectedEmployee = getEmp?.name;
          }
        } else if (this.loggedInUserRole == 'Manager' || (this.loggedInUserRole == 'HOD' && this.loggedInCompanyMDID == null)) {
          selectedEmployee = 'My Chart';
        } else {
          const getEmp = this.teamOfManagerListForTopFourKPI.find((emp: any) => emp.id === this.selectedUserForTopTenKpi);
          selectedEmployee = getEmp?.name ? getEmp?.name : 'My Chart';
        }
      }

      const year = this.sharedService.transformYearToFyFormat(this.selectedYearForTopTenKpi);
      const month = this.sharedService.transform(this.fromDateForTopTenKpi);

      this.pdfDownload.PMSGraphPDFDownload(
        'top4KPIsBasisWeightageGraph', // chartId
        null, // tableId
        'Top 4 KPIs Basis Weightage', // Title
        year, // Year
        month, // Month
        selectedEmployee, // Employee name
        null, // Kpi
        null //selectedUom
      );
    } else {
      const request = {
        companyId: this.loggedInUserCompanyID,
        month: this.fromDateForTopTenKpi,
        name: null,
        type: null,
        userId: this.selectedUserForTopTenKpi,
        fromYear: this.selectedYearForTopTenKpi,
        reportName: 'Top4KPIsBasisWeightage',
        reportType: 'Table'
      };
      this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL);
          saveAs(data?.data, fileName[1]);
        }
      });
    }
  }
  gloablDashboardDownload() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyMDID;
    } else {
      id = this.loggedInUserId;
    }

    var reportTypeQuarterlyTable;
    var reportTypekpiScoreSummary;
    var reportTypetargetvsActual;
    var reportTypelastThreeYearKpiScore;
    var reportTypeperfomanceOfKpi;
    var reportTypetopTenKpiChart;
    if (this.hideQuarterlyTable) {
      reportTypeQuarterlyTable = 'Table';
    } else {
      if (this.quaterlyytdScoreChartGraphType == 'bar') {
        reportTypeQuarterlyTable = 'Bar Graph';
      }
      if (this.quaterlyytdScoreChartGraphType == 'line') {
        reportTypeQuarterlyTable = 'Line Graph';
      }
    }
    if (this.showKpiScoreTableChart) {
      reportTypekpiScoreSummary = 'Table';
    } else {
      if (this.kpiScoreSummaryGraphType == 'bar') {
        reportTypekpiScoreSummary = 'Bar Graph';
      }
      if (this.kpiScoreSummaryGraphType == 'pie') {
        reportTypekpiScoreSummary = 'Donut Graph';
      }
    }

    if (this.showTargetTable) {
      reportTypetargetvsActual = 'Table';
    } else {
      if (this.targetvsActualGraphType == 'bar') {
        reportTypetargetvsActual = 'Bar Graph';
      }
      if (this.targetvsActualGraphType == 'line') {
        reportTypetargetvsActual = 'Line Graph';
      }
      if (this.targetvsActualGraphType == 'area') {
        reportTypetargetvsActual = 'Area Graph';
      }
    }

    if (this.showlastThreeYearKpiScoreTable) {
      reportTypelastThreeYearKpiScore = 'Table';
    } else {
      if (this.lastThreeYearKpiScoreGraphType == 'bar') {
        reportTypelastThreeYearKpiScore = 'Bar Graph';
      }
      if (this.lastThreeYearKpiScoreGraphType == 'line') {
        reportTypelastThreeYearKpiScore = 'Line Graph';
      }
      if (this.lastThreeYearKpiScoreGraphType == 'area') {
        reportTypelastThreeYearKpiScore = 'Area Graph';
      }
      if (this.lastThreeYearKpiScoreGraphType == 'pie') {
        reportTypelastThreeYearKpiScore = 'Donut Graph';
      }
    }
    if (this.showPerformingTable) {
      reportTypeperfomanceOfKpi = 'Table';
    } else {
      if (this.perfomanceOfKpiGraphType == 'bar') {
        reportTypeperfomanceOfKpi = 'Bar Graph';
      }
      if (this.perfomanceOfKpiGraphType == 'line') {
        reportTypeperfomanceOfKpi = 'Line Graph';
      }
      if (this.perfomanceOfKpiGraphType == 'area') {
        reportTypeperfomanceOfKpi = 'Area Graph';
      }
      if (this.perfomanceOfKpiGraphType == 'pie') {
        reportTypeperfomanceOfKpi = 'Donut Graph';
      }
    }

    if (this.showTopTenKpiTable) {
      reportTypetopTenKpiChart = 'Table';
    } else {
      if (this.topTenKpiChartGraphType == 'bar') {
        reportTypetopTenKpiChart = 'Bar Graph';
      }
      if (this.topTenKpiChartGraphType == 'line') {
        reportTypetopTenKpiChart = 'Line Graph';
      }
      if (this.topTenKpiChartGraphType == 'area') {
        reportTypetopTenKpiChart = 'Area Graph';
      }
      if (this.topTenKpiChartGraphType == 'pie') {
        reportTypetopTenKpiChart = 'Donut Graph';
      }
    }
    var loggedUser = '';
    if (this.showMangerTable) {
      loggedUser = 'LoggedUser';
    }
    var ScoreTrendUserId;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      ScoreTrendUserId = this.loggedInUserId;
    }
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      ScoreTrendUserId = this.loggedInCompanyMDID;
    }
    var formYear = this.selectedYearTargetVsActual?.split('-');
    const request = {
      dashboardCountReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: this.fromDateGloabalDashboard,
        name: null,
        search: null,
        type: null,
        userId: id,
        year: this.selectedYear
      },
      kpiScoreSummaryReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: this.selectedKpiScoreSummaryfromDate,
        name: null,
        search: null,
        type: null,
        userId: this.selectedKpiUser,
        year: this.selectedKpiScoreSummaryYear
      },
      performingKpisReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: this.selectedPerformingKpifromDate,
        name: null,
        search: null,
        type: null,
        userId: this.selectedPerformingKpiUser,
        year: this.selectedPerformingKpiYear
      },
      pmsCycle: this.fromDateGloabalDashboard,
      previous3YearsReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: null,
        name: null,
        search: null,
        type: null,
        userId: this.selectedUserForlastThreeYearKpiScoreKpi,
        year: this.selectedlastThreeYearKpiScoreKpiYear
      },
      reportNameTypeMap: {
        ReviewCycleVsYtd: reportTypeQuarterlyTable,
        KPIScoreSummary: reportTypekpiScoreSummary,
        TargetVsActual: reportTypetargetvsActual,
        Previous3YearsData: reportTypelastThreeYearKpiScore,
        ScoreTrend: 'Table',
        TopAndBottomPerformingKPIs: reportTypeperfomanceOfKpi,
        Top4KPIsBasisWeightage: reportTypetopTenKpiChart
      },
      reviewCycleVsYtdReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: this.fromDateYtdTable,
        name: null,
        search: null,
        type: null,
        userId: id,
        year: this.selectedYearTtdTable
      },
      scoreTrendReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: null,
        name: null,
        search: null,
        type: loggedUser,
        userId: ScoreTrendUserId,
        year: this.selectedYearForCompanyScoreTrend
      },
      targetVsActualReq: {
        from: this.fromDate,
        fromYear: formYear[0],
        goalSettingId: this.selectedKpi,
        search: null,
        to: null,
        toYear: formYear[1],
        userId: id
      },
      top4KPIsWeightageReq: {
        companyId: this.loggedInUserCompanyID,
        loggedInUserRole: this.loggedInUserRole,
        month: this.fromDateForTopTenKpi,
        name: null,
        search: null,
        type: null,
        userId: this.selectedUserForTopTenKpi,
        year: this.selectedYearForTopTenKpi
      },
      year: this.selectedYear
    };
    this.httpService.callPostService(this.config.gloablDashboardDownload, request).subscribe((data: any) => {
      if (data?.data != null) {
        var fileName = data?.data?.split(environment.downloadURL);
        saveAs(data?.data, fileName[1]);
      }
    });
  }
  currentPageReport: any = 1;
  pageReport: any = 0;
  totalNoOfPagesReport: any = 0;

  totalCountOfReport: any = 0;
  previousPageReport() {
    if (this.currentPageReport < 1) {
      return;
    } else {
      this.currentPageReport--;
      this.pageReport--;
      this.submiForReportPreview();
    }
  }
  nextPageReport() {
    if (this.currentPageReport >= this.totalNoOfPagesReport) {
      return;
    }
    if (this.currentPageReport == 1) {
      this.pageReport = 1;
    } else {
      this.pageReport++;
    }
    this.currentPageReport++;
    this.submiForReportPreview();
  }
}
